// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelectorAll('.ep-songlib__mobile-filter-group-header').forEach(button => {
//     button.addEventListener('click', function() {
//       const heading = this.querySelector('h4');
//       heading.classList.toggle('active');
//     });
//   });
// });

// (() => {
//  //console.log('🎵 Music section script starting...');
 
//  // Find the ep-songlib section by section ID
//  // Get section ID from the section element's data attribute
//  const sectionElement = document.querySelector('.ep-songlib[data-section-id]');
//  const sectionId = sectionElement ? sectionElement.getAttribute('data-section-id') : null;
//  let root = document.querySelector(`[data-section-id="${sectionId}"]`);
//  //console.log('🎵 Root element found:', root);
//  //console.log('🎵 Section ID:', sectionId);
 
//  if (!root) {
//  console.warn('❌ No .ep-songlib root element found with section ID:', sectionId);
//  // Fallback: try to find any ep-songlib section
//  const fallbackRoot = document.querySelector('.ep-songlib');
//  if (fallbackRoot) {
//  //console.log('🎵 Using fallback root element:', fallbackRoot);
//  root = fallbackRoot;
//  } else {
//  console.warn('❌ No fallback .ep-songlib element found either');
//  return;
//  }
//  }

 
 
//  const trackItems = root.querySelectorAll('.track-list-item');
//  //console.log('🎵 Found track items:', trackItems.length);
 
//  // Search functionality - integrated with filters
//  const searchInput = root.querySelector('#song-search');
 
//  // ===== FILTERING SYSTEM =====
//  let activeFilters = {
//    genre: [],
//    bpm: [],
//    mood: [],
//    key: [],
//    vocal: [],
//    tags: [],
//    theme: [],
//    price: [],
//    length: [],
//    feature: ['newest'] // Feature filter: trending, latest, newest, downloads (single selection)
//  };
//  let filterChangeTriggered = false; // Track if filters changed (not just search)

//  // Filter categories are now handled below with toggle buttons

// // Function to update URL with sort parameter
// function updateURLWithSort(sortValue) {
//   if (!sortValue) return;
 
//   const url = new URL(window.location.href);
 
//   // Map our sort values to URL parameters
//   // Use 'sort_by' for Shopify compatibility, or 'sort' as fallback
//   if (sortValue === 'newest' || sortValue === 'latest') {
//     url.searchParams.set('sort_by', 'created-descending');
//   }
//   // Trending - commented out
//   // else if (sortValue === 'trending') {
//   //   url.searchParams.set('sort_by', 'trending');
//   // }
//   // Top Downloads - commented out
//   // else if (sortValue === 'downloads') {
//   //   url.searchParams.set('sort_by', 'downloads');
//   // }
//   else if (sortValue === 'alphabetical') {
//     url.searchParams.set('sort_by', 'title-ascending');
//   }
 
//   // Also set our custom sort parameter for internal use
//   url.searchParams.set('sort', sortValue);
 
//   // Update URL without page reload
//   window.history.pushState({ sort: sortValue }, '', url.toString());
// }

// // Function to read sort from URL on page load
// function getSortFromURL() {
//   const urlParams = new URLSearchParams(window.location.search);
 
//   // First check for our custom 'sort' parameter
//   const customSort = urlParams.get('sort');
//   // Removed 'trending' and 'downloads' from valid sort options
//   if (customSort && ['newest', 'latest', 'alphabetical'].includes(customSort)) {
//     return customSort;
//   }
 
//   // Then check for Shopify's 'sort_by' parameter
//   const shopifySort = urlParams.get('sort_by');
//   if (shopifySort === 'created-descending') {
//     return 'newest'; // Default to newest for created-descending
//   }
//   // Trending - commented out
//   // else if (shopifySort === 'trending') {
//   //   return 'trending';
//   // }
//   // Top Downloads - commented out
//   // else if (shopifySort === 'downloads') {
//   //   return 'downloads';
//   // }
//   else if (shopifySort === 'title-ascending') {
//     return 'alphabetical';
//   }
 
//   return null; // No sort in URL
// }

// // Sort dropdown toggle - handle both desktop and mobile
// const sortDropdowns = root.querySelectorAll('.ep-songlib__sort');
// const updateAllSortLabels = () => {
//   const currentFeature = activeFilters.feature && activeFilters.feature.length > 0
//     ? activeFilters.feature[0]
//     : 'newest';
 
//   // Update desktop sort dropdown labels
//   sortDropdowns.forEach(sortDropdown => {
//     const sortBtn = sortDropdown.querySelector('.ep-songlib__sort-btn');
//     const activeOption = sortDropdown.querySelector(`.ep-songlib__sort-option[data-filter-value="${currentFeature}"]`);
//     const sortLabel = sortBtn?.querySelector('.ep-songlib__sort-label');
//     if (sortLabel && activeOption) {
//       sortLabel.textContent = `Sort by ${activeOption.textContent}`;
//     }
//   });
 
//   // Update mobile sort heading
//   const mobileSortHeading = root.querySelector('.ep-songlib__mobile-sort-heading');
//   const mobileActiveChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"][data-filter-value="${currentFeature}"]`);
//   if (mobileSortHeading && mobileActiveChip) {
//     mobileSortHeading.textContent = `Sort by ${mobileActiveChip.textContent}`;
//   }
// };

// sortDropdowns.forEach(sortDropdown => {
//   const sortBtn = sortDropdown.querySelector('.ep-songlib__sort-btn');
//   const sortMenu = sortDropdown.querySelector('.ep-songlib__sort-menu');
 
//   if (sortBtn && sortMenu) {
//     sortBtn.addEventListener('click', (e) => {
//       e.stopPropagation();
//       const isActive = sortDropdown.classList.contains('active');
//       // Close all other sort dropdowns
//       sortDropdowns.forEach(sd => sd.classList.remove('active'));
//       sortDropdown.classList.toggle('active', !isActive);
//     });

//     // Sort option selection - updates filter system
//     const sortOptions = sortDropdown.querySelectorAll('.ep-songlib__sort-option');
   
//     sortOptions.forEach(option => {
//       option.addEventListener('click', (e) => {
//         e.stopPropagation();
//         const filterType = option.dataset.filterType;
//         const filterValue = option.dataset.filterValue;
       
//         if (filterType && filterValue) {
//           // Update activeFilters
//           activeFilters[filterType] = [filterValue];
         
//           // Update URL with sort parameter
//           updateURLWithSort(filterValue);
         
//           // Update active state in all sort dropdowns
//           sortDropdowns.forEach(sd => {
//             const sdOptions = sd.querySelectorAll('.ep-songlib__sort-option');
//             sdOptions.forEach(o => o.classList.remove('active'));
//             const matchingOption = sd.querySelector(`.ep-songlib__sort-option[data-filter-value="${filterValue}"]`);
//             if (matchingOption) {
//               matchingOption.classList.add('active');
//             }
//           });
         
//           // Update all sort labels
//           updateAllSortLabels();
         
//           // Sync with mobile feature filter chips
//           const allMobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
//           allMobileFeatureChips.forEach(c => c.classList.remove('active'));
//           const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);
//           if (mobileChip) {
//             mobileChip.classList.add('active');
//           }
         
//           // Close all sort dropdowns
//           sortDropdowns.forEach(sd => sd.classList.remove('active'));
         
//           // Apply filters immediately
//           filterChangeTriggered = true;
//           applyFilters();
//           filterChangeTriggered = false;
//         }
//       });
//     });
//   }
// });

// // Initialize sort from URL on page load
// const urlSort = getSortFromURL();
// if (urlSort) {
//   // Set the sort from URL
//   activeFilters.feature = [urlSort];
 
//   // Update UI to reflect URL sort
//   const sortOptions = root.querySelectorAll('.ep-songlib__sort-option');
//   sortOptions.forEach(o => o.classList.remove('active'));
//   const sortOption = root.querySelector(`.ep-songlib__sort-option[data-filter-value="${urlSort}"]`);
//   if (sortOption) {
//     sortOption.classList.add('active');
//   }
 
//   // Update mobile chips
//   const mobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
//   mobileFeatureChips.forEach(c => c.classList.remove('active'));
//   const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"][data-filter-value="${urlSort}"]`);
//   if (mobileChip) {
//     mobileChip.classList.add('active');
//   }
 
//   // Update desktop chips
//   const desktopFeatureChips = root.querySelectorAll(`.ep-songlib__filter-chip[data-filter-type="feature"]`);
//   desktopFeatureChips.forEach(c => c.classList.remove('active'));
//   const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="feature"][data-filter-value="${urlSort}"]`);
//   if (desktopChip) {
//     desktopChip.classList.add('active');
//   }
// }

// // Set initial labels for all sort dropdowns
// updateAllSortLabels();

// // Handle browser back/forward buttons to restore sort from URL
// window.addEventListener('popstate', (e) => {
//   const urlSort = getSortFromURL();
//   if (urlSort) {
//     activeFilters.feature = [urlSort];
//     // Update UI and apply filters
//     const sortOptions = root.querySelectorAll('.ep-songlib__sort-option');
//     sortOptions.forEach(o => o.classList.remove('active'));
//     const sortOption = root.querySelector(`.ep-songlib__sort-option[data-filter-value="${urlSort}"]`);
//     if (sortOption) {
//       sortOption.classList.add('active');
//     }
//     updateAllSortLabels();
//     applyFilters();
//   }
// });

//  // Close dropdowns when clicking outside
//  document.addEventListener('click', (e) => {
//    if (!e.target.closest('.ep-songlib__filter-category') && !e.target.closest('.ep-songlib__sort')) {
//      filterCategories.forEach(c => c.classList.remove('active'));
//      sortDropdowns.forEach(sd => sd.classList.remove('active'));
//    }
//  });

//  // Filter category toggle buttons
//  const filterCategories = root.querySelectorAll('.ep-songlib__filter-category');
//  filterCategories.forEach(category => {
//    const categoryBtn = category.querySelector('.ep-songlib__filter-category-btn');
//    if (categoryBtn) {
//      categoryBtn.addEventListener('click', (e) => {
//        e.stopPropagation();
//        const isActive = category.classList.contains('active');
//        filterCategories.forEach(c => c.classList.remove('active'));
//        category.classList.toggle('active', !isActive);
//      });
//    }
//  });

// // Helper function to check if we're on desktop
// function isDesktop() {
//   return window.innerWidth >= 1025;
// }

// // Filter chip button handlers
// const filterChips = root.querySelectorAll('.ep-songlib__filter-chip');
// filterChips.forEach(chip => {
//   chip.addEventListener('click', (e) => {
//     e.stopPropagation();
//     const filterType = chip.dataset.filterType;
//     const value = chip.dataset.filterValue;
   
//     if (!filterType || !value) {
//       console.warn('⚠️ Filter chip missing filterType or value:', { filterType, value });
//       return;
//     }
   
//     const isActive = chip.classList.contains('active');
   
//     // Feature filter is single-selection (only one option active at a time)
//     if (filterType === 'feature') {
//       if (!isActive) {
//         // Remove active state from all feature chips
//         const allFeatureChips = root.querySelectorAll(`.ep-songlib__filter-chip[data-filter-type="feature"]`);
//         allFeatureChips.forEach(c => c.classList.remove('active'));
       
//         // Remove active state from all mobile feature chips
//         const allMobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
//         allMobileFeatureChips.forEach(c => c.classList.remove('active'));
       
//         // Set the clicked chip as active
//         chip.classList.add('active');
//         activeFilters[filterType] = [value];
       
//         // Update URL with sort parameter
//         updateURLWithSort(value);
       
//         // Sync with sort dropdown
//         const sortOptions = root.querySelectorAll('.ep-songlib__sort-option');
//         sortOptions.forEach(o => o.classList.remove('active'));
//         const sortOption = root.querySelector(`.ep-songlib__sort-option[data-filter-value="${value}"]`);
//         if (sortOption) {
//           sortOption.classList.add('active');
//           const sortLabel = root.querySelector('.ep-songlib__sort-label');
//           if (sortLabel) {
//             sortLabel.textContent = `Sort by ${sortOption.textContent}`;
//           }
//         }
       
//         // Sync with mobile chip
//         const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//         if (mobileChip) {
//           mobileChip.classList.add('active');
//         }
//       }
//       // If clicking the same feature option, don't deselect it (always keep one selected)
//     } else {
//       // Multi-selection for other filters
//       if (isActive) {
//         chip.classList.remove('active');
//         activeFilters[filterType] = activeFilters[filterType].filter(v => v !== value);
//       } else {
//         chip.classList.add('active');
//         if (!activeFilters[filterType].includes(value)) {
//           activeFilters[filterType].push(value);
//         }
//       }
     
//       // Sync with mobile chips if they exist
//       const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//       if (mobileChip) {
//         if (chip.classList.contains('active')) {
//           mobileChip.classList.add('active');
//         } else {
//           mobileChip.classList.remove('active');
//         }
//       }
//     }
   
//     //console.log('🔍 Filter changed:', {
//     //   filterType: filterType,
//     //   value: value,
//     //   activeFilters: activeFilters[filterType],
//     //   isActive: !isActive
//     // });
   
//     updateMobileFilterTitle();
   
//     // Only apply filters immediately on mobile; on desktop wait for "Show Results" button
//     if (!isDesktop()) {
//       filterChangeTriggered = true; // Mark that filters changed
//       updateFilterChips();
//       applyFilters();
//       filterChangeTriggered = false; // Reset flag
//     } else {
//       // On desktop, just update the filter chips display but don't apply filters yet
//       updateFilterChips();
//       updateDesktopActionButtons();
//     }
//   });
// });

// // Function to update mobile filter title with count (defined early for use in updateFilterChips)
// function updateMobileFilterTitle() {
//   const titleElement = root.querySelector('#mobile-filters-title');
//   if (!titleElement) return;
 
//   // Count only user-selected filters, excluding 'feature' which is a sort option
//   const totalActive = Object.keys(activeFilters)
//     .filter(key => key !== 'feature') // Exclude feature filter from count
//     .reduce((sum, key) => sum + activeFilters[key].length, 0);
 
//   if (totalActive > 0) {
//     titleElement.textContent = `Filters (${totalActive})`;
//   } else {
//     titleElement.textContent = 'Filters';
//   }
// }

// // Function to update desktop action buttons visibility
// function updateDesktopActionButtons() {
//   if (!isDesktop()) return;
 
//   const desktopActions = root.querySelector('.ep-songlib__desktop-actions');
//   if (!desktopActions) return;
 
//   // Check if there are any active filters
//   const totalActive = Object.values(activeFilters).reduce((sum, arr) => sum + arr.length, 0);
//   // Check if search input has value
//   const searchValue = searchInput ? searchInput.value.trim() : '';
//   const hasFilters = totalActive > 0 || searchValue.length > 0;
 
//   if (hasFilters) {
//     desktopActions.classList.add('has-filters');
//   } else {
//     desktopActions.classList.remove('has-filters');
//   }
// }

// // Update filter chips
// function updateFilterChips() {
//   // Update mobile filter title
//   updateMobileFilterTitle();
//    const chipsContainer = root.querySelector('#filter-chips');
//    if (!chipsContainer) return;
   
//    chipsContainer.innerHTML = '';
   
//    let hasChips = false;
//    Object.keys(activeFilters).forEach(filterType => {
//      activeFilters[filterType].forEach(value => {
//        // Skip feature filter in chips display (it's a sort option, not a removable filter)
//        if (filterType === 'feature') return;
       
//        hasChips = true;
//        const chip = document.createElement('div');
//        chip.className = 'ep-songlib__filter-chip';
//        chip.dataset.filterType = filterType;
//        chip.dataset.value = value;
       
//       const label = filterType === 'genre' ? value :
//                    filterType === 'bpm' ? `${value} BPM` :
//                    filterType === 'vocal' ? value :
//                    filterType === 'mood' ? value :
//                    filterType === 'key' ? value :
//                    filterType === 'theme' ? value :
//                    filterType === 'length' ? (value === 'short' ? 'Under 1:30' : value === 'medium' ? '1:30 - 2:30' : 'Over 2:30') :
//                    filterType === 'price' ? (value === 'below-1000' ? 'Below Rs. 1000' : value === '1000-1500' ? 'Rs. 1000 - Rs. 1500' : value === 'above-1500' ? 'Above Rs. 1500' : value) :
//                    value;
       
//       chip.innerHTML = `
//         <span style="white-space: nowrap; display: inline-block;">${label}</span>
//         <button class="ep-songlib__filter-chip-remove" type="button" aria-label="Remove filter">
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
//             <path d="M18 6L6 18M6 6l12 12"/>
//           </svg>
//         </button>
//       `;
       
//        const removeBtn = chip.querySelector('.ep-songlib__filter-chip-remove');
//        removeBtn.addEventListener('click', () => {
//          activeFilters[filterType] = activeFilters[filterType].filter(v => v !== value);
         
//          // Remove active state from filter chip button
//          const filterChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//          if (filterChip) filterChip.classList.remove('active');
         
//          // Sync with mobile checkboxes if they exist
//          const mobileCheckbox = root.querySelector(`.ep-songlib__mobile-filter-option input[data-filter-type="${filterType}"][value="${value}"]`);
//          if (mobileCheckbox) mobileCheckbox.checked = false;
         
//          // Only apply filters immediately on mobile; on desktop wait for "Show Results" button
//          if (!isDesktop()) {
//            filterChangeTriggered = true; // Mark that filters changed
//            updateFilterChips();
//            applyFilters();
//            filterChangeTriggered = false; // Reset flag
//          } else {
//            // On desktop, just update the filter chips display but don't apply filters yet
//            updateFilterChips();
//            updateDesktopActionButtons();
//          }
//        });
       
//        chipsContainer.appendChild(chip);
//      });
//    });
   
//    if (hasChips) {
//      chipsContainer.classList.add('has-chips');
//    } else {
//      chipsContainer.classList.remove('has-chips');
//    }
//  }

//  // Sort products based on sort type
//  function sortProducts(products, sortType) {
//    if (!sortType) {
//      return products; // Return as-is if no sort type
//    }
   
//    // Create a copy of the array to avoid mutating the original
//    const sortedProducts = [...products];
   
//    switch(sortType) {
//      case 'newest':
//      case 'latest':
//        // Sort by created_at timestamp (newest/latest first = descending order)
//        sortedProducts.sort((a, b) => {
//          const dateA = parseInt(a.dataset.createdAt || '0', 10);
//          const dateB = parseInt(b.dataset.createdAt || '0', 10);
//          // Descending order: newest/latest first (larger timestamp first)
//          return dateB - dateA;
//       });
//       break;
     
//      // Trending - commented out
//      // case 'trending':
//      //   // Sort by view count (most viewed first = descending order)
//      //   sortedProducts.sort((a, b) => {
//      //     const viewsA = parseInt(a.dataset.viewCount || '0', 10);
//      //     const viewsB = parseInt(b.dataset.viewCount || '0', 10);
//      //     // Descending order: most viewed first
//      //     return viewsB - viewsA;
//      //   });
//      //   break;
       
//     // Top Downloads - commented out
//     // case 'downloads':
//     //   // Sort by order count (most ordered first = descending order)
//     //   sortedProducts.sort((a, b) => {
//     //     const ordersA = parseInt(a.dataset.orderCount || '0', 10);
//     //     const ordersB = parseInt(b.dataset.orderCount || '0', 10);
//     //     // Descending order: most ordered first
//     //     return ordersB - ordersA;
//     //   });
//     //   break;
     
//     case 'alphabetical':
//       // Sort by product title alphabetically (A-Z)
//       sortedProducts.sort((a, b) => {
//         const titleA = (a.querySelector('.tli__title')?.textContent || '').trim().toLowerCase();
//         const titleB = (b.querySelector('.tli__title')?.textContent || '').trim().toLowerCase();
//         // Ascending order: A-Z
//         if (titleA < titleB) return -1;
//         if (titleA > titleB) return 1;
//         return 0;
//       });
//       break;
     
//     default:
//       // No sorting for unknown types
//       return products;
//   }
   
//    return sortedProducts;
//  }

//  // Apply filters to products
//  function applyFilters() {
//    const allProducts = Array.from(root.querySelectorAll('.track-list-item'));
//    const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
   
//    // Track if any filters are active
//    const hasActiveFilters = Object.values(activeFilters).some(arr => arr.length > 0) || searchTerm !== '';
   
//    allProducts.forEach(item => {
//      let matches = true;
     
//      // Check search term
//     // if (searchTerm) {
//     //   const title = item.querySelector('.tli__title')?.textContent.toLowerCase() || '';
//     //   const tags = Array.from(item.querySelectorAll('.tli__chip')).map(chip => chip.textContent.toLowerCase()).join(' ');
//     //   const searchableText = `${title} ${tags}`;
//     //     if (!searchableText.includes(searchTerm)) {
//     //       matches = false;
//     //     }
//     //  }


//     // Check search term
//     if (searchTerm) {
//       const title = item.querySelector('.tli__title')?.textContent.toLowerCase() || '';

//       const chips = Array.from(item.querySelectorAll('.tli__chip'))
//         .map(chip => chip.textContent.toLowerCase().trim())
//         .join(' ');

//       const genres = (item.dataset.genres || '').replaceAll('||', ' ').toLowerCase();
//       const bpm = (item.dataset.bpm || '').toLowerCase();
//       const mood = (item.dataset.mood || '').replaceAll('||', ' ').toLowerCase();

//       const key = (item.dataset.key || '').replaceAll('||', ' ').toLowerCase();
//       const theme = (item.dataset.theme || '').replaceAll('||', ' ').toLowerCase();
//       const vocal = (item.dataset.vocal || '').replaceAll('||', ' ').toLowerCase();
//       const tags = (item.dataset.tags || '').replaceAll('||', ' ').toLowerCase();

//       const searchableText = `${title} ${chips} ${genres} ${bpm} ${mood} ${key} ${theme} ${vocal} ${tags}`;

//       if (!searchableText.includes(searchTerm)) {
//         matches = false;
//       }
//     }

//      // Check genre filter
//      if (matches && activeFilters.genre.length > 0) {
//        const itemGenres = (item.dataset.genres || '').split('||').filter(g => g);
//        const hasGenre = activeFilters.genre.some(genre => itemGenres.includes(genre));
//        if (!hasGenre) matches = false;
//      }
     
//      // Check BPM filter
//      if (matches && activeFilters.bpm.length > 0) {
//        const itemBpm = item.dataset.bpm || '';
//        if (!activeFilters.bpm.includes(itemBpm)) matches = false;
//      }
     
//      // Check mood filter
//      if (matches && activeFilters.mood.length > 0) {
//        const itemMood = item.dataset.mood || '';
//        if (!activeFilters.mood.includes(itemMood)) matches = false;
//      }
     
//     // Check key filter-------------
//     // if (matches && activeFilters.key.length > 0) {
//     //   const itemKeys = (item.dataset.key || '').split('||').filter(k => k);
//     //   const hasKey = activeFilters.key.some(key => itemKeys.includes(key));
//     //   if (!hasKey) matches = false;
//     // }

//     // Check key filter
//     if (matches && activeFilters.key.length > 0) {
//       const itemKeys = (item.dataset.key || '')
//         .split('||')
//         .map(k => k.trim().toLowerCase())
//         .filter(Boolean);

//       const hasKey = activeFilters.key.some(key =>
//         itemKeys.includes(key.trim().toLowerCase())
//       );

//       if (!hasKey) matches = false;
//     }

//     // Check theme filter
//     if (matches && activeFilters.theme.length > 0) {
//       const itemThemes = (item.dataset.theme || '')
//         .split('||')
//         .map(t => t.trim().toLowerCase())
//         .filter(Boolean);

//       const hasTheme = activeFilters.theme.some(theme =>
//         itemThemes.includes(theme.trim().toLowerCase())
//       );

//       if (!hasTheme) matches = false;
//     }


//     // Check vocal filter
//     if (matches && activeFilters.vocal.length > 0) {
//       const itemVocals = (item.dataset.vocal || '').split('||').filter(v => v);
//       const hasVocal = activeFilters.vocal.some(vocal => itemVocals.includes(vocal));
//       if (!hasVocal) matches = false;
//     }
     
//      // Check tags filter
//      if (matches && activeFilters.tags.length > 0) {
//        const itemTags = (item.dataset.tags || '').split('||').filter(t => t);
//        const hasTag = activeFilters.tags.some(tag => itemTags.includes(tag));
//        if (!hasTag) matches = false;
//      }
     
//      // Check price filter
//      if (matches && activeFilters.price.length > 0) {
//        const itemPriceRange = item.dataset.priceRange || '';
//        if (!activeFilters.price.includes(itemPriceRange)) matches = false;
//      }
     
//      // Check length filter
//      if (matches && activeFilters.length.length > 0) {
//        const itemLength = item.dataset.trackLength || item.getAttribute('data-track-length') || '';
//        if (!activeFilters.length.includes(itemLength)) {
//          matches = false;
//        }
//      }
     
//      // Set filtered attribute - pagination will check this
//      item.dataset.filtered = matches ? 'true' : 'false';
//    });
   
//    // Apply sorting based on feature filter
//    const currentSort = activeFilters.feature && activeFilters.feature.length > 0
//      ? activeFilters.feature[0]
//      : 'newest'; // Default to newest
   
//    // Get the product list container
//    const productListContainer = root.querySelector('.ep-songlib__list');
//    if (productListContainer && currentSort) {
//      // Get all products (both filtered and unfiltered) to maintain DOM order
//      const allProductsArray = Array.from(productListContainer.querySelectorAll('.track-list-item'));
     
//      // Sort all products based on current sort type
//      const sortedProducts = sortProducts(allProductsArray, currentSort);
     
//      // Reorder DOM elements based on sorted order
//      sortedProducts.forEach((product) => {
//        productListContainer.appendChild(product);
//      });
//    }
   
//   // Reset to page 1 when filters change (not on search), if pagination exists
//   if (filterChangeTriggered && typeof currentPage !== 'undefined' && currentPage !== undefined) {
//     currentPage = 1;
//   }
 
//   // Update item visibility
//   if (updateDisplay && typeof updateDisplay === 'function') {
//     // Update items visibility based on current page and filters
//     updateDisplay();
// } else {
//     // If no pagination, just show/hide based on filters
//     // Products are already sorted in DOM, so just show/hide them
//     allProducts.forEach(item => {
//       item.style.display = item.dataset.filtered === 'true' ? 'grid' : 'none';
//     });
//   }
// }

//  // Mobile filters modal
//  const mobileFiltersBtn = root.querySelector('.ep-songlib__mobile-filters-btn');
//  const mobileFiltersModal = root.querySelector('#mobile-filters-modal');
//  const mobileFiltersClose = root.querySelector('.ep-songlib__mobile-filters-close');
//  const mobileFiltersApply = root.querySelector('.ep-songlib__mobile-filters-apply');
 
// // Mobile filter group collapsible functionality
// const mobileFilterGroupHeaders = root.querySelectorAll('.ep-songlib__mobile-filter-group-header');
// mobileFilterGroupHeaders.forEach(header => {
//   header.addEventListener('click', () => {
//     const group = header.closest('.ep-songlib__mobile-filter-group');
//     if (group) {
//       group.classList.toggle('expanded');
//     }
//   });
// });

// // Mobile filter chip click handlers
// const mobileFilterChips = root.querySelectorAll('.ep-songlib__mobile-filter-chip');
// mobileFilterChips.forEach(chip => {
//   chip.addEventListener('click', (e) => {
//     e.stopPropagation();
//     const filterType = chip.dataset.filterType;
//     const value = chip.dataset.filterValue;
   
//     if (!filterType || !value) return;
   
//     const isActive = chip.classList.contains('active');
   
//     // Feature filter is single-selection (only one option active at a time)
//     if (filterType === 'feature') {
//       if (!isActive) {
//         // Remove active state from all mobile feature chips
//         const allMobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
//         allMobileFeatureChips.forEach(c => c.classList.remove('active'));
       
//         // Set the clicked chip as active
//         chip.classList.add('active');
//         activeFilters[filterType] = [value];
       
//         // Update URL with sort parameter
//         updateURLWithSort(value);
       
//         // Sync with desktop sort dropdowns
//         const sortDropdowns = root.querySelectorAll('.ep-songlib__sort');
//         sortDropdowns.forEach(sd => {
//           const sdOptions = sd.querySelectorAll('.ep-songlib__sort-option');
//           sdOptions.forEach(o => o.classList.remove('active'));
//           const matchingOption = sd.querySelector(`.ep-songlib__sort-option[data-filter-value="${value}"]`);
//           if (matchingOption) {
//             matchingOption.classList.add('active');
//           }
//         });
       
//         // Update all sort labels (including mobile heading)
//         updateAllSortLabels();
       
//         // Apply filters immediately
//         filterChangeTriggered = true;
//         applyFilters();
//         filterChangeTriggered = false;
//       }
//       // If clicking the same feature option, don't deselect it (always keep one selected)
//     } else {
//       // Multi-selection for other filters
//       if (isActive) {
//         chip.classList.remove('active');
//         activeFilters[filterType] = activeFilters[filterType].filter(v => v !== value);
//       } else {
//         chip.classList.add('active');
//         if (!activeFilters[filterType].includes(value)) {
//           activeFilters[filterType].push(value);
//         }
//       }
     
//       // Sync with desktop chips
//       const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//       if (desktopChip) {
//         if (chip.classList.contains('active')) {
//           desktopChip.classList.add('active');
//         } else {
//           desktopChip.classList.remove('active');
//         }
//       }
//     }
   
//     updateMobileFilterTitle();
//   });
// });

// if (mobileFiltersBtn && mobileFiltersModal) {
//   mobileFiltersBtn.addEventListener('click', () => {
//     // Sync mobile chips with desktop chip buttons before opening
//     const mobileChips = mobileFiltersModal.querySelectorAll('.ep-songlib__mobile-filter-chip');
//     mobileChips.forEach(mobileChip => {
//       const filterType = mobileChip.dataset.filterType;
//       const value = mobileChip.dataset.filterValue;
//       const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//       if (desktopChip) {
//         if (desktopChip.classList.contains('active')) {
//           mobileChip.classList.add('active');
//         } else {
//           mobileChip.classList.remove('active');
//         }
//       }
//     });
   
//     updateMobileFilterTitle();
//     mobileFiltersModal.classList.add('active');
//     document.body.style.overflow = 'hidden';
//   });
// }

// if (mobileFiltersClose) {
//   mobileFiltersClose.addEventListener('click', () => {
//     mobileFiltersModal.classList.remove('active');
//     document.body.style.overflow = '';
//   });
// }

// if (mobileFiltersModal) {
//   mobileFiltersModal.addEventListener('click', (e) => {
//     if (e.target === mobileFiltersModal) {
//       mobileFiltersModal.classList.remove('active');
//       document.body.style.overflow = '';
//     }
//   });
// }

// // Clear All button
// const mobileFiltersClear = root.querySelector('.ep-songlib__mobile-filters-clear');
// if (mobileFiltersClear) {
//   mobileFiltersClear.addEventListener('click', () => {
//     // Clear all active filters
//     Object.keys(activeFilters).forEach(filterType => {
//       activeFilters[filterType] = [];
//     });
   
//     // Clear search input
//     if (searchInput) {
//       searchInput.value = '';
//     }
   
//     // Remove active class from all mobile chips
//     const mobileChips = mobileFiltersModal.querySelectorAll('.ep-songlib__mobile-filter-chip');
//     mobileChips.forEach(chip => {
//       chip.classList.remove('active');
//     });
   
//     // Remove active class from all desktop chips
//     const desktopChips = root.querySelectorAll('.ep-songlib__filter-chip');
//     desktopChips.forEach(chip => {
//       chip.classList.remove('active');
//     });
   
//     updateMobileFilterTitle();
//     updateFilterChips();
//     applyFilters();
//   });
// }

// if (mobileFiltersApply) {
//   mobileFiltersApply.addEventListener('click', () => {
//     // Update filters from mobile chips
//     Object.keys(activeFilters).forEach(filterType => {
//       activeFilters[filterType] = [];
//       const activeChips = mobileFiltersModal.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"].active`);
//       activeChips.forEach(chip => {
//         activeFilters[filterType].push(chip.dataset.filterValue);
//       });
//     });
   
//     // Sync with desktop chips
//     const mobileChips = mobileFiltersModal.querySelectorAll('.ep-songlib__mobile-filter-chip.active');
//     mobileChips.forEach(mobileChip => {
//       const filterType = mobileChip.dataset.filterType;
//       const value = mobileChip.dataset.filterValue;
//       const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//       if (desktopChip) {
//         desktopChip.classList.add('active');
//       }
//     });
   
//     // Remove active from desktop chips that aren't active in mobile
//     const desktopChips = root.querySelectorAll('.ep-songlib__filter-chip.active');
//     desktopChips.forEach(desktopChip => {
//       const filterType = desktopChip.dataset.filterType;
//       const value = desktopChip.dataset.filterValue;
//       const mobileChip = mobileFiltersModal.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//       if (!mobileChip || !mobileChip.classList.contains('active')) {
//         desktopChip.classList.remove('active');
//       }
//     });
   
//     filterChangeTriggered = true; // Mark that filters changed
//     updateFilterChips();
//     applyFilters();
//     filterChangeTriggered = false; // Reset flag
//     mobileFiltersModal.classList.remove('active');
//     document.body.style.overflow = '';
//   });
// }

// // Desktop Clear All button
// const desktopClearBtn = root.querySelector('.ep-songlib__desktop-clear-btn');
// if (desktopClearBtn) {
//   desktopClearBtn.addEventListener('click', () => {
//     // Clear all active filters
//     Object.keys(activeFilters).forEach(filterType => {
//       activeFilters[filterType] = [];
//     });
   
//     // Clear search input
//     if (searchInput) {
//       searchInput.value = '';
//     }
   
//     // Remove active class from all mobile chips
//     const mobileChips = root.querySelectorAll('.ep-songlib__mobile-filter-chip');
//     mobileChips.forEach(chip => {
//       chip.classList.remove('active');
//     });
   
//     // Remove active class from all desktop chips
//     const desktopChips = root.querySelectorAll('.ep-songlib__filter-chip');
//     desktopChips.forEach(chip => {
//       chip.classList.remove('active');
//     });
   
//     updateMobileFilterTitle();
//     updateFilterChips();
//     updateDesktopActionButtons(); // Hide buttons after clearing
//     applyFilters();
//   });
// }

// // Desktop Show Results button
// const desktopShowResultsBtn = root.querySelector('.ep-songlib__desktop-show-results-btn');
// if (desktopShowResultsBtn) {
//   desktopShowResultsBtn.addEventListener('click', () => {
//     // Apply filters when Show Results is clicked on desktop
//     // Note: Search works independently and is already applied, this only applies other filters
//     filterChangeTriggered = true;
//     updateFilterChips();
//     applyFilters();
//     filterChangeTriggered = false;
//   });
// }
 
//  if (searchInput) {
//    //console.log('🔍 Search input found, setting up search functionality');
//    searchInput.addEventListener('input', (e) => {
//      //console.log('🔍 Searching for:', e.target.value);
//      // Reset to page 1 when searching so results always start from first page
//      // This ensures that if user is on page 2+ and searches, they see results from page 1
//      if (typeof currentPage !== 'undefined' && currentPage !== undefined) {
//        currentPage = 1;
//      }
//      // Apply search immediately on both desktop and mobile - search works independently
//      applyFilters(); // Use unified filter function (this will call updateDisplay() which updates pagination)
//      // Update button visibility on desktop (for other filters)
//      if (isDesktop()) {
//        updateDesktopActionButtons();
//      }
//    });
//  }

// // Initialize all products as filtered initially
// const allProducts = Array.from(root.querySelectorAll('.track-list-item'));

// // Initialize all products as visible on page load
// if (allProducts.length > 0) {
//   // Mark all as visible initially
//   allProducts.forEach(item => {
//     item.dataset.filtered = 'true';
//   });
// }

// // Function to calculate track length category from duration in seconds
// function getTrackLengthCategory(totalSeconds) {
//   if (!totalSeconds || totalSeconds <= 0) return '';
//   if (totalSeconds < 90) return 'short';
//   if (totalSeconds <= 150) return 'medium';
//   return 'long';
// }

// // Function to extract duration from audio and update track length
// // This function loads ONLY metadata, not the full audio file - it does NOT play audio
// function extractAndUpdateTrackLength(productElement, audioElement) {
//   if (!audioElement || !productElement) return;
 
//   // Prevent any accidental playback
//   if (!audioElement.paused) {
//     audioElement.pause();
//   }
 
//   // Check if duration is already available
//   if (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) {
//     const durationInSeconds = audioElement.duration;
//     const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
   
//     if (trackLengthCategory) {
//       productElement.dataset.trackLength = trackLengthCategory;
//       // console.log('✅ Updated track length:', {
//       //   product: productElement.querySelector('.tli__title')?.textContent,
//       //   duration: durationInSeconds,
//       //   category: trackLengthCategory
//       // });
//     }
//     return;
//   }
 
//   // Listen for when metadata is loaded (this event fires when duration becomes available)
//   // Only add listener if not already added to avoid duplicates
//   if (!audioElement.dataset.metadataListenerAdded) {
//     audioElement.dataset.metadataListenerAdded = 'true';
   
//     const handleMetadataLoaded = () => {
//       // Ensure audio is paused (should already be paused, but double-check)
//       if (!audioElement.paused) {
//         audioElement.pause();
//       }
     
//       if (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) {
//         const durationInSeconds = audioElement.duration;
//         const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
       
//         if (trackLengthCategory) {
//           productElement.dataset.trackLength = trackLengthCategory;
//           // console.log('✅ Extracted track length from audio:', {
//           //   product: productElement.querySelector('.tli__title')?.textContent,
//           //   duration: durationInSeconds,
//           //   category: trackLengthCategory
//           // });
         
//           // Re-apply filters if any are active
//           if (activeFilters.length.length > 0) {
//             applyFilters();
//           }
//         }
//       }
//     };
   
//     // Add listener with { once: true } so it automatically removes after firing
//     audioElement.addEventListener('loadedmetadata', handleMetadataLoaded, { once: true });
   
//     // Load ONLY metadata (not the full audio file) - this is safe and won't play audio
//     // Set preload to metadata to only load metadata
//     if (audioElement.preload !== 'metadata') {
//       audioElement.preload = 'metadata';
//     }
   
//     // Load metadata if not already loading/loaded
//     if (audioElement.readyState === 0 && audioElement.src) {
//       // Use load() to load metadata - this does NOT play the audio
//       audioElement.load();
//     }
//   }
// }

// // Extract duration from all products by loading metadata only
// // Since Osaria player creates audio elements dynamically, we'll check for them
// // This function loads ONLY metadata (not full audio), so it's safe and won't play audio
// function extractDurationsFromAllProducts() {
//   allProducts.forEach((productElement, index) => {
//     // Try to find audio element directly in the product
//     let audioElement = productElement.querySelector('audio');
   
//     // If not found, try to find it through Osaria player
//     if (!audioElement) {
//       const osariaPlayer = productElement.querySelector('.osaria-player-custom-product-view');
//       if (osariaPlayer) {
//         // Try to get audio source from Osaria data
//         const osariaData = productElement.dataset.productOsariaAudioData;
       
//         // Create a temporary audio element to load metadata only
//         if (osariaData) {
//           try {
//             const osariaDataObj = JSON.parse(osariaData);
//             const audioUrl = osariaDataObj?.url || osariaDataObj?.src || osariaDataObj?.audio_url;
           
//             if (audioUrl) {
//               // Create a temporary audio element just for metadata extraction
//               const tempAudio = new Audio();
//               tempAudio.preload = 'metadata'; // Only load metadata, not full file
             
//               tempAudio.addEventListener('loadedmetadata', () => {
//                 if (tempAudio.duration && isFinite(tempAudio.duration) && tempAudio.duration > 0) {
//                   const durationInSeconds = tempAudio.duration;
//                   const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
//                   if (trackLengthCategory) {
//                     productElement.dataset.trackLength = trackLengthCategory;
//                     // console.log('✅ Extracted track length from Osaria data:', {
//                     //   product: productElement.querySelector('.tli__title')?.textContent,
//                     //   duration: durationInSeconds,
//                     //   category: trackLengthCategory
//                     // });
                   
//                     // Re-apply filters if any are active
//                     if (activeFilters.length.length > 0) {
//                       applyFilters();
//                     }
//                   }
//                 }
//                 // Clean up
//                 tempAudio.src = '';
//               });
             
//               tempAudio.addEventListener('error', () => {
//                 console.warn('⚠️ Could not load metadata for:', productElement.querySelector('.tli__title')?.textContent);
//                 tempAudio.src = '';
//               });
             
//               // Load metadata (this does NOT play audio)
//               tempAudio.src = audioUrl;
//             }
//           } catch (e) {
//             console.warn('⚠️ Could not parse Osaria data for:', productElement.querySelector('.tli__title')?.textContent);
//           }
//         }
       
//         // Also use MutationObserver to watch for audio elements being added by Osaria
//         const observer = new MutationObserver((mutations) => {
//           mutations.forEach((mutation) => {
//             mutation.addedNodes.forEach((node) => {
//               if (node.nodeName === 'AUDIO' || (node.querySelector && node.querySelector('audio'))) {
//                 const audio = node.nodeName === 'AUDIO' ? node : node.querySelector('audio');
//                 if (audio) {
//                   extractAndUpdateTrackLength(productElement, audio);
//                 }
//               }
//             });
//           });
//         });
       
//         observer.observe(osariaPlayer, { childList: true, subtree: true });
       
//         // Also check after delays in case audio elements are created asynchronously
//         setTimeout(() => {
//           audioElement = productElement.querySelector('audio');
//           if (audioElement) {
//             extractAndUpdateTrackLength(productElement, audioElement);
//           }
//         }, 500);
       
//         setTimeout(() => {
//           audioElement = productElement.querySelector('audio');
//           if (audioElement) {
//             extractAndUpdateTrackLength(productElement, audioElement);
//           }
//         }, 2000);
//       }
//     } else {
//       // Audio element found directly - extract duration by loading metadata
//       extractAndUpdateTrackLength(productElement, audioElement);
//     }
//   });
// }

// // Run extraction on page load, but only for already-loaded audio
// // This prevents auto-playing all tracks
// extractDurationsFromAllProducts();

// // Also set up listeners for when audio loads naturally (via user interaction)
// // Don't force load on page initialization

// // Debug: Log all track lengths to see what values products have
// //console.log('🎵 Track Length Debug - All products:');
// allProducts.forEach((item, index) => {
//   const trackLength = item.dataset.trackLength || '(empty)';
//   const productTitle = item.querySelector('.tli__title')?.textContent || 'Unknown';
//   console.log(`  Product ${index + 1}: "${productTitle}" - Track Length: "${trackLength}"`);
// });

//  // Initialize filter chips to sync with activeFilters (if any are set)
//  // This ensures chips show as active when filters are applied
//  function syncChipStates() {
//    Object.keys(activeFilters).forEach(filterType => {
//      activeFilters[filterType].forEach(value => {
//        const chip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
//        if (chip) {
//          chip.classList.add('active');
//        }
//      });
//    });
//  }
 
//  // Call sync after page load
//  syncChipStates();
//  updateMobileFilterTitle(); // Initialize mobile filter title

//   // Advanced Pagination System - declare variables in outer scope
//   let currentPage = 1;
//   let updateDisplay = null;
//   const paginationData = root.querySelector('#pagination-data');
 
//   if (paginationData) {
//     const itemsPerPage = parseInt(paginationData.dataset.itemsPerPage);
//     const totalProducts = parseInt(paginationData.dataset.totalProducts);
//     const totalPages = parseInt(paginationData.dataset.totalPages);
   
//     //console.log('📊 Pagination Data:', { itemsPerPage, totalProducts, totalPages });
   
//     // Function to show/hide products based on current page
//     updateDisplay = () => {
//       // Get all filtered products from DOM (in their sorted order, not from static allProducts array)
//       // Query the container to get products in their current DOM order (after sorting)
//       const container = root.querySelector('.ep-songlib__list');
//       const filteredProducts = container
//         ? Array.from(container.querySelectorAll('.track-list-item')).filter(item => item.dataset.filtered === 'true')
//         : allProducts.filter(item => item.dataset.filtered === 'true');
//       const filteredCount = filteredProducts.length;
     
//       // Calculate total pages based on filtered products
//       const filteredTotalPages = Math.max(1, Math.ceil(filteredCount / itemsPerPage));
     
//       // Calculate page range for current page
//       const startIndex = (currentPage - 1) * itemsPerPage;
//       const endIndex = startIndex + itemsPerPage;
     
//       // Hide all products first
//       allProducts.forEach(item => {
//         item.style.display = 'none';
//       });
     
//       // Show only products in current page range from filtered results
//       filteredProducts.forEach((item, index) => {
//         if (index >= startIndex && index < endIndex) {
//           item.style.display = 'grid';
//         }
//       });
     
//       // Update pagination controls with filtered count
//       updatePaginationControls(filteredCount, filteredTotalPages);
//     };
   
//     // Update pagination button states
//     const updatePaginationControls = (filteredCount = null, filteredTotalPages = null) => {
//       // Use filtered counts if provided, otherwise use original counts
//       const actualTotalPages = filteredTotalPages !== null ? filteredTotalPages : totalPages;
     
//       const prevBtn = root.querySelector('#prev-btn');
//       const nextBtn = root.querySelector('#next-btn');
//       const pageNumbers = root.querySelector('#page-numbers');
     
//       if (prevBtn) {
//         prevBtn.disabled = currentPage === 1;
//       }
     
//       if (nextBtn) {
//         nextBtn.disabled = currentPage >= actualTotalPages;
//       }
     
//       // Show/hide and enable/disable "Show More" button - only show if there are at least itemsPerPage (12) more products
//       // Works in parallel with filters and pagination
//       const showMoreBtn = root.querySelector('.show-more-btn');
//       if (showMoreBtn) {
//         // Calculate remaining items beyond what's currently shown
//         const actualFilteredCount = filteredCount !== null ? filteredCount : totalProducts;
//         const itemsShown = currentPage * itemsPerPage;
//         const remainingItems = actualFilteredCount - itemsShown;
        
//         // Show More button should only appear if there are at least itemsPerPage (12) more products available
//         // This ensures the button text "Show 12 more" is accurate
//         const hasEnoughMoreItems = remainingItems >= itemsPerPage;
//         const hasMorePages = currentPage < actualTotalPages;
        
//         // Show More should only work if:
//         // 1. There are at least itemsPerPage (12) more filtered items to show, AND
//         // 2. There are more pages to show (pagination has more pages)
//         // Works in parallel with both filters and pagination
//         const shouldEnable = hasEnoughMoreItems && hasMorePages && actualTotalPages > 1;
        
//         // Debug logging
//         // console.log('🔍 Show More Button Check:', {
//         //   currentPage,
//         //   actualTotalPages,
//         //   actualFilteredCount,
//         //   itemsShown,
//         //   remainingItems,
//         //   itemsPerPage,
//         //   hasEnoughMoreItems,
//         //   hasMorePages,
//         //   shouldEnable
//         // });
        
//         // Hide and disable button if not enough items (less than itemsPerPage remaining)
//         if (!shouldEnable) {
//           showMoreBtn.style.display = 'none';
//           showMoreBtn.disabled = true;
//           //console.log('✅ Hiding and disabling Show More button - not enough items (need at least ' + itemsPerPage + ' more)');
//         } else {
//           showMoreBtn.style.display = 'flex';
//           showMoreBtn.disabled = false;
//           //console.log('✅ Showing and enabling Show More button - ' + remainingItems + ' items remaining');
//         }
//       }
     
//       // Only update page numbers if container exists
//       if (pageNumbers) {
//         // Check if page numbers need to be regenerated (when total pages change)
//         const existingPages = pageNumbers.querySelectorAll('.page-number');
//         const existingPageCount = existingPages.length;
//         const isMobile = window.innerWidth <= 768;
//         const hasEllipsis = pageNumbers.querySelector('.ellipsis') !== null;
       
//         // Check if current page is visible in pagination (for mobile with ellipsis)
//         const visiblePageNumbers = Array.from(existingPages)
//           .filter(el => !el.classList.contains('ellipsis')) // Skip ellipsis elements
//           .map(el => parseInt(el.dataset.page) || parseInt(el.textContent))
//           .filter(num => !isNaN(num));
//         const isCurrentPageVisible = visiblePageNumbers.includes(currentPage);
        
//         // Calculate expected page count for mobile with ellipsis
//         // If current page is 1, 2, or last: expect 4 items (1, 2, ..., last)
//         // If current page is in middle: expect 5 items (1, 2, ..., currentPage, ..., last)
//         const expectedMobilePageCount = (isMobile && actualTotalPages > 4) 
//           ? ((currentPage > 2 && currentPage < actualTotalPages) ? 5 : 4)
//           : actualTotalPages;
        
//         // Regenerate if:
//         // 1. Total pages changed
//         // 2. Pages don't exist
//         // 3. On mobile and structure should be different (has ellipsis when shouldn't, or vice versa)
//         // 4. On mobile and page count doesn't match expected count
//         // 5. Current page is not visible in pagination (important for mobile with ellipsis)
//         const shouldRegenerate = (!isMobile && existingPageCount !== actualTotalPages) ||
//                                   existingPageCount === 0 ||
//                                   (isMobile && actualTotalPages <= 4 && hasEllipsis) ||
//                                   (!isMobile && hasEllipsis) ||
//                                   (isMobile && actualTotalPages > 4 && existingPageCount !== expectedMobilePageCount) ||
//                                   (isMobile && actualTotalPages > 4 && !isCurrentPageVisible);
       
//         if (shouldRegenerate) {
//           // Check if mobile view (width <= 768px)
//           const isMobile = window.innerWidth <= 768;
          
//           // Regenerate page numbers with new total
//           let pageHtml = '';
          
//           if (isMobile && actualTotalPages > 4) {
//             // Mobile view: Show 1, 2, ..., last number
//             // Always show first page
//             if (1 === currentPage) {
//               pageHtml += `<span class="page-number active">1</span>`;
//             } else {
//               pageHtml += `<button class="page-number" data-page="1">1</button>`;
//             }
            
//             // Always show second page
//             if (2 === currentPage) {
//               pageHtml += `<span class="page-number active">2</span>`;
//             } else {
//               pageHtml += `<button class="page-number" data-page="2">2</button>`;
//             }
            
//             // Show current page if it's not 1, 2, or last
//             if (currentPage > 2 && currentPage < actualTotalPages) {
//               // Show ellipsis before current page if there's a gap
//               if (currentPage > 3) {
//                 pageHtml += `<span class="page-number ellipsis">...</span>`;
//               }
              
//               // Show current page
//               pageHtml += `<span class="page-number active">${currentPage}</span>`;
              
//               // Show ellipsis after current page if there's a gap
//               if (currentPage < actualTotalPages - 1) {
//                 pageHtml += `<span class="page-number ellipsis">...</span>`;
//               }
//             } else {
//               // Show ellipsis if current page is 1, 2, or last (only when more than 4 pages)
//               if (actualTotalPages > 4) {
//                 pageHtml += `<span class="page-number ellipsis">...</span>`;
//               }
//             }
            
//             // Always show last page
//             if (actualTotalPages === currentPage) {
//               pageHtml += `<span class="page-number active">${actualTotalPages}</span>`;
//             } else {
//               pageHtml += `<button class="page-number" data-page="${actualTotalPages}">${actualTotalPages}</button>`;
//             }
//           } else {
//             // Desktop view or mobile with 4 or fewer pages: Show all numbers
//             for (let i = 1; i <= actualTotalPages; i++) {
//               if (i === currentPage) {
//                 pageHtml += `<span class="page-number active">${i}</span>`;
//               } else {
//                 pageHtml += `<button class="page-number" data-page="${i}">${i}</button>`;
//               }
//             }
//           }
//         pageNumbers.innerHTML = pageHtml;
       
//         // Add click handlers to page numbers (skip ellipsis)
//         pageNumbers.querySelectorAll('.page-number').forEach(btn => {
//           if (btn.dataset.page && !btn.classList.contains('ellipsis')) {
//               btn.setAttribute('data-listener', 'true');
//             btn.addEventListener('click', () => {
//               currentPage = parseInt(btn.dataset.page);
//               updateDisplay();
//             });
//           }
//         });
//         } else {
//           // Just update active state without regenerating HTML
//           existingPages.forEach(pageEl => {
//             // Skip ellipsis elements - they don't have page numbers
//             if (pageEl.classList.contains('ellipsis')) {
//               return;
//             }
            
//             const pageNum = parseInt(pageEl.dataset.page) || parseInt(pageEl.textContent);
//             // Skip if pageNum is NaN (shouldn't happen, but safety check)
//             if (isNaN(pageNum)) {
//               return;
//             }
            
//             if (pageNum === currentPage) {
//               pageEl.classList.add('active');
//               // If it's a button, convert to span to match original design
//               if (pageEl.tagName === 'BUTTON') {
//                 const span = document.createElement('span');
//                 span.className = 'page-number active';
//                 span.textContent = pageNum;
//                 pageEl.parentNode.replaceChild(span, pageEl);
//               }
//             } else {
//               pageEl.classList.remove('active');
//               // If it's a span (was active), convert back to button
//               if (pageEl.tagName === 'SPAN') {
//                 const btn = document.createElement('button');
//                 btn.className = 'page-number';
//                 btn.dataset.page = pageNum;
//                 btn.textContent = pageNum;
//                 if (!btn.hasAttribute('data-listener')) {
//                   btn.setAttribute('data-listener', 'true');
//                   btn.addEventListener('click', () => {
//                     currentPage = parseInt(btn.dataset.page);
//                     updateDisplay();
//                   });
//                 }
//                 pageEl.parentNode.replaceChild(btn, pageEl);
//               } else if (pageEl.tagName === 'BUTTON' && !pageEl.hasAttribute('data-listener')) {
//                 // Add click handler if not already added
//                 pageEl.setAttribute('data-listener', 'true');
//                 pageEl.addEventListener('click', () => {
//                   currentPage = parseInt(pageEl.dataset.page);
//                   updateDisplay();
//                 });
//               }
//             }
//           });
//         }
//       }
//     };
   
//     // Add resize listener to update pagination when switching between mobile/desktop
//     let resizeTimeout;
//     window.addEventListener('resize', () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(() => {
//         // Force regeneration of pagination on resize
//         const pageNumbers = root.querySelector('#page-numbers');
//         if (pageNumbers) {
//           // Clear existing pages to force regeneration
//           pageNumbers.innerHTML = '';
//           updatePaginationControls();
//         }
//       }, 150);
//     });
   
//     // Previous button
//     const prevBtn = root.querySelector('#prev-btn');
//     if (prevBtn) {
//       prevBtn.addEventListener('click', () => {
//         if (currentPage > 1) {
//           currentPage--;
//           updateDisplay();
//         }
//       });
//     }
   
//     // Next button
//     const nextBtn = root.querySelector('#next-btn');
//     if (nextBtn) {
//       nextBtn.addEventListener('click', () => {
//         // Calculate filtered pages dynamically
//         const filteredProducts = allProducts.filter(item => item.dataset.filtered === 'true');
//         const filteredTotalPages = Math.max(1, Math.ceil(filteredProducts.length / itemsPerPage));
       
//         if (currentPage < filteredTotalPages) {
//           currentPage++;
//           updateDisplay();
//         }
//       });
//     }
   
//     // Show More button - only works if there are at least itemsPerPage (12) more products available
//     const showMoreBtn = root.querySelector('.show-more-btn');
//     if (showMoreBtn) {
//       showMoreBtn.addEventListener('click', () => {
//         // Don't proceed if button is disabled
//         if (showMoreBtn.disabled) {
//           //console.log('🚫 Show More button is disabled, ignoring click');
//           return;
//         }
        
//         // Check if there are at least itemsPerPage (12) more filtered items available
//         // Use the same logic as updateDisplay to get filtered products
//         const container = root.querySelector('.ep-songlib__list');
//         const filteredProducts = container
//           ? Array.from(container.querySelectorAll('.track-list-item')).filter(item => item.dataset.filtered === 'true')
//           : allProducts.filter(item => item.dataset.filtered === 'true');
//         const filteredTotalPages = Math.max(1, Math.ceil(filteredProducts.length / itemsPerPage));
//         const totalItems = filteredProducts.length;
//         const itemsShown = currentPage * itemsPerPage;
//         const remainingItems = totalItems - itemsShown;
//         const hasEnoughMoreItems = remainingItems >= itemsPerPage;
//         const hasMorePages = currentPage < filteredTotalPages;
        
//         // Only proceed if there are at least itemsPerPage (12) more items AND more pages
//         // Works in parallel with both filters and pagination
//         if (hasEnoughMoreItems && hasMorePages && filteredTotalPages > 1) {
//           currentPage++;
//           updateDisplay();
//         } else {
//           //console.log('🚫 Not enough items to show (need at least ' + itemsPerPage + ' more, but only ' + remainingItems + ' remaining)');
//           // Disable button if not enough items
//           showMoreBtn.disabled = true;
//           showMoreBtn.style.display = 'none';
//         }
//       });
//     }
   
//     // Initialize display
//     updateDisplay();
   
//     // Initialize filters - apply on page load
//     if (typeof applyFilters === 'function') {
//       applyFilters();
//     }
//   }
 
// // --- Osaria Player Integration ---
// let activeRow = null;
// let activePlayer = null;
// let selectedMediaSyncListener = null; // Store reference to selected media sync listener

//   function pauseAllCartAudio() {
//     try {
//       const pauseCartAudio = (container) => { if (container) container.querySelectorAll('audio').forEach(audio => { if (!audio.paused) { audio.pause(); const cartItem = audio.closest('.cart-item-card, .cart__item, [class*="cart-item"]'); if (cartItem) { const playBtn = cartItem.querySelector('.cart-item-card__playbtn, [class*="playbtn"], button[aria-label*="Play"]'); if (playBtn) { playBtn.classList.remove('playing', 'active'); const playIcon = playBtn.querySelector('.play-icon, [class*="play"]'), pauseIcon = playBtn.querySelector('.pause-icon, [class*="pause"]'); if (playIcon) playIcon.style.display = ''; if (pauseIcon) pauseIcon.style.display = 'none'; } } } }); };
//       pauseCartAudio(document.querySelector('cart-drawer-component') || document.querySelector('[id*="cart-drawer"]') || document.querySelector('cart-drawer') || document.querySelector('[class*="cart-drawer"]'));
//       pauseCartAudio(document.querySelector('.cart-items__wrapper'));
//     } catch (error) { console.warn('⚠️ Error pausing cart audio:', error); }
//   }

//   function pauseAllMusicStoreAudio() {
//     try {
//       root.querySelectorAll('audio').forEach(audio => { if (!audio.paused) { audio.pause(); const trackItem = audio.closest('.track-list-item'); if (trackItem) { setPlayIcon(trackItem, false); trackItem.classList.remove('playing'); } } });
//       if (window.StickyAudioPlayer?.getCurrentTrack) { const currentTrack = window.StickyAudioPlayer.getCurrentTrack(); if (currentTrack?.element?.closest('.track-list-item')) { const stickyAudio = window.StickyAudioPlayer.getAudioElement?.(); if (stickyAudio && !stickyAudio.paused) { stickyAudio.pause(); window.StickyAudioPlayer.updatePlayPause?.(false); } } }
//     } catch (error) { console.warn('⚠️ Error pausing music store audio:', error); }
//   }

//   function setupCartAudioObserver() {
//     const targetElement = document.querySelector('cart-drawer-component') || document.querySelector('[id*="cart-drawer"]') || document.querySelector('cart-drawer') || document.querySelector('[class*="cart-drawer"]') || document.querySelector('.cart-items__wrapper');
//     if (targetElement) {
//       const setupCartAudioListeners = () => { targetElement.querySelectorAll('audio').forEach(audio => { if (!audio.dataset.cartPlayListenerAdded) { audio.dataset.cartPlayListenerAdded = 'true'; audio.addEventListener('play', () => { pauseAllMusicStoreAudio(); document.dispatchEvent(new CustomEvent('cart:audio:play', { bubbles: true })); }); } }); };
//       setupCartAudioListeners();
//       new MutationObserver(setupCartAudioListeners).observe(targetElement, { childList: true, subtree: true });
//       return true;
//     }
//     return false;
//   }
//   if (!setupCartAudioObserver()) { setTimeout(() => { if (!setupCartAudioObserver()) { document.addEventListener('cart:drawer:open', () => { setTimeout(() => setupCartAudioObserver(), 500); }, { once: true }); } }, 1000); }
//   document.addEventListener('cart:content:refreshed', () => { setTimeout(() => setupCartAudioObserver(), 500); });
//   document.addEventListener('cart:audio:play', () => { pauseAllMusicStoreAudio(); });
  
//   // Listen for sticky player pause/play events - immediate UI update
//   document.addEventListener('stickyPlayerPause', (e) => {
//     const { variantId, productId, source } = e.detail;
//     if (source === 'musicLibrary') return; // Ignore our own events
    
//     //console.log('🎵 Music Store - Received stickyPlayerPause event', { variantId, productId, source });
    
//     // Immediately update all playing tracks in this section
//     root.querySelectorAll('.track-list-item.playing').forEach(track => {
//       const trackVariantId = track.dataset.variantId;
//       const trackProductId = track.dataset.productId;
      
//       // If variantId matches or no variantId specified (pause all), pause this track
//       if (!variantId || (trackVariantId && Number(trackVariantId) === Number(variantId)) || 
//           (productId && trackProductId && Number(trackProductId) === Number(productId))) {
//         track.classList.remove('playing');
//         setPlayIcon(track, false);
        
//         // Also pause the audio element if it exists
//         const audio = track.querySelector('audio');
//         if (audio && !audio.paused) {
//           audio.pause();
//         }
//       }
//     });
    
//     // Clear activeRow if it matches
//     if (activeRow) {
//       const activeVariantId = activeRow.dataset.variantId;
//       const activeProductId = activeRow.dataset.productId;
//       if (!variantId || (activeVariantId && Number(activeVariantId) === Number(variantId)) ||
//           (productId && activeProductId && Number(activeProductId) === Number(productId))) {
//         activeRow = null;
//         activePlayer = null;
//       }
//     }
//   });
  
//   document.addEventListener('stickyPlayerPlay', (e) => {
//     const { variantId, productId, source } = e.detail;
//     if (source === 'musicLibrary') return; // Ignore our own events
    
//     //console.log('🎵 Music Store - Received stickyPlayerPlay event', { variantId, productId, source });
    
//     // Find and update the track that should be playing
//     if (variantId || productId) {
//       const track = root.querySelector(
//         variantId ? `.track-list-item[data-variant-id="${variantId}"]` :
//         `.track-list-item[data-product-id="${productId}"]`
//       );
      
//       if (track) {
//         track.classList.add('playing');
//         setPlayIcon(track, true);
//         activeRow = track;
//       }
//     }
//   });

//   // format seconds → m:ss
//   const fmt = (sec) => {
//     if (!isFinite(sec) || sec < 0) return '0:00';
//     const m = Math.floor(sec / 60);
//     const s = Math.floor(sec % 60).toString().padStart(2,'0');
//     return `${m}:${s}`;
//   };

//   // Initialize all time displays to show total duration on page load
//   const initializeTimeDisplays = () => {
//     const allRows = root.querySelectorAll('.track-list-item');
//     allRows.forEach(row => {
//       const current = row.querySelector('.tli__current');
//       const currentMobile = row.querySelector('.tli__current-mobile');
//       const totalElement = row.querySelector('.tli__total');
     
//       // Only set if not already playing or loading, and total element exists
//       if (totalElement && !row.classList.contains('playing')) {
//         const totalDuration = totalElement.textContent.trim();
       
//         // Set desktop time display if it exists and is not in loading state
//         if (current && !current.classList.contains('loading')) {
//           current.textContent = totalDuration;
//         }
       
//         // Set mobile time display if it exists and is not in loading state
//         if (currentMobile && !currentMobile.classList.contains('loading')) {
//           currentMobile.textContent = totalDuration;
//         }
//       }
//     });
//   };
 
//   // Initialize time displays on page load and after DOM is ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initializeTimeDisplays);
//   } else {
//     initializeTimeDisplays();
//   }

//   // Toggle icons
//   const setPlayIcon = (row, playing, loading = false) => {
//     const play = row.querySelector('.icon-play');
//     const pause = row.querySelector('.icon-pause');
//     if (!play || !pause) return;
   
//     if (loading) {
//       play.style.display = 'none';
//       pause.style.display = 'none';
//       row.classList.remove('showing-pause');
//     } else {
//       play.style.display = playing ? 'none' : 'block';
//       pause.style.display = playing ? 'block' : 'none';
//       // Add/remove showing-pause class for overlay
//       if (playing) {
//         row.classList.add('showing-pause');
//       } else {
//         row.classList.remove('showing-pause');
//       }
//     }
//   };

//  // Reset all play icons except the active one
//  const resetAllPlayIcons = (exceptRow = null) => {
//  root.querySelectorAll('.track-list-item').forEach(trackRow => {
//  if (trackRow !== exceptRow) {
//  setPlayIcon(trackRow, false);
//  }
//  });
//  };

//   // Reset previously active row UI
//   const resetActive = () => {
//     if (!activeRow) return;
//     setPlayIcon(activeRow, false);
//     const seek = activeRow.querySelector('.tli__seek');
//     const current = activeRow.querySelector('.tli__current');
//     const currentMobile = activeRow.querySelector('.tli__current-mobile');
//     if (seek) seek.value = 0;
   
//     // Reset to total duration instead of '0:00'
//     const totalElement = activeRow.querySelector('.tli__total');
//     const audioElement = activeRow.querySelector('audio');
   
//     if (current) {
//       // Try to get duration from audio element first
//       if (audioElement && audioElement.duration && isFinite(audioElement.duration)) {
//         current.textContent = fmt(audioElement.duration);
//       } else if (totalElement) {
//         current.textContent = totalElement.textContent.trim();
//       } else {
//         current.textContent = '0:00';
//       }
//       current.classList.remove('loading', 'error');
//     }
//     if (currentMobile) {
//       // Try to get duration from audio element first
//       if (audioElement && audioElement.duration && isFinite(audioElement.duration)) {
//         currentMobile.textContent = fmt(audioElement.duration);
//       } else if (totalElement) {
//         currentMobile.textContent = totalElement.textContent.trim();
//       } else {
//         currentMobile.textContent = '0:00';
//       }
//     }
//     activeRow = null;
//   };

//   // Show loading state
//   const showLoading = (row) => {
//  //console.log('🔄 Showing loading state for:', row.querySelector('.tli__title').textContent);
//     setPlayIcon(row, false, true);
//     const current = row.querySelector('.tli__current');
//     const currentMobile = row.querySelector('.tli__current-mobile');
//     if (current) {
//       current.textContent = 'Loading...';
//       current.classList.add('loading');
//  //console.log('✅ Loading text set to:', current.textContent);
//  } else {
//  console.warn('❌ No .tli__current element found for loading state');
//     }
//     if (currentMobile) {
//       currentMobile.textContent = 'Loading...';
//     }
//   };

//   // Handle audio errors
//   const handleAudioError = (row) => {
//     setPlayIcon(row, false);
//     const current = row.querySelector('.tli__current');
//     const currentMobile = row.querySelector('.tli__current-mobile');
//     if (current) {
//  current.textContent = 'Loading...';
//  current.classList.remove('error');
//  current.classList.add('loading');
//  }
//  if (currentMobile) {
//  currentMobile.textContent = 'Loading...';
//  }
//  console.warn('Audio failed to load for track:', row.querySelector('.tli__title').textContent);
//  };

//  // Initialize Osaria Player for a track
//  const initOsariaPlayer = (row) => {
//  const osariaData = row.dataset.productOsariaAudioData;
//  if (!osariaData) {
//  console.warn('❌ No Osaria data found for track:', row.querySelector('.tli__title').textContent);
//  return null;
//  }

//  // Create Osaria player element
//  const playerDiv = row.querySelector('.osaria-player-custom-product-view');
//  if (!playerDiv) {
//  console.warn('❌ No Osaria player div found for track:', row.querySelector('.tli__title').textContent);
//  return null;
//  }

//  // Initialize Osaria player (this will be handled by Osaria's JavaScript)
//  //console.log('🎵 Initializing Osaria player for:', row.querySelector('.tli__title').textContent);
//  return playerDiv;
//   };

//   // Bind clicks
//   root.querySelectorAll('.track-list-item').forEach((row, index) => {
//  console.log(`🎵 Setting up track ${index + 1}:`, row.querySelector('.tli__title')?.textContent);
//     const btn = row.querySelector('.tli__playbtn');
//     const seek = row.querySelector('.tli__seek');
//     const addBtn = row.querySelector('.tli__add');
//  //console.log('🎵 Play button found:', !!btn);
//  //console.log('🎵 Seek bar found:', !!seek);
//  //console.log('🎵 Add button found:', !!addBtn);
//  if (!btn) {
//  console.warn('❌ No play button found for track:', row.querySelector('.tli__title')?.textContent);
//  return;
//  }

//     // Make entire track clickable (except play button and add to cart button)
//     row.style.cursor = 'pointer';
//     row.setAttribute('tabindex', '0');
//     row.setAttribute('role', 'button');
//     row.setAttribute('aria-label', `Play track: ${row.querySelector('.tli__title').textContent}`);
   
//     // Helper function to check if click/touch should be ignored
//     const shouldIgnoreInteraction = (target) => {
//       return target.closest('.tli__playbtn') ||
//              target.closest('.tli__add') ||
//              target.closest('.tli__seek') ||
//              target.closest('.tli__seek-container');
//     };
   
//     // Handle click events
//     row.addEventListener('click', (e) => {
//       // Don't trigger if clicking on play button, add button, or seek bar
//       if (shouldIgnoreInteraction(e.target)) {
//         return;
//       }
     
//       //console.log('🎵 Track clicked:', row.querySelector('.tli__title').textContent);
//       // Trigger the play button click
//       btn.click();
//     });
   
//     // Handle touch events for mobile compatibility
//     let rowTouchStartTime = 0;
//     let rowTouchStartTarget = null;
   
//     row.addEventListener('touchstart', (e) => {
//       // Check if touch started on a button that should be ignored
//       if (shouldIgnoreInteraction(e.target)) {
//         // Don't track this touch - let the button handle it
//         rowTouchStartTime = 0;
//         rowTouchStartTarget = null;
//         return;
//       }
//       rowTouchStartTime = Date.now();
//       rowTouchStartTarget = e.target;
//     }, { passive: true });
   
//     row.addEventListener('touchend', (e) => {
//       // Don't trigger if touching on play button, add button, or seek bar
//       const endTarget = e.target;
//       const startTarget = rowTouchStartTarget;
     
//       // Check if touch was on any button that should be ignored
//       if (shouldIgnoreInteraction(endTarget) || shouldIgnoreInteraction(startTarget)) {
//         // Reset tracking and don't trigger
//         rowTouchStartTime = 0;
//         rowTouchStartTarget = null;
//         return;
//       }
     
//       // Only trigger if we have valid tracking data
//       if (!rowTouchStartTime || !rowTouchStartTarget) {
//         return;
//       }
     
//       // Only trigger if it was a quick tap (not a swipe)
//       const touchDuration = Date.now() - rowTouchStartTime;
//       if (touchDuration < 300 && touchDuration > 0) {
//         e.preventDefault();
//         e.stopPropagation();
//         //console.log('🎵 Track touched:', row.querySelector('.tli__title').textContent);
//         // Trigger the play button click
//         btn.click();
//       }
     
//       // Reset tracking
//       rowTouchStartTime = 0;
//       rowTouchStartTarget = null;
//     }, { passive: false });

//     // play/pause
//     btn.addEventListener('click', () => {
//  //console.log('🎵 Clicked play button for:', row.querySelector('.tli__title').textContent);
//  //console.log('🎵 Osaria data:', row.dataset.productOsariaAudioData);
 
//  // Check if Osaria data exists
//  const osariaData = row.dataset.productOsariaAudioData;
//  if (!osariaData || osariaData === 'null' || osariaData === '') {
//  console.warn('❌ No Osaria data found for track:', row.querySelector('.tli__title').textContent);
//  alert('No audio source found for this track. Please check Osaria metafields.');
//         return;
//       }

//      // If same track is already playing, pause it
//      if (row === activeRow && activePlayer) {
//        //console.log('🎵 Pausing current track');
//        // Remove playing class
//        row.classList.remove('playing');
//        // Try to pause the Osaria player
//        const audioElement = row.querySelector('audio');
//        if (audioElement) {
//          audioElement.pause();
//        }
//         setPlayIcon(row, false);
//        // Reset progress bar and time
//        const seek = row.querySelector('.tli__seek');
//        const current = row.querySelector('.tli__current');
//        const currentMobile = row.querySelector('.tli__current-mobile');
//        if (seek) {
//          seek.value = 0;
//          seek.style.setProperty('--value', '0%');
//        }
//        const seekFill = row.querySelector('.tli__seek-fill');
//        if (seekFill) seekFill.style.width = '0%';
//          if (current) {
//              current.textContent = '0:00';
//            current.classList.remove('loading');
//          }
//          if (currentMobile) {
//              currentMobile.textContent = '0:00';
//          }
       
//        // Notify sticky player about pause
//        notifyPlayPause(false);
       
//        activeRow = null;
//        activePlayer = null;
//         return;
//       }

//    // Stop any currently playing track
//  if (activeRow && activeRow !== row) {
//  //console.log('🎵 Stopping previous track');
//  const prevAudio = activeRow.querySelector('audio');
//  if (prevAudio) {
//  prevAudio.pause();
//  }
//  setPlayIcon(activeRow, false);
//  }
 
//  // Reset all play icons to ensure only one shows pause
//  resetAllPlayIcons();

//  // Set new active row
//  activeRow = row;
//         showLoading(row);

//  // Initialize Osaria player
//  const player = initOsariaPlayer(row);
//  if (player) {
//  activePlayer = player;
 
//  // Wait for Osaria player to initialize and find audio element
//  const checkForAudio = () => {
//  const audioElement = row.querySelector('audio');
//  if (audioElement) {
//  //console.log('🎵 Audio element found, setting up events');
 
// // Set up audio events
// audioElement.addEventListener('loadstart', () => {
//  //console.log('🎵 Audio loadstart');
//  // Don't extract here to avoid triggering unwanted loads
//  });
 
// audioElement.addEventListener('canplay', () => {
// //console.log('🎵 Audio canplay');
// setPlayIcon(row, true);
// const current = row.querySelector('.tli__current');
// const currentMobile = row.querySelector('.tli__current-mobile');
// // Show total duration when audio is ready
// if (audioElement.duration && isFinite(audioElement.duration)) {
//   const totalDuration = fmt(audioElement.duration);
//   if (current) {
//     current.textContent = totalDuration;
//     current.classList.remove('loading');
//   }
//   if (currentMobile) {
//     currentMobile.textContent = totalDuration;
//   }
// } else {
//   // Fallback: try to get from tli__total element
//   const totalElement = row.querySelector('.tli__total');
//   if (current) {
//     if (totalElement) {
//       current.textContent = totalElement.textContent.trim();
//     } else {
//       current.textContent = '0:00';
//     }
//     current.classList.remove('loading');
//   }
//   if (currentMobile) {
//     if (totalElement) {
//       currentMobile.textContent = totalElement.textContent.trim();
//     } else {
//       currentMobile.textContent = '0:00';
//      }
//    }
//  }
 
//  // Extract and update track length from audio duration
//  if (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) {
//    const durationInSeconds = audioElement.duration;
//    const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
//    if (trackLengthCategory) {
//      row.dataset.trackLength = trackLengthCategory;
//      //console.log('✅ Updated track length from canplay event:', {
//     //    product: row.querySelector('.tli__title')?.textContent,
//     //    duration: durationInSeconds,
//     //    category: trackLengthCategory
//     //  });
     
//      // Re-apply filters if any are active
//      if (activeFilters.length.length > 0) {
//        applyFilters();
//      }
//    }
//  }
//  });
 
//      audioElement.addEventListener('play', () => {
//        //console.log('🎵 Audio playing');
       
//        // Pause any playing audio in cart drawer
//        pauseAllCartAudio();
       
//        // Remove playing class from all tracks
//        root.querySelectorAll('.track-list-item').forEach(track => {
//          track.classList.remove('playing');
//        });
//        // Add playing class to current track
//        row.classList.add('playing');
//        // Reset all other tracks to show play button
//        resetAllPlayIcons(row);
//        // Show pause button for this track
//           setPlayIcon(row, true);
//          // Set this as active row
//          activeRow = row;
       
//        // Prepare track data for sticky player
//        const titleElement = row.querySelector('.tli__title');
//        const titleText = titleElement?.textContent?.trim();
//        const albumArtElement = row.querySelector('.tli__cover img');
//        const albumArtSrc = albumArtElement?.src;
       
//        //console.log('🎵 Music store - title element:', titleElement);
//        //console.log('🎵 Music store - title text:', titleText);
//        //console.log('🎵 Music store - album art element:', albumArtElement);
//        //console.log('🎵 Music store - album art src:', albumArtSrc);
       
//        // Create comprehensive track data
//        const trackData = {
//          title: titleText || 'Unknown Track',
//          artist: 'Unknown Artist', // You can enhance this with metafields
//          albumArt: albumArtSrc || '',
//          duration: audioElement.duration || 0,
//          element: row // Add the track element for cart functionality
//        };
       
//        //console.log('🎵 Music store - sending track data to global API:', trackData);
       
//        // Send track list to sticky player first
//        sendTrackListToStickyPlayer();
       
//        // Use global sticky player API
//        if (window.StickyAudioPlayer) {
//          window.StickyAudioPlayer.show(trackData);
//          window.StickyAudioPlayer.connect(audioElement);
//          window.StickyAudioPlayer.updatePlayPause(true);
//        } else {
//          console.warn('🎵 Global StickyAudioPlayer not available, using fallback');
//          notifyStickyPlayer(trackData, audioElement);
//          notifyPlayPause(true);
//        }
//      });
 
//      audioElement.addEventListener('pause', () => {
//        //console.log('🎵 Audio paused');
//          row.classList.remove('playing');
//          setPlayIcon(row, false);
         
//          // Clear activeRow and activePlayer if this is the active track
//          // This ensures that clicking play again will resume instead of requiring two clicks
//          if (activeRow === row) {
//            activeRow = null;
//            activePlayer = null;
//          }
         
//          // Notify sticky player about pause using global API
//          if (window.StickyAudioPlayer) {
//            window.StickyAudioPlayer.updatePlayPause(false);
//          } else {
//            notifyPlayPause(false);
//        }
//      });
 
// audioElement.addEventListener('timeupdate', () => {
// if (activeRow === row) {
// const current = row.querySelector('.tli__current');
// const currentMobile = row.querySelector('.tli__current-mobile');
// const seek = row.querySelector('.tli__seek');
// if (current && audioElement.duration && isFinite(audioElement.duration)) {
// // Show remaining time (countdown)
// const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
// current.textContent = fmt(remaining);
// }
// if (currentMobile && audioElement.duration && isFinite(audioElement.duration)) {
// // Show remaining time (countdown)
// const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
// currentMobile.textContent = fmt(remaining);
// }
// if (seek && audioElement.duration && isFinite(audioElement.duration)) {
// const progress = (audioElement.currentTime / audioElement.duration) * 1000;
// seek.value = Math.round(progress);
// // Update CSS custom property for gradient fill
// const fillWidth = (audioElement.currentTime / audioElement.duration) * 100;
// seek.style.setProperty('--value', `${fillWidth}%`);
// const seekFill = row.querySelector('.tli__seek-fill');
// if (seekFill) seekFill.style.width = `${fillWidth}%`;
// //console.log('🎵 Progress update:', audioElement.currentTime, '/', audioElement.duration, '=', progress);
// }
// }
// });
 
//  audioElement.addEventListener('ended', () => {
//  //console.log('🎵 Audio ended');
//  if (activeRow === row) {
//  row.classList.remove('playing');
//  setPlayIcon(row, false);
//  const seek = row.querySelector('.tli__seek');
//  const current = row.querySelector('.tli__current');
//  const currentMobile = row.querySelector('.tli__current-mobile');
//  if (seek) {
//  seek.value = 0;
//  seek.style.setProperty('--value', '0%');
//  }
//  const seekFill = row.querySelector('.tli__seek-fill');
//  if (seekFill) seekFill.style.width = '0%';
//  // Reset to total duration (countdown starts at full duration)
//  if (audioElement.duration && isFinite(audioElement.duration)) {
//    const totalDuration = fmt(audioElement.duration);
//    if (current) current.textContent = totalDuration;
//    if (currentMobile) currentMobile.textContent = totalDuration;
//  } else {
//    // Fallback: try to get from tli__total element
//    const totalElement = row.querySelector('.tli__total');
//    if (totalElement && current) {
//      current.textContent = totalElement.textContent.trim();
//    }
//    if (totalElement && currentMobile) {
//      currentMobile.textContent = totalElement.textContent.trim();
//    }
//  }
//  activeRow = null;
//  activePlayer = null;
//  }
//  });
 
//  audioElement.addEventListener('error', (e) => {
//  console.error('🎵 Audio error:', e);
//  // Show loading instead of error
//  const current = row.querySelector('.tli__current');
//  const currentMobile = row.querySelector('.tli__current-mobile');
//  if (current) {
//  current.textContent = 'Loading...';
//  current.classList.remove('error');
//  current.classList.add('loading');
//  }
//  if (currentMobile) {
//  currentMobile.textContent = 'Loading...';
//  }
//  });
 
//  // Try to play
//  const playPromise = audioElement.play();
//  if (playPromise) {
//    playPromise.then(() => {
//      // Enable seek bar when audio starts playing
//      const seek = row.querySelector('.tli__seek');
//      if (seek) {
//        seek.disabled = false;
//        //console.log('🎵 Seek bar enabled for:', row.querySelector('.tli__title').textContent);
//      }
//    }).catch((error) => {
//      console.error('🎵 Playback failed:', error);
//      // Show loading instead of error
//      const current = row.querySelector('.tli__current');
//      const currentMobile = row.querySelector('.tli__current-mobile');
//      if (current) {
//        current.textContent = 'Loading...';
//        current.classList.remove('error');
//        current.classList.add('loading');
//      }
//      if (currentMobile) {
//        currentMobile.textContent = 'Loading...';
//      }
//    });
//  }
//  } else {
//  // Keep checking for audio element
//  setTimeout(checkForAudio, 100);
//  }
//  };
 
//  checkForAudio();
//  } else {
//  // Show loading instead of error
//  const current = row.querySelector('.tli__current');
//  const currentMobile = row.querySelector('.tli__current-mobile');
//  if (current) {
//  current.textContent = 'Loading...';
//  current.classList.remove('error');
//  current.classList.add('loading');
//  }
//  if (currentMobile) {
//  currentMobile.textContent = 'Loading...';
//  }
//       }
//     });

//     // Simple and reliable seek interactions
//     if (seek) {
//       //console.log('🎵 Setting up seek bar for:', row.querySelector('.tli__title').textContent);
//       //console.log('🎵 Seek bar disabled?', seek.disabled);
     
//       // Make sure seek bar is enabled
//       seek.disabled = false;
     
//       // Simple input event for real-time updates
//       seek.addEventListener('input', function(e) {
//         //console.log('🎵 INPUT EVENT:', e.target.value);
       
//         // Always update the visual progress
//         const fillWidth = (Number(e.target.value) / 1000) * 100;
//         seek.style.setProperty('--value', `${fillWidth}%`);
//         const seekFill = row.querySelector('.tli__seek-fill');
//         if (seekFill) seekFill.style.width = `${fillWidth}%`;
       
//         // Update time display (show remaining time)
//         const current = row.querySelector('.tli__current');
//         const currentMobile = row.querySelector('.tli__current-mobile');
//         if ((current || currentMobile) && activeRow === row) {
//           // Check if selected media is playing this track
//           const variantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
//           const selectedMediaTrack = variantId ? document.querySelector(`.sm-track-item[data-variant-id="${variantId}"]`) : null;
//           const selectedAudio = selectedMediaTrack ? selectedMediaTrack.querySelector('audio') : null;
         
//           // Use selected media audio if available, otherwise use local audio
//           const audioElement = selectedAudio || row.querySelector('audio');
         
//           if (audioElement && audioElement.duration && isFinite(audioElement.duration)) {
//             const pct = Number(e.target.value) / 1000;
//             const t = audioElement.duration * pct;
//             const remaining = Math.max(0, audioElement.duration - t);
//             const timeStr = fmt(remaining);
//             if (current) current.textContent = timeStr;
//             if (currentMobile) currentMobile.textContent = timeStr;
//           }
//         }
//       });
     
//       // Change event for final seek
//       seek.addEventListener('change', function(e) {
//         //console.log('🎵 CHANGE EVENT:', e.target.value);
       
//         if (activeRow === row) {
//           // Check if selected media is playing this track
//           const variantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
//           const selectedMediaTrack = variantId ? document.querySelector(`.sm-track-item[data-variant-id="${variantId}"]`) : null;
//           const selectedAudio = selectedMediaTrack ? selectedMediaTrack.querySelector('audio') : null;
         
//           // Use selected media audio if available, otherwise use local audio
//           const audioElement = selectedAudio || row.querySelector('audio');
         
//           if (audioElement && audioElement.duration) {
//             const pct = Number(e.target.value) / 1000;
//             const newTime = audioElement.duration * pct;
//             audioElement.currentTime = newTime;
//             //console.log('🎵 Seeked to:', fmt(newTime), selectedAudio ? '(selected media)' : '(music library)');
//           }
//         }
//       });
     
//       // Test all possible events
//       seek.addEventListener('mousedown', () => console.log('🎵 MOUSEDOWN'));
//       seek.addEventListener('mouseup', () => console.log('🎵 MOUSEUP'));
//       seek.addEventListener('mousemove', () => console.log('🎵 MOUSEMOVE'));
//       seek.addEventListener('click', () => console.log('🎵 CLICK'));
//       seek.addEventListener('touchstart', () => console.log('🎵 TOUCHSTART'));
//       seek.addEventListener('touchend', () => console.log('🎵 TOUCHEND'));
//     }
//   });

//  // Osaria player initialization
//  //console.log('🎵 Osaria player integration ready');

//  // Function to update cart count in header
// //  function updateCartCount() {
// //    fetch('/cart.js')
// //      .then(response => response.json())
// //      .then(cart => {
// //        // Update cart count in header
// //        const cartCountElement = document.getElementById('CartCount');
// //        if (cartCountElement) {
// //          cartCountElement.querySelector('span').textContent = cart.item_count;
// //        }
       
// //        // Update cart count in any other cart elements
// //        const cartCountElements = document.querySelectorAll('.cart-count, .cart-item-count');
// //        cartCountElements.forEach(element => {
// //          element.textContent = cart.item_count;
// //        });
       
// //        //console.log('🛒 Cart count updated:', cart.item_count);
// //      })
// //      .catch(error => {
// //        console.error('❌ Failed to update cart count:', error);
// //      });
// //   }
// function updateCartCount() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {

//       let displayCount = 0;

//       cart.items.forEach((item) => {

//         const hasCustomProperty =
//           item.properties &&
//           Object.keys(item.properties).some(
//             key => key.includes('Your Name')
//           );

//         if (hasCustomProperty) {

//           // Custom Vocal Order
//           displayCount += 1;

//         } else {

//           // Normal products
//           displayCount += item.quantity;

//         }

//       });

//       // Header count
//       const cartCountElement = document.getElementById('CartCount');

//       if (cartCountElement) {
//         const span = cartCountElement.querySelector('span');

//         if (span) {
//           span.textContent = displayCount;
//         }
//       }

//       // Other cart count elements
//       const cartCountElements = document.querySelectorAll(
//         '.cart-count, .cart-item-count'
//       );

//       cartCountElements.forEach((element) => {
//         element.textContent = displayCount;
//       });

//       console.log('🛒 Display Count:', displayCount);
//     })
//     .catch(error => {
//       console.error('❌ Failed to update cart count:', error);
//     });
// }

//   // Function to check if a variant is in the cart
//   // Cache cart state to avoid redundant fetches
//   let cartCache = null;
//   let cartCacheTime = 0;
//   const CART_CACHE_DURATION = 100; // Cache for 100ms to batch rapid calls
  
//   async function isVariantInCart(variantId) {
//     try {
//       const now = Date.now();
//       // Use cache if available and recent
//       if (cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
//         return cartCache.items.some(item => item.variant_id === variantId);
//       }
//       // Fetch fresh cart data
//       const response = await fetch('/cart.js');
//       const cart = await response.json();
//       cartCache = cart;
//       cartCacheTime = now;
//       return cart.items.some(item => item.variant_id === variantId);
//     } catch (error) {
//       console.error('❌ Failed to check cart:', error);
//       return false;
//     }
//   }
  
//   // Function to invalidate cart cache
//   function invalidateCartCache() {
//     cartCache = null;
//     cartCacheTime = 0;
//   }

//   // Track last cart state for comparison
//   let lastCartState = null;
  
//   // Function to get current cart state as a string for comparison
//   async function getCartStateString() {
//     try {
//       const now = Date.now();
//       // Use cache if available and recent
//       if (cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
//         return cartCache.items.map(item => item.variant_id).sort().join(',');
//       }
//       // Fetch fresh cart data
//       const response = await fetch('/cart.js');
//       const cart = await response.json();
//       cartCache = cart;
//       cartCacheTime = now;
//       // Create a string representation of cart items (variant IDs)
//       return cart.items.map(item => item.variant_id).sort().join(',');
//     } catch (error) {
//       console.warn('Failed to get cart state:', error);
//       return null;
//     }
//   }

//   // Function to check if cart has changed and update buttons (optimized)
//   async function checkCartChanges() {
//     try {
//       // Fetch fresh cart data
//       const response = await fetch('/cart.js');
//       const cart = await response.json();
      
//       // Update cache
//       cartCache = cart;
//       cartCacheTime = Date.now();
      
//       // Check if state changed
//       const currentCartState = cart.items.map(item => item.variant_id).sort().join(',');
//       if (currentCartState !== lastCartState && currentCartState !== null) {
//         //console.log('🛒 Cart state changed, updating button states');
//         lastCartState = currentCartState;
        
//         // Update buttons using cached cart data (no additional fetch)
//         const buttons = root.querySelectorAll('.tli__add');
//         if (buttons.length > 0) {
//           const cartVariantIds = new Set(cart.items.map(item => item.variant_id));
//           buttons.forEach(btn => {
//             const variantId = Number(btn.dataset.vid);
//             if (!variantId) return;
            
//             if (!btn.dataset.originalContent) {
//               btn.dataset.originalContent = btn.innerHTML;
//             }
            
//             const isInCart = cartVariantIds.has(variantId);
//             const originalContent = btn.dataset.originalContent;
            
//             // if (isInCart) {
//             //   btn.innerHTML = `
//             //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//             //       <path d="M5 13l4 4L19 7"/>
//             //     </svg>
//             //   `;
//             //   btn.classList.add('success');
//             //   btn.dataset.inCart = 'true';
//             // } else {
//             //   btn.innerHTML = originalContent;
//             //   btn.classList.remove('success');
//             //   btn.dataset.inCart = 'false';
//             // }
//           });
//         }
        
//         updateCartCount();
//       }
//     } catch (error) {
//       console.warn('Failed to check cart changes:', error);
//     }
//   }

//   // Function to check if variant is in Selected Media
//   function isVariantInSelectedMedia(variantId) {
//     try {
//       const stored = localStorage.getItem('sm_selected_tracks');
//       if (stored) {
//         const tracks = JSON.parse(stored);
//         return tracks.some(track => Number(track.variantId) === Number(variantId));
//       }
//     } catch (e) {
//       console.warn('Failed to check Selected Media:', e);
//     }
//     return false;
//   }

//   // Function to update button state based on cart (NOT Selected Media - Selected Media tick is temporary)
//   async function updateButtonState(button, variantId) {
//     const isInCart = await isVariantInCart(variantId);
//     const originalContent = button.dataset.originalContent || button.innerHTML;
   
//     // Store original content if not already stored
//     if (!button.dataset.originalContent) {
//       button.dataset.originalContent = originalContent;
//     }
   
//     // Show red tick SVG ONLY if in cart (Selected Media items show temporary tick, not persistent)
//     // if (isInCart) {
//     //   // Show red tick SVG
//     //   button.innerHTML = `
//     //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//     //       <path d="M5 13l4 4L19 7"/>
//     //     </svg>
//     //   `;
//     //   button.classList.add('success');
//     //   button.dataset.inCart = 'true';
//     //   // Make button non-clickable when showing tick (product in cart)
//     //   button.style.pointerEvents = 'none';
//     //   button.style.cursor = 'default';
//     // } else {
//     //   // Show plus
//     //   button.innerHTML = originalContent;
//     //   button.classList.remove('success');
//     //   button.dataset.inCart = 'false';
//     //   // Re-enable button clicks when not in cart
//     //   button.style.pointerEvents = '';
//     //   button.style.cursor = '';
//     // }
//   }

//   // Function to update all add to cart buttons based on cart state (optimized - single fetch)
//   async function updateAllButtonStates() {
//     const buttons = root.querySelectorAll('.tli__add');
//     if (buttons.length === 0) return;
    
//     // Fetch cart once for all buttons
//     const now = Date.now();
//     let cart;
//     if (cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
//       cart = cartCache;
//     } else {
//       try {
//         const response = await fetch('/cart.js');
//         cart = await response.json();
//         cartCache = cart;
//         cartCacheTime = now;
//       } catch (error) {
//         console.error('Failed to fetch cart for button updates:', error);
//         return;
//       }
//     }
    
//     const cartVariantIds = new Set(cart.items.map(item => item.variant_id));
//     const originalContent = buttons[0].dataset.originalContent || buttons[0].innerHTML;
    
//     // Update all buttons in parallel using cached cart data
//     buttons.forEach(btn => {
//       const variantId = Number(btn.dataset.vid);
//       if (!variantId) return;
      
//       // Store original content if not already stored
//       if (!btn.dataset.originalContent) {
//         btn.dataset.originalContent = btn.innerHTML;
//       }
      
//       const isInCart = cartVariantIds.has(variantId);
      
//       // if (isInCart) {
//       //   // Show red tick SVG
//       //   btn.innerHTML = `
//       //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//       //       <path d="M5 13l4 4L19 7"/>
//       //     </svg>
//       //   `;
//       //   btn.classList.add('success');
//       //   btn.dataset.inCart = 'true';
//       //   // Make button non-clickable when showing tick (product in cart)
//       //   btn.style.pointerEvents = 'none';
//       //   btn.style.cursor = 'default';
//       // } else {
//       //   // Show plus
//       //   const origContent = btn.dataset.originalContent || originalContent;
//       //   btn.innerHTML = origContent;
//       //   btn.classList.remove('success');
//       //   btn.dataset.inCart = 'false';
//       //   // Re-enable button clicks when not in cart
//       //   btn.style.pointerEvents = '';
//       //   btn.style.cursor = '';
//       // }
//     });
    
//     // Also update sticky player cart button if there's a current track (using cached cart data)
//     if (window.StickyAudioPlayer && window.StickyAudioPlayer.getCurrentTrack) {
//       const currentTrack = window.StickyAudioPlayer.getCurrentTrack();
//       if (currentTrack && currentTrack.element) {
//         const addBtn = currentTrack.element.querySelector('.tli__add');
//         if (addBtn) {
//           const variantId = Number(addBtn.dataset.vid);
//           if (variantId) {
//             // Use cached cart data instead of fetching
//             const isInCart = cartVariantIds.has(variantId);
            
//             // Update add button if not already updated
//             if (!addBtn.dataset.originalContent) {
//               addBtn.dataset.originalContent = addBtn.innerHTML;
//             }
            
//             // if (isInCart) {
//             //   addBtn.innerHTML = `
//             //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//             //       <path d="M5 13l4 4L19 7"/>
//             //     </svg>
//             //   `;
//             //   addBtn.classList.add('success');
//             //   addBtn.dataset.inCart = 'true';
//             // } else {
//             //   addBtn.innerHTML = addBtn.dataset.originalContent;
//             //   addBtn.classList.remove('success');
//             //   addBtn.dataset.inCart = 'false';
//             // }
            
//             // Update sticky player button to match (using cached data)
//             const stickyCartBtn = document.getElementById('sap-cart');
//             if (stickyCartBtn) {
//               // if (isInCart) {
//               //   stickyCartBtn.innerHTML = `
//               //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//               //       <path d="M5 13l4 4L19 7"/>
//               //     </svg>
//               //   `;
//               //   stickyCartBtn.classList.add('success');
//               // } else {
//               //   stickyCartBtn.innerHTML = `
//               //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//               //       <path d="M12 5v14M5 12h14"/>
//               //     </svg>
//               //   `;
//               //   stickyCartBtn.classList.remove('success');
//               // }
//             }
//           }
//         }
//       }
//     }
//   }

//   // AJAX Add to Cart with enhanced feedback
//   root.querySelectorAll('.tli__add').forEach(btn => {
//     // Store original content
//     if (!btn.dataset.originalContent) {
//       btn.dataset.originalContent = btn.innerHTML;
//     }
   
//     // Shared handler function for both click and touch events
//     let isHandling = false; // Flag to prevent double-triggering
    
//     const handleAddButton = async (e) => {
//       //console.log('🎵 handleAddButton called', { isHandling, disabled: btn.disabled });
     
//       // Prevent double-triggering
//       if (isHandling) {
//         //console.log('🎵 Already handling, skipping');
//         return;
//       }
//       isHandling = true;
     
//       // Prevent music playback when clicking/tapping add button
//       if (e && e.stopPropagation) e.stopPropagation();
//       if (e && e.preventDefault) e.preventDefault();
     
//       if (btn.disabled) {
//         //console.log('🎵 Button disabled, skipping');
//         isHandling = false;
//         return;
//       }
     
//       const variantId = Number(btn.dataset.vid);
//       const isCurrentlyInCart = btn.dataset.inCart === 'true';
//       const trackItem = btn.closest('.track-list-item');
     
//       // If product is already in cart, prevent removing it from music-store-section
//       // The tick should only disappear when product is removed from cart drawer or elsewhere
//       if (isCurrentlyInCart) {
//         //console.log('🎵 Product already in cart - button is ticked and cannot be unticked from music-store-section');
//         isHandling = false;
//         return;
//       }
     
//       // Check if Selected Media section exists on the page
//       const selectedMediaSection = document.querySelector('.sm-wrap');
     
//       if (selectedMediaSection && !isCurrentlyInCart) {
//         // Send track to Selected Media section instead of adding directly to cart
//         const titleEl = trackItem.querySelector('.tli__title');
//         const title = titleEl ? titleEl.textContent.trim() : 'Unknown Track';
       
//         const thumbnailEl = trackItem.querySelector('.tli__cover img');
//         const thumbnail = thumbnailEl ? thumbnailEl.src : '';
       
//         // Try to get duration from .tli__total (total duration) only
//         // Don't use .tli__current-mobile as it shows current time (0:00) not total duration
//         const durationEl = trackItem.querySelector('.tli__total');
//         let duration = durationEl ? durationEl.textContent.trim() : '';
       
//         // If duration is still empty or "0:00", try to get from audio element
//         if (!duration || duration === '0:00') {
//           const audioEl = trackItem.querySelector('audio');
//           if (audioEl && audioEl.duration && isFinite(audioEl.duration) && audioEl.duration > 0) {
//             const m = Math.floor(audioEl.duration / 60);
//             const s = Math.floor(audioEl.duration % 60).toString().padStart(2, '0');
//             duration = `${m}:${s}`;
//           }
//         }
       
//         const priceEl = trackItem.querySelector('.tli__price-current');
//         const price = priceEl ? priceEl.textContent.trim() : '';
       
//         // Extract chips/tags
//         const chipEls = trackItem.querySelectorAll('.tli__chip');
//         const chips = Array.from(chipEls).map(chip => chip.textContent.trim()).filter(Boolean);
       
//         // Get product ID from data attribute
//         const productId = trackItem.dataset.productId ? Number(trackItem.dataset.productId) : null;
//         const product_type = trackItem.getAttribute("data-product-type");
//         const productType = product_type || null;

//         console.log("productType",productType)

//         // Get product handle from product link (for proper cart identification)
//         let productHandle = null;
//         const productLink = trackItem.querySelector('a[href*="/products/"]');
//         if (productLink && productLink.href) {
//           const urlMatch = productLink.href.match(/\/products\/([^\/\?#]+)/);
//           if (urlMatch && urlMatch[1]) {
//             productHandle = urlMatch[1];
//             //console.log('🎵 Music Store - Extracted product handle:', productHandle);
//           }
//         }
       
//         if (!productHandle) {
//           console.warn('🎵 Music Store - Could not extract product handle from track item');
//         }



//         // Get Osaria audio data from data attribute (CRITICAL for playback)
//         // Try multiple ways to get the data attribute
//         let osariaAudioData = trackItem.dataset.productOsariaAudioData ||
//                               trackItem.getAttribute('data-product-osaria-audio-data') ||
//                               '';
       
//         // If still empty, try to get from the Osaria player div
//         if (!osariaAudioData || osariaAudioData === '') {
//           const osariaPlayerDiv = trackItem.querySelector('.osaria-player-custom-product-view');
//           if (osariaPlayerDiv) {
//             osariaAudioData = osariaPlayerDiv.dataset.productOsariaAudioData ||
//                              osariaPlayerDiv.getAttribute('data-product-osaria-audio-data') ||
//                              '';
//           }
//         }
       
//         //console.log('🎵 Music Library - Preparing track for Selected Media:', {
//         //   variantId: variantId,
//         //   title: title,
//         //   hasOsariaData: !!osariaAudioData,
//         //   osariaDataLength: osariaAudioData ? osariaAudioData.length : 0,
//         //   osariaDataPreview: osariaAudioData ? osariaAudioData.substring(0, 50) + '...' : 'missing',
//         //   trackItemHasAttribute: trackItem.hasAttribute('data-product-osaria-audio-data'),
//         //   datasetValue: trackItem.dataset.productOsariaAudioData
//         // });
       
//         // Create track data object
//         const trackData = {
//           variantId: variantId,
//           productId: productId,
//           productHandle: productHandle,
//           title: title,
//           thumbnail: thumbnail,
//           duration: duration,
//           price: price,
//           chips: chips,
//           osariaAudioData: osariaAudioData,
//           productType:productType,
//         };
       
//         //console.log('🎵 Music Library - Sending track to Selected Media:', {
//         //   ...trackData,
//         //   osariaAudioData: osariaAudioData ? `present (${osariaAudioData.length} chars)` : 'MISSING'
//         // });
       
//         // Dispatch event to Selected Media section
//         const event = new CustomEvent('addTrackToSelected', {
//           detail: trackData
//         });
       
//         //console.log('🎵 Music Library - Dispatching addTrackToSelected event:', {
//         //   variantId: trackData.variantId,
//         //   productId: trackData.productId,
//         //   title: trackData.title
//         // });
       
//         // Dispatch event synchronously to ensure validation message can show immediately
//         document.dispatchEvent(event);
       
//         //console.log('🎵 Music Library - Event dispatched');
       
//         // Immediate optimistic update - show tick right away
//         const originalHTML = btn.innerHTML;
//         btn.innerHTML = `
//           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//             <path d="M5 13l4 4L19 7"/>
//           </svg>
//         `;
//         btn.classList.add('success');
        
//         // Check for validation message in next frame (immediate check)
//         requestAnimationFrame(() => {
//           const validationMsg = document.querySelector('#smValidationMessage');
//           const isValidationShowing = validationMsg &&
//             (validationMsg.style.display === 'flex' ||
//              validationMsg.style.visibility === 'visible' ||
//              validationMsg.classList.contains('show') ||
//              window.getComputedStyle(validationMsg).display === 'flex');
         
//           if (isValidationShowing) {
//             // Validation message showing - revert immediately
//             btn.innerHTML = originalHTML;
//             btn.classList.remove('success');
//             isHandling = false;
//             return;
//           }
         
//           // Show tick temporarily, then restore to "+" (not persistent for Selected Media)
//           setTimeout(() => {
//             btn.innerHTML = originalHTML;
//             btn.classList.remove('success');
//             // Check if item is in cart - if so, show tick via updateButtonState
//             updateButtonState(btn, variantId);
//             isHandling = false; // Reset flag to allow future clicks
//           }, 1500); // Show tick for 1.5 seconds then restore
//         });
       
//         return; // Exit early, don't add to cart directly
//       }
     
//       // Original cart functionality if Selected Media section doesn't exist
//       // Note: This code should never run if isCurrentlyInCart is true due to early return above
//       const originalContent = btn.dataset.originalContent || btn.innerHTML;
      
//       // Optimistic UI update - show immediate visual feedback (only for adding, not removing)
//       // Optimistically show red tick immediately when adding
//       btn.innerHTML = `
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//           <path d="M5 13l4 4L19 7"/>
//         </svg>
//       `;
//       btn.classList.add('success');
//       btn.dataset.inCart = 'true';
//       // Make button non-clickable when showing tick
//       btn.style.pointerEvents = 'none';
//       btn.style.cursor = 'default';
      
//       btn.disabled = true;
     
//       // try {
//       //   // Only handle adding to cart (removal is prevented by early return above)
//       //   // Add to cart
//       //   const res = await fetch('/cart/add.js', {
//       //     method: 'POST',
//       //     headers: {
//       //       'Content-Type': 'application/json',
//       //       'Accept': 'application/json',
//       //       'X-Requested-With': 'XMLHttpRequest'
//       //     },
//       //     body: JSON.stringify({ id: variantId, quantity: 1 })
//       //   });
       
//       //   if (!res.ok) {
//       //     const errorData = await res.json().catch(() => ({}));
//       //     throw new Error(errorData.message || 'Failed to add to cart');
//       //   }
        
//       //   // Use response cart data instead of fetching again
//       //   const updatedCart = await res.json();
       
//       //   // Update cache and state from response (no additional fetch needed)
//       //   cartCache = updatedCart;
//       //   cartCacheTime = Date.now();
//       //   const newCartState = updatedCart.items.map(item => item.variant_id).sort().join(',');
//       //   lastCartState = newCartState;
       
//       //   // Update cart count in header
//       //   updateCartCount();
       
//       //   // Update this button's state to reflect actual cart state
//       //   await updateButtonState(btn, variantId);
       
//       //   // Dispatch cart:updated event to notify other listeners
//       //   document.dispatchEvent(new CustomEvent('cart:updated', {
//       //     bubbles: true,
//       //     detail: { source: 'music-store-button' }
//       //   }));
       
//       //   // Update sticky player button if this is the current track
//       //   if (trackItem && window.StickyAudioPlayer && window.StickyAudioPlayer.updateCartButton) {
//       //     const currentTrack = window.StickyAudioPlayer.getCurrentTrack();
//       //     if (currentTrack && currentTrack.element === trackItem) {
//       //       // Use sticky player's update method
//       //       window.StickyAudioPlayer.updateCartButton();
//       //     }
//       //   }
       
//       //   btn.disabled = false;
//       //   isHandling = false; // Reset flag immediately
       
//       // } catch (e) {
//       //   console.error('Add to cart error:', e);
//       //   // Revert optimistic update on error
//       //   await updateButtonState(btn, variantId);
//       //   btn.classList.remove('error');
//       //   btn.disabled = false;
//       //   isHandling = false; // Reset flag immediately
//       // }

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: JSON.stringify({
//             id: variantId,
//             quantity: 1
//           })
//         });

//         console.log("reseeeeeeeeeeeeeeeeeeeeeeeee",res)

//         if (!res.ok) {
//           const errorData = await res.json().catch(() => ({}));
//           throw new Error(errorData.message || 'Failed to add to cart');
//         }

//         // /cart/add.js returns added item, not full cart
//         const addedItem = await res.json();
//         console.log('Added item:', addedItem);

//         // latest full cart fetch
//         const updatedCart = await fetch('/cart.js', {
//           cache: 'no-store'
//         }).then(res => res.json());

//         console.log('Updated cart:', updatedCart);

//         cartCache = updatedCart;
//         cartCacheTime = Date.now();

//         const newCartState = Array.isArray(updatedCart.items)
//           ? updatedCart.items.map(item => item.variant_id).sort().join(',')
//           : '';

//         lastCartState = newCartState;

//         // Update cart count in header
//         if (typeof updateCartCount === 'function') {
//           updateCartCount(updatedCart);
//         }

//         // Update this button's state
//         await updateButtonState(btn, variantId);

//         // Notify cart drawer
//         document.dispatchEvent(
//           new CustomEvent('cart:updated', {
//             bubbles: true,
//             detail: {
//               source: 'music-store-button',
//               cart: updatedCart
//             }
//           })
//         );

//         // Also notify content refresh listeners
//         document.dispatchEvent(
//           new CustomEvent('cart:content:refreshed', {
//             bubbles: true,
//             detail: {
//               cart: updatedCart
//             }
//           })
//         );

//         if (
//           trackItem &&
//           window.StickyAudioPlayer &&
//           window.StickyAudioPlayer.updateCartButton
//         ) {
//           const currentTrack = window.StickyAudioPlayer.getCurrentTrack();

//           if (currentTrack && currentTrack.element === trackItem) {
//             window.StickyAudioPlayer.updateCartButton();
//           }
//         }

//         btn.disabled = false;
//         isHandling = false;
//       } catch (e) {
//         console.error('Add to cart error:', e);

//         await updateButtonState(btn, variantId);

//         btn.classList.remove('error');
//         btn.disabled = false;
//         isHandling = false;
//       }
//     };
   
//     // Simple approach: Use both click and touch for maximum compatibility
//     // On mobile, touch events fire first, then click fires ~300ms later
//     // We'll handle both but prevent double-triggering
   
//     let lastTriggerTime = 0;
//     const TRIGGER_COOLDOWN = 500; // ms
   
//     const triggerHandler = (e) => {
//       const now = Date.now();
//       // Prevent rapid double-triggers
//       if (now - lastTriggerTime < TRIGGER_COOLDOWN) {
//         return;
//       }
//       lastTriggerTime = now;
     
//       // Stop propagation to prevent row handler
//       if (e && e.stopPropagation) e.stopPropagation();
//       if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
     
//       // Call the handler
//       handleAddButton(e);
//     };
   
//     // Handle click events (works on both desktop and mobile)
//     btn.addEventListener('click', (e) => {
//       // On mobile, click fires after touch, so we check if touch already handled it
//       const timeSinceLastTrigger = Date.now() - lastTriggerTime;
//       if (timeSinceLastTrigger < 300) {
//         // Touch likely already handled it, skip click
//         return;
//       }
//       triggerHandler(e);
//     });
   
//     // Handle touch events for mobile (fires before click)
//     btn.addEventListener('touchend', (e) => {
//       // Stop propagation immediately
//       if (e && e.stopPropagation) e.stopPropagation();
//       if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
     
//       // Prevent default to stop click from also firing
//       if (e && e.preventDefault) e.preventDefault();
     
//       // Trigger handler immediately
//       triggerHandler(e);
//     }, { passive: false, capture: true });
//   });
 
//   // Initialize button states on page load
//   updateAllButtonStates();

//   // Initialize cart state tracking
//   getCartStateString().then(state => {
//     lastCartState = state;
//   });

//   // Listen for cart updates
//   document.addEventListener('cart:updated', () => {
//     //console.log('🛒 Cart updated event received, refreshing button states');
//     updateAllButtonStates();
//     updateCartCount();
//     // Update tracked state
//     getCartStateString().then(state => {
//       lastCartState = state;
//     });
//   });

//   // Also listen for custom cart events
//   window.addEventListener('cartUpdated', () => {
//     //console.log('🛒 Cart updated (custom event), refreshing button states');
//     updateAllButtonStates();
//     updateCartCount();
//     // Update tracked state
//     getCartStateString().then(state => {
//       lastCartState = state;
//     });
//   });

//   // Listen for cart:change event (Shopify cart drawer)
//   document.addEventListener('cart:change', () => {
//     //console.log('🛒 Cart change event received, refreshing button states');
//     // Immediate update
//     updateAllButtonStates();
//     updateCartCount();
//     getCartStateString().then(state => {
//       lastCartState = state;
//     });
//   });

//   // Listen for cart drawer content refresh (when items are added/removed)
//   document.addEventListener('cart:content:refreshed', () => {
//     //console.log('🛒 Cart content refreshed, updating button states');
//     // Clear cart cache to force fresh fetch
//     cartCache = null;
//     cartCacheTime = 0;
//     // Update all button states
//     updateAllButtonStates();
//     updateCartCount();
//     getCartStateString().then(state => {
//       lastCartState = state;
//     });
//   });

//   // Listen for cart drawer open/close events
//   document.addEventListener('cart:drawer:open', () => {
//     //console.log('🛒 Cart drawer opened, will check for changes');
//   });

//   document.addEventListener('cart:drawer:close', () => {
//     //console.log('🛒 Cart drawer closed, checking for changes');
//     checkCartChanges(); // Immediate check
//   });

//   // Poll for cart changes every 5 seconds (as backup - reduced frequency)
//   setInterval(() => {
//     checkCartChanges();
//   }, 5000);

//   // Also check when window regains focus (user might have removed items in another tab)
//   window.addEventListener('focus', () => {
//     //console.log('🛒 Window focused, checking cart changes');
//     checkCartChanges();
//     // Also update button states to sync with Selected Media changes
//     updateAllButtonStates();
//   });

//   // Track Selected Media localStorage for changes
//   let lastSelectedMediaState = null;
  
//   function getSelectedMediaState() {
//     try {
//       const stored = localStorage.getItem('sm_selected_tracks');
//       return stored || '';
//     } catch (e) {
//       return '';
//     }
//   }
  
//   function checkSelectedMediaChanges() {
//     const currentState = getSelectedMediaState();
//     if (currentState !== lastSelectedMediaState) {
//       //console.log('🎵 Selected Media changed, updating button states');
//       lastSelectedMediaState = currentState;
//       updateAllButtonStates();
//     }
//   }
  
//   // Initialize Selected Media state
//   lastSelectedMediaState = getSelectedMediaState();
  
//   // Listen for storage events (fires when localStorage changes in other tabs/windows)
//   window.addEventListener('storage', (e) => {
//     if (e.key === 'sm_selected_tracks') {
//       //console.log('🎵 Selected Media storage event detected, updating button states');
//       lastSelectedMediaState = e.newValue || '';
//       updateAllButtonStates();
//     }
//   });
  
//   // Poll for Selected Media changes (for same-window changes) - reduced frequency
//   setInterval(() => {
//     checkSelectedMediaChanges();
//   }, 2000);

//   // Watch for cart drawer changes using MutationObserver
//   const cartDrawer = document.querySelector('cart-drawer-component') || document.querySelector('[id*="cart-drawer"]');
//   if (cartDrawer) {
//     const cartObserver = new MutationObserver(() => {
//       // When cart drawer content changes, check for cart updates immediately
//       checkCartChanges();
//     });
    
//     // Observe cart drawer for changes
//     cartObserver.observe(cartDrawer, {
//       childList: true,
//       subtree: true,
//       attributes: false
//     });
    
//     //console.log('🛒 Cart drawer observer set up');
//   }

//   // Listen for cart item removal events (common Shopify pattern)
//   document.addEventListener('cart:item:removed', () => {
//     //console.log('🛒 Cart item removed event received');
//     checkCartChanges(); // Immediate update
//   });

//   // Listen for any cart-related mutations in the document
//   const documentObserver = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       // Check if cart-related elements changed
//       if (mutation.target && (
//         mutation.target.classList?.contains('cart-item') ||
//         mutation.target.closest?.('.cart-item') ||
//         mutation.target.closest?.('cart-drawer-component') ||
//         mutation.target.closest?.('cart-items-component')
//       )) {
//         checkCartChanges(); // Immediate update
//       }
//     });
//   });

//   // Observe document body for cart-related changes
//   documentObserver.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // Keyboard navigation support
//   root.addEventListener('keydown', (e) => {
//     if (e.target.classList.contains('tli__playbtn') && (e.key === 'Enter' || e.key === ' ')) {
//       e.preventDefault();
//       e.target.click();
//     }
   
//     // Support keyboard navigation for entire track items
//     if (e.target.classList.contains('track-list-item') && (e.key === 'Enter' || e.key === ' ')) {
//       e.preventDefault();
//       const playBtn = e.target.querySelector('.tli__playbtn');
//       if (playBtn) {
//         playBtn.click();
//       }
//     }
//   });

// // Function to notify sticky player about track changes
// // Function to build track list from all visible tracks
// const buildTrackList = () => {
//   const trackItems = document.querySelectorAll('.track-list-item');
//   const trackList = [];
 
//   trackItems.forEach((item, index) => {
//     const title = item.querySelector('.tli__title')?.textContent?.trim() || 'Unknown Track';
//     const albumArt = item.querySelector('.tli__cover img')?.src || '';
//     const artist = 'Unknown Artist'; // You can add artist metafield if available
   
//     trackList.push({
//       title,
//       artist,
//       albumArt,
//       element: item,
//       index: index
//     });
//   });
 
//   return trackList;
// };

// // Function to send track list to sticky player
// const sendTrackListToStickyPlayer = () => {
//   const trackList = buildTrackList();
//   //console.log('🎵 Sending track list to sticky player:', trackList);
 
//   if (window.StickyAudioPlayer && window.StickyAudioPlayer.setTrackList) {
//     window.StickyAudioPlayer.setTrackList(trackList);
//   }
// };

// const notifyStickyPlayer = (trackData, audioElement) => {
//   //console.log('🎵 Notifying sticky player:', trackData);
//   //console.log('🎵 StickyAudioPlayer available:', !!window.StickyAudioPlayer);
 
//   // Send track list to sticky player
//   sendTrackListToStickyPlayer();
 
//   // Try direct API call first
//   if (window.StickyAudioPlayer && window.StickyAudioPlayer.show) {
//     //console.log('🎵 Using direct API call');
//     //console.log('🎵 Calling StickyAudioPlayer.show with:', trackData);
//     window.StickyAudioPlayer.show(trackData);
//     if (audioElement) {
//       window.StickyAudioPlayer.connect(audioElement);
//     }
//   } else {
//     //console.log('🎵 StickyAudioPlayer not available, using event');
//   }
 
//   // Also dispatch custom event for sticky player
//   const event = new CustomEvent('trackChanged', {
//     detail: { trackData, audioElement }
//   });
//   document.dispatchEvent(event);
//   //console.log('🎵 Custom event dispatched');
// };

// // Function to notify sticky player about play/pause
// const notifyPlayPause = (isPlaying) => {
//   //console.log('🎵 Notifying play/pause:', isPlaying);
 
//   // Try direct API call first
//   if (window.StickyAudioPlayer) {
//     window.StickyAudioPlayer.updatePlayPause(isPlaying);
//   }
 
//   // Also dispatch custom event
//   const event = new CustomEvent('trackPlayPause', {
//     detail: { isPlaying }
//   });
//   document.dispatchEvent(event);
// };

//   // Cleanup on page unload
//   window.addEventListener('beforeunload', () => {
//   if (activeRow) {
//     const audioElement = activeRow.querySelector('audio');
//     if (audioElement) {
//       audioElement.pause();
//     }
//     }
//   });

//   // Sticky Audio Player JavaScript
//   (() => {
//     const stickyPlayer = document.getElementById('sticky-player');
//     const albumArt = document.getElementById('sap-album-art');
//     const title = document.getElementById('sap-title');
//     const currentTime = document.getElementById('sap-current-time');
//     const totalTime = document.getElementById('sap-total-time');
//     const progressFill = document.getElementById('sap-progress-fill');
//     const progressThumb = document.getElementById('sap-progress-thumb');
//     const playPauseBtn = document.getElementById('sap-play-pause');
//     const prevBtn = document.getElementById('sap-prev');
//     const nextBtn = document.getElementById('sap-next');
//     const cartBtn = document.getElementById('sap-cart');
//     const closeBtn = document.getElementById('sap-close');
//     const progressBar = document.querySelector('.sap__progress-bar');

//     let currentTrack = null;
//     let audioElement = null;
//     let isPlaying = false;
//     let trackList = [];
//     let currentTrackIndex = -1;

//     // Move sticky player to body to avoid transform context issues
//     if (stickyPlayer && stickyPlayer.parentNode !== document.body) {
//       document.body.appendChild(stickyPlayer);
//       //console.log('🎵 Moved sticky player to body from music store');
//     }

//     // Initialize player as hidden
//     stickyPlayer.classList.add('idle');
//     document.body.classList.remove('player-active');
   
//     // Force positioning to viewport bottom
//     const forceBottomPosition = () => {
//       stickyPlayer.style.position = 'fixed';
//       stickyPlayer.style.bottom = '0';
//       stickyPlayer.style.left = '0';
//       stickyPlayer.style.right = '0';
//       stickyPlayer.style.width = '100%';
//       stickyPlayer.style.zIndex = '99999';
//       stickyPlayer.style.margin = '0';
     
//       // Don't override transform - let CSS classes handle it
//     };
   
//     // Apply positioning immediately
//     forceBottomPosition();
   
//     // Reapply on window events
//     window.addEventListener('load', forceBottomPosition);
//     window.addEventListener('resize', forceBottomPosition);
//     window.addEventListener('scroll', forceBottomPosition);

//     // Format time helper - returns mm:ss format
//     const formatTime = (seconds) => {
//       if (!isFinite(seconds) || seconds < 0) return '00:00';
//       const m = Math.floor(seconds / 60);
//       const s = Math.floor(seconds % 60).toString().padStart(2, '0');
//       const mm = m.toString().padStart(2, '0');
//       return `${mm}:${s}`;
//     };

//     // Update progress bar
//     const updateProgress = () => {
//       if (!audioElement || !isFinite(audioElement.duration)) return;
     
//       const progress = (audioElement.currentTime / audioElement.duration) * 100;
//       progressFill.style.width = `${progress}%`;
//       progressThumb.style.left = `${progress}%`;
//       currentTime.textContent = formatTime(audioElement.currentTime);
     
//       // Also update the track list item's progress bar if it exists
//       if (currentTrack && currentTrack.element) {
//         const trackElement = currentTrack.element;
//         const seek = trackElement.querySelector('.tli__seek');
//         const seekFill = trackElement.querySelector('.tli__seek-fill');
//         const current = trackElement.querySelector('.tli__current');
//         const currentMobile = trackElement.querySelector('.tli__current-mobile');
       
//         if (seek && audioElement.duration && isFinite(audioElement.duration)) {
//           const progressValue = (audioElement.currentTime / audioElement.duration) * 1000;
//           seek.value = Math.round(progressValue);
//           const fillWidth = (audioElement.currentTime / audioElement.duration) * 100;
//           seek.style.setProperty('--value', `${fillWidth}%`);
//           if (seekFill) {
//             seekFill.style.width = `${fillWidth}%`;
//           }
//         }
       
//         // Update time display (remaining time countdown)
//         if (current && audioElement.duration && isFinite(audioElement.duration)) {
//           const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
//           const m = Math.floor(remaining / 60);
//           const s = Math.floor(remaining % 60).toString().padStart(2, '0');
//           current.textContent = `${m}:${s}`;
//         }
//         if (currentMobile && audioElement.duration && isFinite(audioElement.duration)) {
//           const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
//           const m = Math.floor(remaining / 60);
//           const s = Math.floor(remaining % 60).toString().padStart(2, '0');
//           currentMobile.textContent = `${m}:${s}`;
//         }
//       }
//     };

//     // Update play/pause button
//     const updatePlayPause = (playing) => {
//       isPlaying = playing;
     
//       // Update main play/pause button using class toggle
//       if (playing) {
//         playPauseBtn.classList.add('playing');
//         // Ensure player stays in playing state
//         stickyPlayer.classList.remove('idle');
//         stickyPlayer.classList.add('playing');
//       } else {
//         playPauseBtn.classList.remove('playing');
//         // If no track is loaded, return to idle state
//         if (!currentTrack) {
//           stickyPlayer.classList.remove('playing');
//           stickyPlayer.classList.add('idle');
//         }
//       }
     
//       // Also update the track list item's icon if it exists
//       if (currentTrack && currentTrack.element) {
//         const trackElement = currentTrack.element;
//         if (playing) {
//           trackElement.classList.add('playing');
//           // Use setPlayIcon if available in scope, otherwise update manually
//           const playIcon = trackElement.querySelector('.icon-play');
//           const pauseIcon = trackElement.querySelector('.icon-pause');
//           if (playIcon) playIcon.style.display = 'none';
//           if (pauseIcon) pauseIcon.style.display = 'block';
//           trackElement.classList.add('showing-pause');
//         } else {
//           trackElement.classList.remove('playing');
//           trackElement.classList.remove('showing-pause');
//           const playIcon = trackElement.querySelector('.icon-play');
//           const pauseIcon = trackElement.querySelector('.icon-pause');
//           if (playIcon) playIcon.style.display = 'block';
//           if (pauseIcon) pauseIcon.style.display = 'none';
//         }
//       }
//     };

//     // Show player with track data
//     const showPlayer = (trackData) => {
//       //console.log('🎵 Showing player for track:', trackData);
//       //console.log('🎵 Track data type:', typeof trackData);
//       //console.log('🎵 Track data keys:', trackData ? Object.keys(trackData) : 'null');
     
//       if (!trackData) {
//         console.error('🎵 No track data provided to showPlayer');
//         return;
//       }
     
//       currentTrack = trackData;
     
//       // Update track info with proper fallbacks
//       if (trackData.albumArt) {
//         albumArt.src = trackData.albumArt;
//         albumArt.alt = trackData.title;
//       }
     
//       // Ensure we have proper track information with multiple fallbacks
//       let displayTitle = 'No track selected';
     
//       if (trackData.title && trackData.title.trim()) {
//         displayTitle = trackData.title.trim();
//       } else if (currentTrack && currentTrack.title && currentTrack.title.trim()) {
//         displayTitle = currentTrack.title.trim();
//       }
     
//       title.textContent = displayTitle;
     
//       //console.log('🎵 Final display values:', {
//       //   title: displayTitle,
//       //   albumArt: trackData.albumArt,
//       //   originalTitle: trackData.title
//       // });
     
//       // Update current track index if we have a track list
//       if (trackList.length > 0) {
//         const trackIndex = trackList.findIndex(track => track.title === trackData.title);
//         if (trackIndex !== -1) {
//           currentTrackIndex = trackIndex;
//           //console.log('🎵 Updated current track index to:', currentTrackIndex);
//         }
//       }
     
//       // Update total time from trackData if available
//       if (trackData.duration && trackData.duration > 0) {
//         totalTime.textContent = formatTime(trackData.duration);
//       }
     
//       // Show the player and add body class for spacing
//       stickyPlayer.classList.remove('idle');
//       stickyPlayer.classList.add('playing');
//       document.body.classList.add('player-active');
//     };

//     // Hide player
//     const hidePlayer = () => {
//       stickyPlayer.classList.remove('playing');
//       stickyPlayer.classList.add('idle');
//       document.body.classList.remove('player-active');
//       currentTrack = null;
//       audioElement = null;
//       isPlaying = false;
//     };

//     // Function to update total time display
//     const updateTotalTime = (audio) => {
//       if (audio && audio.duration && isFinite(audio.duration) && audio.duration > 0) {
//         totalTime.textContent = formatTime(audio.duration);
//         return true; // Duration updated
//       }
//       return false; // Duration not available yet
//     };
   
//     // Connect to audio element
//     // Note: This connects sticky player to the audio element without interfering
//     // with existing event listeners in music store or selected media sections.
//     // The audio events (play/pause) will automatically trigger handlers in both sections.
//     const connectToAudio = (audio) => {
//       //console.log('🎵 Connecting to audio element:', audio);
     
//       // Disconnect from previous audio element if any
//       if (audioElement && audioElement !== audio) {
//         // Remove our listeners from previous audio (if needed)
//         // Note: We don't remove other listeners as they're needed by their sections
//       }
     
//       audioElement = audio;
     
//       // Set up audio event listeners for sticky player
//       // These are in addition to existing listeners, not replacing them
//       audio.addEventListener('timeupdate', updateProgress);
//       audio.addEventListener('play', () => {
//         updatePlayPause(true);
//         // Audio play event will also trigger handlers in music store/selected media
//         // The handlers in those sections will update their UI automatically
//         //console.log('🎵 Sticky player - Audio play event fired, sections should update automatically');
//       });
//       audio.addEventListener('pause', () => {
//         updatePlayPause(false);
//         // Audio pause event will also trigger handlers in music store/selected media
//         // The handlers in those sections will update their UI automatically
//         //console.log('🎵 Sticky player - Audio pause event fired, sections should update automatically');
//       });
//       audio.addEventListener('ended', () => {
//         updatePlayPause(false);
//         hidePlayer();
//       });
     
//       // Listen for loadedmetadata event to get duration when available
//       audio.addEventListener('loadedmetadata', () => {
//         //console.log('🎵 Sticky player - loadedmetadata, duration:', audio.duration);
//         updateTotalTime(audio);
//       });
     
//       // Listen for durationchange event
//       audio.addEventListener('durationchange', () => {
//         //console.log('🎵 Sticky player - durationchange, duration:', audio.duration);
//         updateTotalTime(audio);
//       });
     
//       // Try to update total time immediately if available
//       if (!updateTotalTime(audio)) {
//         // If duration not available, check periodically (up to 5 seconds)
//         let durationCheckAttempts = 0;
//         const maxDurationChecks = 50; // 5 seconds (50 * 100ms)
//         const checkDuration = () => {
//           if (updateTotalTime(audio) || durationCheckAttempts >= maxDurationChecks) {
//             return; // Stop checking
//           }
//           durationCheckAttempts++;
//           setTimeout(checkDuration, 100);
//         };
//         setTimeout(checkDuration, 100);
//       }
//     };

//     // Set track list from music library
//     const setTrackList = (tracks) => {
//       //console.log('🎵 Setting track list:', tracks);
//       trackList = tracks;
     
//       // Find current track index
//       if (currentTrack) {
//         currentTrackIndex = trackList.findIndex(track =>
//           track.title === currentTrack.title
//         );
//         if (currentTrackIndex === -1) {
//           currentTrackIndex = 0;
//         }
//       } else {
//         currentTrackIndex = 0;
//       }
     
//       //console.log('🎵 Current track index set to:', currentTrackIndex);
//     };

//     // Play next track
//       const playNextTrack = () => {
//         // Check if current track is from cart drawer
//         const isFromCartDrawer = currentTrack && currentTrack.element && 
//                                  (currentTrack.element.classList.contains('cart-item-card') ||
//                                   currentTrack.element.closest('.cart-item-card') ||
//                                   currentTrack.element.closest('cart-drawer-component'));
        
//         if (isFromCartDrawer) {
//           // Navigate through cart items
//           const cartWrapper = document.querySelector('.cart-items__wrapper');
//           if (!cartWrapper) return;
          
//           const cartItems = Array.from(cartWrapper.querySelectorAll('.cart-item-card[data-product-osaria-audio-data]'));
//           if (cartItems.length === 0) return;
          
//           // Find current cart item index
//           const currentCartItem = currentTrack.element.classList.contains('cart-item-card') 
//             ? currentTrack.element 
//             : currentTrack.element.closest('.cart-item-card');
          
//           if (!currentCartItem) return;
          
//           const currentCartIndex = cartItems.indexOf(currentCartItem);
//           if (currentCartIndex === -1) return;
          
//           // Stop current track
//           if (audioElement && !audioElement.paused) {
//             audioElement.pause();
//           }
//           if (currentCartItem) {
//             currentCartItem.classList.remove('playing');
//             const playIcon = currentCartItem.querySelector('.icon-play');
//             const pauseIcon = currentCartItem.querySelector('.icon-pause');
//             if (playIcon) playIcon.style.display = 'block';
//             if (pauseIcon) pauseIcon.style.display = 'none';
//           }
          
//           // Get next cart item (wrap around)
//           const nextCartIndex = (currentCartIndex + 1) % cartItems.length;
//           const nextCartItem = cartItems[nextCartIndex];
          
//           // Click the play button on the next cart item
//           // Wait a bit to ensure current track is fully stopped and audio is ready
//           setTimeout(() => {
//             const nextPlayButton = nextCartItem.querySelector('.cart-item-card__playbtn');
//             if (nextPlayButton && !nextPlayButton.disabled) {
//               // Ensure Osaria player is initialized if needed
//               const osariaPlayer = nextCartItem.querySelector('.osaria-player-custom-product-view');
//               if (osariaPlayer) {
//                 // Trigger Osaria initialization if not already done
//                 osariaPlayer.dispatchEvent(new CustomEvent('osaria:init', { 
//                   bubbles: true,
//                   detail: { element: osariaPlayer, productId: nextCartItem.dataset.productId } 
//                 }));
//               }
//               nextPlayButton.click();
//             } else if (nextPlayButton && nextPlayButton.disabled) {
//               // If disabled, wait a bit more and try again
//               setTimeout(() => {
//                 if (nextPlayButton && !nextPlayButton.disabled) {
//                   nextPlayButton.click();
//                 }
//               }, 300);
//             }
//           }, 150);
//           return;
//         }
        
//         // Normal behavior: navigate through trackList
//         if (trackList.length === 0) return;
       
//         // Stop current track and update its UI
//         if (currentTrack && currentTrack.element) {
//           const currentTrackElement = currentTrack.element;
//           const currentAudio = currentTrackElement.querySelector('audio');
         
//           // Stop the audio
//           if (currentAudio && !currentAudio.paused) {
//             currentAudio.pause();
//           }
         
//           // Clear progress bar
//           const seek = currentTrackElement.querySelector('.tli__seek');
//           const seekFill = currentTrackElement.querySelector('.tli__seek-fill');
//           if (seek) {
//             seek.value = 0;
//             seek.style.setProperty('--value', '0%');
//           }
//           if (seekFill) {
//             seekFill.style.width = '0%';
//           }
         
//           // Update UI to show it's paused
//           currentTrackElement.classList.remove('playing');
//           currentTrackElement.classList.remove('showing-pause');
//           const playIcon = currentTrackElement.querySelector('.icon-play');
//           const pauseIcon = currentTrackElement.querySelector('.icon-pause');
//           if (playIcon) playIcon.style.display = 'block';
//           if (pauseIcon) pauseIcon.style.display = 'none';
//         }
       
//         // Also stop the sticky player's audio element if it exists
//         if (audioElement && !audioElement.paused) {
//           audioElement.pause();
//         }
       
//         currentTrackIndex = (currentTrackIndex + 1) % trackList.length;
//         const nextTrack = trackList[currentTrackIndex];
       
//         //console.log('🎵 Playing next track:', nextTrack);
       
//         // Find the corresponding track element and trigger play
//         const trackElement = nextTrack.element;
//         if (trackElement) {
//           const playButton = trackElement.querySelector('.tli__playbtn');
//           if (playButton) {
//             playButton.click();
//           }
//         }
//       };

//       // Play previous track
//       const playPreviousTrack = () => {
//         // Check if current track is from cart drawer
//         const isFromCartDrawer = currentTrack && currentTrack.element && 
//                                  (currentTrack.element.classList.contains('cart-item-card') ||
//                                   currentTrack.element.closest('.cart-item-card') ||
//                                   currentTrack.element.closest('cart-drawer-component'));
        
//         if (isFromCartDrawer) {
//           // Navigate through cart items
//           const cartWrapper = document.querySelector('.cart-items__wrapper');
//           if (!cartWrapper) return;
          
//           const cartItems = Array.from(cartWrapper.querySelectorAll('.cart-item-card[data-product-osaria-audio-data]'));
//           if (cartItems.length === 0) return;
          
//           // Find current cart item index
//           const currentCartItem = currentTrack.element.classList.contains('cart-item-card') 
//             ? currentTrack.element 
//             : currentTrack.element.closest('.cart-item-card');
          
//           if (!currentCartItem) return;
          
//           const currentCartIndex = cartItems.indexOf(currentCartItem);
//           if (currentCartIndex === -1) return;
          
//           // Stop current track
//           if (audioElement && !audioElement.paused) {
//             audioElement.pause();
//           }
//           if (currentCartItem) {
//             currentCartItem.classList.remove('playing');
//             const playIcon = currentCartItem.querySelector('.icon-play');
//             const pauseIcon = currentCartItem.querySelector('.icon-pause');
//             if (playIcon) playIcon.style.display = 'block';
//             if (pauseIcon) pauseIcon.style.display = 'none';
//           }
          
//           // Get previous cart item (wrap around - last item if at first)
//           const prevCartIndex = currentCartIndex === 0 ? cartItems.length - 1 : currentCartIndex - 1;
//           const prevCartItem = cartItems[prevCartIndex];
          
//           // Click the play button on the previous cart item
//           // Wait a bit to ensure current track is fully stopped and audio is ready
//           setTimeout(() => {
//             const prevPlayButton = prevCartItem.querySelector('.cart-item-card__playbtn');
//             if (prevPlayButton && !prevPlayButton.disabled) {
//               // Ensure Osaria player is initialized if needed
//               const osariaPlayer = prevCartItem.querySelector('.osaria-player-custom-product-view');
//               if (osariaPlayer) {
//                 // Trigger Osaria initialization if not already done
//                 osariaPlayer.dispatchEvent(new CustomEvent('osaria:init', { 
//                   bubbles: true,
//                   detail: { element: osariaPlayer, productId: prevCartItem.dataset.productId } 
//                 }));
//               }
//               prevPlayButton.click();
//             } else if (prevPlayButton && prevPlayButton.disabled) {
//               // If disabled, wait a bit more and try again
//               setTimeout(() => {
//                 if (prevPlayButton && !prevPlayButton.disabled) {
//                   prevPlayButton.click();
//                 }
//               }, 300);
//             }
//           }, 150);
//           return;
//         }
        
//         // Normal behavior: navigate through trackList
//         if (trackList.length === 0) return;
       
//         // Stop current track and update its UI
//         if (currentTrack && currentTrack.element) {
//           const currentTrackElement = currentTrack.element;
//           const currentAudio = currentTrackElement.querySelector('audio');
         
//           // Stop the audio
//           if (currentAudio && !currentAudio.paused) {
//             currentAudio.pause();
//           }
         
//           // Clear progress bar
//           const seek = currentTrackElement.querySelector('.tli__seek');
//           const seekFill = currentTrackElement.querySelector('.tli__seek-fill');
//           if (seek) {
//             seek.value = 0;
//             seek.style.setProperty('--value', '0%');
//           }
//           if (seekFill) {
//             seekFill.style.width = '0%';
//           }
         
//           // Update UI to show it's paused
//           currentTrackElement.classList.remove('playing');
//           currentTrackElement.classList.remove('showing-pause');
//           const playIcon = currentTrackElement.querySelector('.icon-play');
//           const pauseIcon = currentTrackElement.querySelector('.icon-pause');
//           if (playIcon) playIcon.style.display = 'block';
//           if (pauseIcon) pauseIcon.style.display = 'none';
//         }
       
//         // Also stop the sticky player's audio element if it exists
//         if (audioElement && !audioElement.paused) {
//           audioElement.pause();
//         }
       
//         currentTrackIndex = currentTrackIndex === 0 ? trackList.length - 1 : currentTrackIndex - 1;
//         const prevTrack = trackList[currentTrackIndex];
       
//         //console.log('🎵 Playing previous track:', prevTrack);
       
//         // Find the corresponding track element and trigger play
//         const trackElement = prevTrack.element;
//         if (trackElement) {
//           const playButton = trackElement.querySelector('.tli__playbtn');
//           if (playButton) {
//             playButton.click();
//           }
//         }
//       };

//     // Event listeners
//     playPauseBtn.addEventListener('click', () => {
//       if (audioElement) {
//         if (isPlaying) {
//           audioElement.pause();
//           // Dispatch immediate pause event to all sections
//           const currentTrack = window.StickyAudioPlayer?.getCurrentTrack?.();
//           const variantId = currentTrack?.element?.dataset?.variantId || currentTrack?.variantId;
//           const productId = currentTrack?.element?.dataset?.productId || currentTrack?.productId;
          
//           document.dispatchEvent(new CustomEvent('stickyPlayerPause', {
//             bubbles: true,
//             detail: { variantId, productId, source: 'stickyPlayer' }
//           }));
//         } else {
//             audioElement.play();
//             // Dispatch immediate play event to all sections
//             const currentTrack = window.StickyAudioPlayer?.getCurrentTrack?.();
//             const variantId = currentTrack?.element?.dataset?.variantId || currentTrack?.variantId;
//             const productId = currentTrack?.element?.dataset?.productId || currentTrack?.productId;
            
//             document.dispatchEvent(new CustomEvent('stickyPlayerPlay', {
//               bubbles: true,
//               detail: { variantId, productId, source: 'stickyPlayer' }
//             }));
//           }
//       }
//     });

//     prevBtn.addEventListener('click', () => {
//       playPreviousTrack();
//     });

//     nextBtn.addEventListener('click', () => {
//       playNextTrack();
//     });

//     // Cart button - add/remove current track to/from cart
//     cartBtn.addEventListener('click', async () => {
//       if (!currentTrack || !currentTrack.element) {
//         console.warn('🎵 No current track to add to cart');
//         return;
//       }

//       // Find the add to cart button in the track element
//       const trackElement = currentTrack.element;
//       // Try music store add button first
//       let addBtn = trackElement.querySelector('.tli__add');
     
//       // Selected media tracks don't have individual add buttons (they're added via form)
//       // So only handle music store tracks
//       if (!addBtn) {
//         console.warn('🎵 No add button found in current track (selected media tracks are added via form)');
//         return;
//       }

//       // Check if button is disabled
//       if (addBtn.disabled) {
//         return;
//       }

//       // Store original cart button content if not already stored
//       if (!cartBtn.dataset.originalContent) {
//         cartBtn.dataset.originalContent = cartBtn.innerHTML;
//       }

//       cartBtn.disabled = true;

//       // Simulate click on the add button from the track
//       addBtn.click();

//       // Wait a bit for the cart operation to complete, then update sticky button
//       setTimeout(async () => {
//         await updateStickyCartButton();
//         cartBtn.disabled = false;
//       }, 500);
//     });

//     // Close button - hide the sticky player
//     closeBtn.addEventListener('click', () => {
//       if (audioElement) {
//         audioElement.pause();
//       }
//       hidePlayer();
//     });

//     // Progress bar click
//     progressBar.addEventListener('click', (e) => {
//       if (!audioElement || !audioElement.duration) return;
     
//       const rect = progressBar.getBoundingClientRect();
//       const clickX = e.clientX - rect.left;
//       const percentage = clickX / rect.width;
//       const newTime = percentage * audioElement.duration;
     
//       audioElement.currentTime = newTime;
//     });

//     // Function to check if a variant is in the cart (for sticky player)
//     const isVariantInCartSticky = async (variantId) => {
//       try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();
//         return cart.items.some(item => item.variant_id === variantId);
//       } catch (error) {
//         console.error('❌ Failed to check cart:', error);
//         return false;
//       }
//     };

//     // Function to update sticky player cart button based on current track
//     const updateStickyCartButton = async () => {
//       if (!currentTrack || !currentTrack.element) return;
     
//       // Store original cart button content if not already stored
//       if (!cartBtn.dataset.originalContent) {
//         cartBtn.dataset.originalContent = cartBtn.innerHTML;
//       }
     
//       // Check if track is from cart drawer
//       // The element should be the cart-item-card itself when playing from cart drawer
//       const isCartItemCard = currentTrack.element.classList && 
//                              currentTrack.element.classList.contains('cart-item-card');
//       const cartItemCard = isCartItemCard 
//         ? currentTrack.element 
//         : (currentTrack.element.closest && currentTrack.element.closest('.cart-item-card'));
//       const isFromCartDrawer = isCartItemCard || cartItemCard || 
//                                 (currentTrack.element.closest && 
//                                  currentTrack.element.closest('.cart-items__wrapper'));
     
//       if (isFromCartDrawer && cartItemCard) {
//         // Track is from cart drawer - show tick and check if still in cart
//         // Check if item is still in cart by checking if the cart item card still exists in DOM
//         const cartWrapper = document.querySelector('.cart-items__wrapper');
//         const isStillInCart = cartWrapper && cartWrapper.contains(cartItemCard);
        
//         if (isStillInCart) {
//           // Show tick icon - item is in cart
//           cartBtn.innerHTML = `
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//               <path d="M5 13l4 4L19 7"/>
//             </svg>
//           `;
//           cartBtn.classList.add('success');
//         } else {
//           // Item was removed from cart - show plus icon
//           cartBtn.innerHTML = cartBtn.dataset.originalContent;
//           cartBtn.classList.remove('success');
//         }
//         return;
//       }
     
//       // Track is from music store - use existing logic
//       const addBtn = currentTrack.element.querySelector('.tli__add');
//       if (!addBtn) return;
     
//       const variantId = Number(addBtn.dataset.vid);
//       if (!variantId) return;
     
//       const isInCart = await isVariantInCartSticky(variantId);
//       // if (isInCart) {
//       //   cartBtn.innerHTML = `
//       //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
//       //       <path d="M5 13l4 4L19 7"/>
//       //     </svg>
//       //   `;
//       //   cartBtn.classList.add('success');
//       // } else {
//       //   cartBtn.innerHTML = cartBtn.dataset.originalContent;
//       //   cartBtn.classList.remove('success');
//       // }
//     };

//     // Expose functions globally for communication with music library
//     window.StickyAudioPlayer = {
//       show: (trackData) => {
//         //console.log('🎵 Sticky player - direct API show called with:', trackData);
//         //console.log('🎵 Sticky player - trackData.title:', trackData?.title);
//         showPlayer(trackData);
//         // Update cart button when track is shown
//         setTimeout(updateStickyCartButton, 100);
//       },
//       hide: hidePlayer,
//       connect: connectToAudio,
//       updateProgress: updateProgress,
//       updatePlayPause: updatePlayPause,
//       setTrackList: setTrackList,
//       playNext: playNextTrack,
//       playPrevious: playPreviousTrack,
//       getCurrentTrack: () => currentTrack,
//       updateCartButton: updateStickyCartButton
//     };

//     // Listen for track changes from music library sections
//     document.addEventListener('trackChanged', (e) => {
//       //console.log('🎵 Sticky player received trackChanged event:', e.detail);
//       const { trackData, audioElement: audio } = e.detail;
//       //console.log('🎵 Sticky player - received trackData:', trackData);
//       //console.log('🎵 Sticky player - trackData.title:', trackData?.title);
//       showPlayer(trackData);
//       if (audio) {
//         connectToAudio(audio);
//       }
//       // Update cart button when track changes
//       setTimeout(updateStickyCartButton, 100);
//     });

//     // Listen for play/pause events
//     document.addEventListener('trackPlayPause', (e) => {
//       //console.log('🎵 Sticky player received trackPlayPause event:', e.detail);
//       const { isPlaying: playing } = e.detail;
//       updatePlayPause(playing);
//     });
   
//     // Listen for unified play events from both music store and selected media
//     document.addEventListener('unifiedTrackPlay', (e) => {
//       const { trackData, source } = e.detail;
//       //console.log('🎵 Sticky player received unifiedTrackPlay event from:', source, trackData);
     
//       // Only update sticky player if trackData is provided
//       if (trackData) {
//         showPlayer(trackData);
       
//         // Update total time from trackData if available (before connecting to audio)
//         if (trackData.duration && trackData.duration > 0) {
//           totalTime.textContent = formatTime(trackData.duration);
//         }
       
//         // Try to find and connect to the audio element
//         const findAndConnectAudio = (trackElement) => {
//           if (!trackElement) return;
         
//           let audio = trackElement.querySelector('audio');
//           if (audio) {
//             connectToAudio(audio);
//             // Check if audio is already playing
//             if (!audio.paused) {
//               updatePlayPause(true);
//             }
//           } else {
//             // If not found immediately, wait a bit for Osaria to create it
//             let attempts = 0;
//             const maxAttempts = 20; // 2 seconds (20 * 100ms)
//             const checkForAudio = () => {
//               audio = trackElement.querySelector('audio');
//               if (audio) {
//                 connectToAudio(audio);
//                 // Check if audio is playing
//                 if (!audio.paused) {
//                   updatePlayPause(true);
//                 }
//               } else if (attempts < maxAttempts) {
//                 attempts++;
//                 setTimeout(checkForAudio, 100);
//               }
//             };
//             setTimeout(checkForAudio, 100);
//           }
//         };
       
//         if (source === 'musicLibrary' || source === 'selectedMedia') {
//           // Find audio in the track element
//           const trackElement = trackData.element;
//           findAndConnectAudio(trackElement);
//         }
       
//         // Update cart button when track changes
//         setTimeout(updateStickyCartButton, 100);
//       }
//     });
   
//     // Listen for unified pause events from both sections
//     document.addEventListener('unifiedTrackPause', (e) => {
//       const { source } = e.detail;
//       //console.log('🎵 Sticky player received unifiedTrackPause event from:', source);
//       updatePlayPause(false);
//     });

//     // Listen for cart updates to refresh sticky player button
//     document.addEventListener('cart:updated', () => {
//       //console.log('🛒 Sticky player - cart updated, refreshing cart button');
//       updateStickyCartButton();
//     });
   
//     window.addEventListener('cartUpdated', () => {
//       //console.log('🛒 Sticky player - cart updated (custom event), refreshing cart button');
//       updateStickyCartButton();
//     });
    
//     // Listen for cart drawer content refresh (when items are added/removed)
//     document.addEventListener('cart:content:refreshed', () => {
//       //console.log('🛒 Sticky player - cart content refreshed, checking cart button state');
//       updateStickyCartButton();
//     });
    
//     // Listen for cart change events
//     document.addEventListener('cart:change', () => {
//       //console.log('🛒 Sticky player - cart changed, refreshing cart button');
//       updateStickyCartButton();
//     });

//     //console.log('🎵 Sticky Audio Player initialized');
//   })();
 
//   // Listen for unified play events from selected media
//   document.addEventListener('unifiedTrackPlay', (e) => {
//     const { variantId, productId, source } = e.detail;
//     //console.log('🎵 Music Library - Received unifiedTrackPlay event', {
//     //   variantId: variantId,
//     //   productId: productId,
//     //   source: source
//     // });
   
//     if (source === 'musicLibrary') return; // Ignore our own events
   
//     // If selected media is playing, pause any playing track in music store
//     if (source === 'selectedMedia') {
//       // Clean up any existing selected media sync listener
//       if (selectedMediaSyncListener) {
//         const selectedMediaTrack = document.querySelector('.sm-track-item.playing');
//         if (selectedMediaTrack) {
//           const selectedAudio = selectedMediaTrack.querySelector('audio');
//           if (selectedAudio) {
//             selectedAudio.removeEventListener('timeupdate', selectedMediaSyncListener);
//           }
//         }
//         selectedMediaSyncListener = null;
//       }
     
//       // Pause any currently playing track in music store
//       if (activeRow) {
//         const prevAudio = activeRow.querySelector('audio');
//         if (prevAudio) {
//           prevAudio.pause();
//           prevAudio.currentTime = 0;
//         }
//         setPlayIcon(activeRow, false);
//         activeRow.classList.remove('playing');
       
//         // Reset progress bar and time
//         const seek = activeRow.querySelector('.tli__seek');
//         const current = activeRow.querySelector('.tli__current');
//         const currentMobile = activeRow.querySelector('.tli__current-mobile');
//         if (seek) {
//           seek.value = 0;
//           seek.style.setProperty('--value', '0%');
//         }
//         const seekFill = activeRow.querySelector('.tli__seek-fill');
//         if (seekFill) seekFill.style.width = '0%';
       
//         // Reset to total duration
//         if (prevAudio && prevAudio.duration && isFinite(prevAudio.duration)) {
//           const totalDuration = fmt(prevAudio.duration);
//           if (current) {
//             current.textContent = totalDuration;
//             current.classList.remove('loading');
//           }
//           if (currentMobile) {
//             currentMobile.textContent = totalDuration;
//           }
//         } else {
//           const totalElement = activeRow.querySelector('.tli__total');
//           if (current) {
//             if (totalElement) {
//               current.textContent = totalElement.textContent.trim();
//             } else {
//               current.textContent = '0:00';
//             }
//             current.classList.remove('loading');
//           }
//           if (currentMobile) {
//             if (totalElement) {
//               currentMobile.textContent = totalElement.textContent.trim();
//             } else {
//               currentMobile.textContent = '0:00';
//             }
//           }
//         }
       
//         activeRow = null;
//         activePlayer = null;
//       }
     
//       // Update UI to show matching track is playing (if it exists in music store)
//       if (variantId) {
//         root.querySelectorAll('.track-list-item').forEach(row => {
//           const rowVariantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
//           if (rowVariantId === variantId) {
//             // Update UI to show this track is playing (Selected Media is playing it)
//             resetAllPlayIcons(row);
//             setPlayIcon(row, true);
//             row.classList.add('playing');
           
//             // Set as active row so seek bar updates
//             activeRow = row;
           
//             // Find the audio element in selected media and sync seek bar updates
//             // Audio element might not be ready yet, so we need to wait for it
//             // Try to find by variant ID first, then by playing class as fallback
//             let selectedMediaTrack = document.querySelector(`.sm-track-item[data-variant-id="${variantId}"]`);
//             if (!selectedMediaTrack) {
//               // Fallback: find by playing class
//               selectedMediaTrack = document.querySelector('.sm-track-item.playing');
//             }
//             if (selectedMediaTrack) {
//               //console.log('🎵 Found selected media track for sync:', selectedMediaTrack);
//               // Clean up any existing listener first
//               if (selectedMediaSyncListener) {
//                 const prevSelectedMediaTrack = document.querySelector('.sm-track-item.playing');
//                 if (prevSelectedMediaTrack) {
//                   const prevSelectedAudio = prevSelectedMediaTrack.querySelector('audio');
//                   if (prevSelectedAudio) {
//                     prevSelectedAudio.removeEventListener('timeupdate', selectedMediaSyncListener);
//                   }
//                 }
//                 selectedMediaSyncListener = null;
//               }
             
//               // Function to set up seek bar sync
//               const setupSeekBarSync = () => {
//                 const selectedAudio = selectedMediaTrack.querySelector('audio');
//                 //console.log('🎵 Checking for selected audio:', {
//                 //   hasSelectedMediaTrack: !!selectedMediaTrack,
//                 //   hasSelectedAudio: !!selectedAudio,
//                 //   activeRow: activeRow === row,
//                 //   audioDuration: selectedAudio ? selectedAudio.duration : 'N/A'
//                 // });
               
//                 if (selectedAudio && activeRow === row) {
//                   //console.log('🎵 Setting up seek bar sync for selected media playback');
                 
//                   // Listen to selected media audio timeupdate and update music library seek bar
//                   selectedMediaSyncListener = () => {
//                     // Always update if this is the active row (don't check paused state)
//                     if (activeRow === row && selectedAudio) {
//                       const current = row.querySelector('.tli__current');
//                       const currentMobile = row.querySelector('.tli__current-mobile');
//                       const seek = row.querySelector('.tli__seek');
                     
//                       // Check if elements exist
//                       if (!current && !currentMobile && !seek) {
//                         console.warn('⚠️ No UI elements found for seek bar sync');
//                         return;
//                       }
                     
//                       if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
//                         // Update time displays (show remaining time)
//                         const remaining = Math.max(0, selectedAudio.duration - selectedAudio.currentTime);
//                         if (current) {
//                           current.textContent = fmt(remaining);
//                           current.classList.remove('loading');
//                         }
//                         if (currentMobile) {
//                           currentMobile.textContent = fmt(remaining);
//                         }
                       
//                         // Update seek bar
//                         if (seek) {
//                           // Enable seek bar
//                           seek.disabled = false;
                         
//                           const progress = (selectedAudio.currentTime / selectedAudio.duration) * 1000;
//                           seek.value = Math.round(progress);
//                           const fillWidth = (selectedAudio.currentTime / selectedAudio.duration) * 100;
//                           seek.style.setProperty('--value', `${fillWidth}%`);
                         
//                           const seekFill = row.querySelector('.tli__seek-fill');
//                           if (seekFill) {
//                             seekFill.style.width = `${fillWidth}%`;
//                           }
//                         }
//                       } else {
//                         // If duration not available yet, wait for it
//                         if (current) {
//                           current.textContent = 'Loading...';
//                           current.classList.add('loading');
//                         }
//                         if (currentMobile) {
//                           currentMobile.textContent = 'Loading...';
//                         }
//                       }
//                     } else {
//                       // Debug: log why listener isn't updating
//                       if (activeRow !== row) {
//                         //console.log('⚠️ Active row mismatch:', {
//                         //   activeRow: activeRow ? activeRow.querySelector('.tli__title')?.textContent : 'null',
//                         //   expectedRow: row.querySelector('.tli__title')?.textContent
//                         // });
//                       }
//                       if (!selectedAudio) {
//                         console.warn('⚠️ Selected audio element not found');
//                       }
//                     }
//                   };
                 
//                   // Add new listener
//                   selectedAudio.addEventListener('timeupdate', selectedMediaSyncListener);
                 
//                   // Also listen to loadedmetadata to get initial duration
//                   const handleMetadata = () => {
//                     if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
//                       //console.log('✅ Selected audio metadata loaded, duration:', selectedAudio.duration);
//                       // Update immediately with initial state
//                       selectedMediaSyncListener();
//                     }
//                   };
//                   selectedAudio.addEventListener('loadedmetadata', handleMetadata, { once: true });
                 
//                   // Also update immediately if duration is already available
//                   if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
//                     selectedMediaSyncListener();
//                   } else {
//                     // Wait a bit for metadata to load
//                     setTimeout(() => {
//                       if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
//                         selectedMediaSyncListener();
//                       }
//                     }, 100);
//                   }
                 
//                   //console.log('✅ Seek bar sync listener attached');
//                   return true; // Successfully set up
//                 }
//                 return false; // Audio not ready yet
//               };
             
//               // Try to set up immediately
//               if (!setupSeekBarSync()) {
//                 //console.log('⏳ Selected audio not ready, starting polling...');
//                 // If audio not ready, wait for it (check periodically)
//                 let attempts = 0;
//                 const maxAttempts = 100; // Try for up to 10 seconds (100 * 100ms)
//                 const checkInterval = setInterval(() => {
//                   attempts++;
//                   if (setupSeekBarSync()) {
//                     //console.log('✅ Seek bar sync set up after', attempts, 'attempts');
//                     clearInterval(checkInterval);
//                   } else if (attempts >= maxAttempts) {
//                     console.warn('⚠️ Failed to set up seek bar sync after', maxAttempts, 'attempts');
//                     clearInterval(checkInterval);
//                   } else if (attempts % 10 === 0) {
//                     // Log every 10 attempts
//                     //console.log('⏳ Still waiting for selected audio element...', attempts, '/', maxAttempts);
//                   }
//                 }, 100);
//               } else {
//                 //console.log('✅ Seek bar sync set up immediately');
//               }
//             }
//           } else {
//             // Make sure other tracks show play icon
//             setPlayIcon(row, false);
//             row.classList.remove('playing');
//           }
//         });
//       }
     
//       return; // Don't process further
//     }
   
//     if (!variantId) {
//       console.warn('🎵 Music Library - No variantId in event');
//       return;
//     }
   
//     // Find matching track in music library by comparing variantId as number
//     let matchingRow = null;
//     root.querySelectorAll('.track-list-item').forEach(row => {
//       const rowVariantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
//       if (rowVariantId === variantId) {
//         matchingRow = row;
//         //console.log('🎵 Music Library - Found matching track', {
//         //   variantId: rowVariantId,
//         //   title: row.querySelector('.tli__title')?.textContent
//         // });
//       }
//     });
   
//     if (!matchingRow) {
//       console.warn('🎵 Music Library - No matching track found for variantId:', variantId);
//       return;
//     }
   
//     if (matchingRow) {
//       //console.log('🎵 Music Library - Received play event from Selected Media, updating UI');
     
//       // Stop current track if playing (only if different track)
//       if (activeRow && activeRow !== matchingRow) {
//         const prevAudio = activeRow.querySelector('audio');
//         if (prevAudio) {
//           prevAudio.pause();
//         }
//         setPlayIcon(activeRow, false);
//         activeRow.classList.remove('playing');
//       }
     
//       // Update UI to show this track is playing (Selected Media is playing it)
//       if (!matchingRow.classList.contains('playing')) {
//         resetAllPlayIcons(matchingRow);
//         setPlayIcon(matchingRow, true);
//         matchingRow.classList.add('playing');
//         activeRow = matchingRow;
//         //console.log('🎵 Music Library - UI updated to show playing state');
//       } else {
//         //console.log('🎵 Music Library - Track already showing as playing');
//       }
//     } else {
//       //console.log('🎵 Music Library - Track not found in music library');
//     }
//   });
 
//   // Listen for unified pause events from selected media
//   document.addEventListener('unifiedTrackPause', (e) => {
//     const { variantId, productId, source } = e.detail;
//     if (source === 'musicLibrary') return; // Ignore our own events
   
//     // Clean up selected media sync listener when paused
//     if (source === 'selectedMedia' && selectedMediaSyncListener) {
//       const selectedMediaTrack = document.querySelector('.sm-track-item.playing');
//       if (selectedMediaTrack) {
//         const selectedAudio = selectedMediaTrack.querySelector('audio');
//         if (selectedAudio) {
//           selectedAudio.removeEventListener('timeupdate', selectedMediaSyncListener);
//         }
//       }
//       selectedMediaSyncListener = null;
//     }
   
//     // If no variantId specified, pause ALL playing tracks in music store
//     if (!variantId) {
//       if (activeRow) {
//         const audio = activeRow.querySelector('audio');
//         if (audio && !audio.paused) {
//           audio.pause();
//           audio.currentTime = 0;
//         }
//         setPlayIcon(activeRow, false);
//         activeRow.classList.remove('playing');
       
//         // Reset progress bar and time
//         const seek = activeRow.querySelector('.tli__seek');
//         const current = activeRow.querySelector('.tli__current');
//         const currentMobile = activeRow.querySelector('.tli__current-mobile');
//         if (seek) {
//           seek.value = 0;
//           seek.style.setProperty('--value', '0%');
//         }
//         const seekFill = activeRow.querySelector('.tli__seek-fill');
//         if (seekFill) seekFill.style.width = '0%';
       
//         // Reset to total duration
//         if (audio && audio.duration && isFinite(audio.duration)) {
//           const totalDuration = fmt(audio.duration);
//           if (current) {
//             current.textContent = totalDuration;
//             current.classList.remove('loading');
//           }
//           if (currentMobile) {
//             currentMobile.textContent = totalDuration;
//           }
//         } else {
//           const totalElement = activeRow.querySelector('.tli__total');
//           if (current) {
//             if (totalElement) {
//               current.textContent = totalElement.textContent.trim();
//             } else {
//               current.textContent = '0:00';
//             }
//             current.classList.remove('loading');
//           }
//           if (currentMobile) {
//             if (totalElement) {
//               currentMobile.textContent = totalElement.textContent.trim();
//             } else {
//               currentMobile.textContent = '0:00';
//             }
//           }
//         }
       
//         activeRow = null;
//         activePlayer = null;
//       }
//       return;
//     }
   
//     // Find matching track in music library by comparing variantId as number
//     let matchingRow = null;
//     root.querySelectorAll('.track-list-item').forEach(row => {
//       const rowVariantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
//       if (rowVariantId === variantId) {
//         matchingRow = row;
//       }
//     });
   
//     if (matchingRow) {
//       //console.log('🎵 Music Library - Received pause event from Selected Media, updating UI');
//       if (matchingRow.classList.contains('playing')) {
//         const audio = matchingRow.querySelector('audio');
//         if (audio) {
//           audio.pause();
//         }
//         matchingRow.classList.remove('playing');
//         setPlayIcon(matchingRow, false);
//         if (matchingRow === activeRow) {
//           activeRow = null;
//           activePlayer = null;
//         }
//       }
//     }
//   });
// })();
// document.addEventListener("click", function(e) {
//   const btn = e.target.closest(".tli__add");
//   if (!btn) return;

//   const scrollY = window.scrollY;

//   // lock scroll
//   document.body.style.position = "fixed";
//   document.body.style.top = `-${scrollY}px`;
//   document.body.style.left = "0";
//   document.body.style.right = "0";

//   setTimeout(function () {
//     // unlock scroll
//     document.body.style.position = "";
//     document.body.style.top = "";
//     document.body.style.left = "";
//     document.body.style.right = "";
//     window.scrollTo(0, scrollY);
//   }, 600);
// });





document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ep-songlib__mobile-filter-group-header').forEach(button => {
    button.addEventListener('click', function() {
      const heading = this.querySelector('h4');
      heading.classList.toggle('active');
    });
  });
});

(() => {
 //console.log('🎵 Music section script starting...');
 
 // Find the ep-songlib section by section ID
 // Get section ID from the section element's data attribute
 const sectionElement = document.querySelector('.ep-songlib[data-section-id]');
 const sectionId = sectionElement ? sectionElement.getAttribute('data-section-id') : null;
 let root = document.querySelector(`[data-section-id="${sectionId}"]`);
 //console.log('🎵 Root element found:', root);
 //console.log('🎵 Section ID:', sectionId);
 
 if (!root) {
 console.warn('❌ No .ep-songlib root element found with section ID:', sectionId);
 // Fallback: try to find any ep-songlib section
 const fallbackRoot = document.querySelector('.ep-songlib');
 if (fallbackRoot) {
 //console.log('🎵 Using fallback root element:', fallbackRoot);
 root = fallbackRoot;
 } else {
 console.warn('❌ No fallback .ep-songlib element found either');
 return;
 }
 }

 
 
 const trackItems = root.querySelectorAll('.track-list-item');
 //console.log('🎵 Found track items:', trackItems.length);
 
 // Search functionality - integrated with filters
 const searchInput = root.querySelector('#song-search');
 
 // ===== FILTERING SYSTEM =====
 let activeFilters = {
   genre: [],
   bpm: [],
   mood: [],
   key: [],
   vocal: [],
   section: [],
   theme: [],
   price: [],
   length: [],
   feature: ['newest'] // Feature filter: trending, latest, newest, downloads (single selection)
 };

 // Keep old data-filter-type="tags" markup compatible while treating it as Section.
 const normalizeFilterType = (filterType) => filterType === 'tags' ? 'section' : filterType;
 const normalizeValue = (value) => String(value || '').trim().toLowerCase();

 // Rename legacy Tags filter labels to Section without requiring old markup to change immediately.
 root.querySelectorAll('[data-filter-type="tags"]').forEach(element => {
   element.dataset.filterType = 'section';
 });
 root.querySelectorAll('.ep-songlib__filter-category-btn, .ep-songlib__mobile-filter-group-header h4').forEach(label => {
   if (label.textContent.trim().toLowerCase() === 'tags') {
     label.textContent = 'Section';
   }
 });

 let filterChangeTriggered = false; // Track if filters changed (not just search)

 // Filter categories are now handled below with toggle buttons

// Function to update URL with sort parameter
function updateURLWithSort(sortValue) {
  if (!sortValue) return;
 
  const url = new URL(window.location.href);
 
  // Map our sort values to URL parameters
  // Use 'sort_by' for Shopify compatibility, or 'sort' as fallback
  if (sortValue === 'newest' || sortValue === 'latest') {
    url.searchParams.set('sort_by', 'created-descending');
  }
  // Trending - commented out
  // else if (sortValue === 'trending') {
  //   url.searchParams.set('sort_by', 'trending');
  // }
  // Top Downloads - commented out
  // else if (sortValue === 'downloads') {
  //   url.searchParams.set('sort_by', 'downloads');
  // }
  else if (sortValue === 'alphabetical') {
    url.searchParams.set('sort_by', 'title-ascending');
  }
 
  // Also set our custom sort parameter for internal use
  url.searchParams.set('sort', sortValue);
 
  // Update URL without page reload
  window.history.pushState({ sort: sortValue }, '', url.toString());
}

// Function to read sort from URL on page load
function getSortFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
 
  // First check for our custom 'sort' parameter
  const customSort = urlParams.get('sort');
  // Removed 'trending' and 'downloads' from valid sort options
  if (customSort && ['newest', 'latest', 'alphabetical'].includes(customSort)) {
    return customSort;
  }
 
  // Then check for Shopify's 'sort_by' parameter
  const shopifySort = urlParams.get('sort_by');
  if (shopifySort === 'created-descending') {
    return 'newest'; // Default to newest for created-descending
  }
  // Trending - commented out
  // else if (shopifySort === 'trending') {
  //   return 'trending';
  // }
  // Top Downloads - commented out
  // else if (shopifySort === 'downloads') {
  //   return 'downloads';
  // }
  else if (shopifySort === 'title-ascending') {
    return 'alphabetical';
  }
 
  return null; // No sort in URL
}

// Sort dropdown toggle - handle both desktop and mobile
const sortDropdowns = root.querySelectorAll('.ep-songlib__sort');
const updateAllSortLabels = () => {
  const currentFeature = activeFilters.feature && activeFilters.feature.length > 0
    ? activeFilters.feature[0]
    : 'newest';
 
  // Update desktop sort dropdown labels
  sortDropdowns.forEach(sortDropdown => {
    const sortBtn = sortDropdown.querySelector('.ep-songlib__sort-btn');
    const activeOption = sortDropdown.querySelector(`.ep-songlib__sort-option[data-filter-value="${currentFeature}"]`);
    const sortLabel = sortBtn?.querySelector('.ep-songlib__sort-label');
    if (sortLabel && activeOption) {
      sortLabel.textContent = `Sort by ${activeOption.textContent}`;
    }
  });
 
  // Update mobile sort heading
  const mobileSortHeading = root.querySelector('.ep-songlib__mobile-sort-heading');
  const mobileActiveChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"][data-filter-value="${currentFeature}"]`);
  if (mobileSortHeading && mobileActiveChip) {
    mobileSortHeading.textContent = `Sort by ${mobileActiveChip.textContent}`;
  }
};

sortDropdowns.forEach(sortDropdown => {
  const sortBtn = sortDropdown.querySelector('.ep-songlib__sort-btn');
  const sortMenu = sortDropdown.querySelector('.ep-songlib__sort-menu');
 
  if (sortBtn && sortMenu) {
    sortBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = sortDropdown.classList.contains('active');
      // Close all other sort dropdowns
      sortDropdowns.forEach(sd => sd.classList.remove('active'));
      sortDropdown.classList.toggle('active', !isActive);
    });

    // Sort option selection - updates filter system
    const sortOptions = sortDropdown.querySelectorAll('.ep-songlib__sort-option');
   
    sortOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        const filterType = option.dataset.filterType;
        const filterValue = option.dataset.filterValue;
       
        if (filterType && filterValue) {
          // Update activeFilters
          activeFilters[filterType] = [filterValue];
         
          // Update URL with sort parameter
          updateURLWithSort(filterValue);
         
          // Update active state in all sort dropdowns
          sortDropdowns.forEach(sd => {
            const sdOptions = sd.querySelectorAll('.ep-songlib__sort-option');
            sdOptions.forEach(o => o.classList.remove('active'));
            const matchingOption = sd.querySelector(`.ep-songlib__sort-option[data-filter-value="${filterValue}"]`);
            if (matchingOption) {
              matchingOption.classList.add('active');
            }
          });
         
          // Update all sort labels
          updateAllSortLabels();
         
          // Sync with mobile feature filter chips
          const allMobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
          allMobileFeatureChips.forEach(c => c.classList.remove('active'));
          const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);
          if (mobileChip) {
            mobileChip.classList.add('active');
          }
         
          // Close all sort dropdowns
          sortDropdowns.forEach(sd => sd.classList.remove('active'));
         
          // Apply filters immediately
          filterChangeTriggered = true;
          applyFilters();
          filterChangeTriggered = false;
        }
      });
    });
  }
});

// Initialize sort from URL on page load
const urlSort = getSortFromURL();
if (urlSort) {
  // Set the sort from URL
  activeFilters.feature = [urlSort];
 
  // Update UI to reflect URL sort
  const sortOptions = root.querySelectorAll('.ep-songlib__sort-option');
  sortOptions.forEach(o => o.classList.remove('active'));
  const sortOption = root.querySelector(`.ep-songlib__sort-option[data-filter-value="${urlSort}"]`);
  if (sortOption) {
    sortOption.classList.add('active');
  }
 
  // Update mobile chips
  const mobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
  mobileFeatureChips.forEach(c => c.classList.remove('active'));
  const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"][data-filter-value="${urlSort}"]`);
  if (mobileChip) {
    mobileChip.classList.add('active');
  }
 
  // Update desktop chips
  const desktopFeatureChips = root.querySelectorAll(`.ep-songlib__filter-chip[data-filter-type="feature"]`);
  desktopFeatureChips.forEach(c => c.classList.remove('active'));
  const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="feature"][data-filter-value="${urlSort}"]`);
  if (desktopChip) {
    desktopChip.classList.add('active');
  }
}

// Set initial labels for all sort dropdowns
updateAllSortLabels();

// Handle browser back/forward buttons to restore sort from URL
window.addEventListener('popstate', (e) => {
  const urlSort = getSortFromURL();
  if (urlSort) {
    activeFilters.feature = [urlSort];
    // Update UI and apply filters
    const sortOptions = root.querySelectorAll('.ep-songlib__sort-option');
    sortOptions.forEach(o => o.classList.remove('active'));
    const sortOption = root.querySelector(`.ep-songlib__sort-option[data-filter-value="${urlSort}"]`);
    if (sortOption) {
      sortOption.classList.add('active');
    }
    updateAllSortLabels();
    applyFilters();
  }
});

 // Close dropdowns when clicking outside
 document.addEventListener('click', (e) => {
   if (!e.target.closest('.ep-songlib__filter-category') && !e.target.closest('.ep-songlib__sort')) {
     filterCategories.forEach(c => c.classList.remove('active'));
     sortDropdowns.forEach(sd => sd.classList.remove('active'));
   }
 });

 // Filter category toggle buttons
 const filterCategories = root.querySelectorAll('.ep-songlib__filter-category');
 filterCategories.forEach(category => {
   const categoryBtn = category.querySelector('.ep-songlib__filter-category-btn');
   if (categoryBtn) {
     categoryBtn.addEventListener('click', (e) => {
       e.stopPropagation();
       const isActive = category.classList.contains('active');
       filterCategories.forEach(c => c.classList.remove('active'));
       category.classList.toggle('active', !isActive);
     });
   }
 });

// Helper function to check if we're on desktop
function isDesktop() {
  return window.innerWidth >= 1025;
}

// Filter chip button handlers
const filterChips = root.querySelectorAll('.ep-songlib__filter-chip');
filterChips.forEach(chip => {
  chip.addEventListener('click', (e) => {
    e.stopPropagation();
    const originalFilterType = chip.dataset.filterType;
    const filterType = normalizeFilterType(originalFilterType);
    const value = chip.dataset.filterValue;
   
    if (!filterType || !value) {
      console.warn('⚠️ Filter chip missing filterType or value:', { filterType, value });
      return;
    }
   
    const isActive = chip.classList.contains('active');
   
    // Feature filter is single-selection (only one option active at a time)
    if (filterType === 'feature') {
      if (!isActive) {
        // Remove active state from all feature chips
        const allFeatureChips = root.querySelectorAll(`.ep-songlib__filter-chip[data-filter-type="feature"]`);
        allFeatureChips.forEach(c => c.classList.remove('active'));
       
        // Remove active state from all mobile feature chips
        const allMobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
        allMobileFeatureChips.forEach(c => c.classList.remove('active'));
       
        // Set the clicked chip as active
        chip.classList.add('active');
        activeFilters[filterType] = [value];
       
        // Update URL with sort parameter
        updateURLWithSort(value);
       
        // Sync with sort dropdown
        const sortOptions = root.querySelectorAll('.ep-songlib__sort-option');
        sortOptions.forEach(o => o.classList.remove('active'));
        const sortOption = root.querySelector(`.ep-songlib__sort-option[data-filter-value="${value}"]`);
        if (sortOption) {
          sortOption.classList.add('active');
          const sortLabel = root.querySelector('.ep-songlib__sort-label');
          if (sortLabel) {
            sortLabel.textContent = `Sort by ${sortOption.textContent}`;
          }
        }
       
        // Sync with mobile chip
        const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${originalFilterType}"][data-filter-value="${value}"], .ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
        if (mobileChip) {
          mobileChip.classList.add('active');
        }
      }
      // If clicking the same feature option, don't deselect it (always keep one selected)
    } else {
      // Multi-selection for other filters
      if (isActive) {
        chip.classList.remove('active');
        activeFilters[filterType] = activeFilters[filterType].filter(v => v !== value);
      } else {
        chip.classList.add('active');
        if (!activeFilters[filterType].includes(value)) {
          activeFilters[filterType].push(value);
        }
      }
     
      // Sync with mobile chips if they exist
      const mobileChip = root.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
      if (mobileChip) {
        if (chip.classList.contains('active')) {
          mobileChip.classList.add('active');
        } else {
          mobileChip.classList.remove('active');
        }
      }
    }
   
    //console.log('🔍 Filter changed:', {
    //   filterType: filterType,
    //   value: value,
    //   activeFilters: activeFilters[filterType],
    //   isActive: !isActive
    // });
   
    updateMobileFilterTitle();
   
    // Apply filters immediately on both desktop and mobile.
    filterChangeTriggered = true;
    updateFilterChips();
    applyFilters();
    updateDesktopActionButtons();
    filterChangeTriggered = false;
  });
});

// Function to update mobile filter title with count (defined early for use in updateFilterChips)
function updateMobileFilterTitle() {
  const titleElement = root.querySelector('#mobile-filters-title');
  if (!titleElement) return;
 
  // Count only user-selected filters, excluding 'feature' which is a sort option
  const totalActive = Object.keys(activeFilters)
    .filter(key => key !== 'feature') // Exclude feature filter from count
    .reduce((sum, key) => sum + activeFilters[key].length, 0);
 
  if (totalActive > 0) {
    titleElement.textContent = `Filters (${totalActive})`;
  } else {
    titleElement.textContent = 'Filters';
  }
}

// Function to update desktop action buttons visibility
function updateDesktopActionButtons() {
  if (!isDesktop()) return;
 
  const desktopActions = root.querySelector('.ep-songlib__desktop-actions');
  if (!desktopActions) return;
 
  // Check if there are any active filters
  const totalActive = Object.keys(activeFilters)
    .filter(key => key !== 'feature')
    .reduce((sum, key) => sum + activeFilters[key].length, 0);
  // Check if search input has value
  const searchValue = searchInput ? searchInput.value.trim() : '';
  const hasFilters = totalActive > 0 || searchValue.length > 0;
 
  if (hasFilters) {
    desktopActions.classList.add('has-filters');
  } else {
    desktopActions.classList.remove('has-filters');
  }
}

// Update filter chips
function updateFilterChips() {
  // Update mobile filter title
  updateMobileFilterTitle();
   const chipsContainer = root.querySelector('#filter-chips');
   if (!chipsContainer) return;
   
   chipsContainer.innerHTML = '';
   
   let hasChips = false;
   Object.keys(activeFilters).forEach(filterType => {
     activeFilters[filterType].forEach(value => {
       // Skip feature filter in chips display (it's a sort option, not a removable filter)
       if (filterType === 'feature') return;
       
       hasChips = true;
       const chip = document.createElement('div');
       chip.className = 'ep-songlib__filter-chip';
       chip.dataset.filterType = filterType;
       chip.dataset.value = value;
       
      const label = filterType === 'genre' ? value :
                   filterType === 'bpm' ? `${value} BPM` :
                   filterType === 'vocal' ? value :
                   filterType === 'mood' ? value :
                   filterType === 'key' ? value :
                   filterType === 'theme' ? value :
                   filterType === 'section' ? value :
                   filterType === 'length' ? (value === 'short' ? 'Under 1:30' : value === 'medium' ? '1:30 - 2:30' : 'Over 2:30') :
                   filterType === 'price' ? (value === 'below-1000' ? 'Below Rs. 1000' : value === '1000-1500' ? 'Rs. 1000 - Rs. 1500' : value === 'above-1500' ? 'Above Rs. 1500' : value) :
                   value;
       
      chip.innerHTML = `
        <span style="white-space: nowrap; display: inline-block;">${label}</span>
        <button class="ep-songlib__filter-chip-remove" type="button" aria-label="Remove filter">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      `;
       
       const removeBtn = chip.querySelector('.ep-songlib__filter-chip-remove');
       removeBtn.addEventListener('click', () => {
         activeFilters[filterType] = activeFilters[filterType].filter(v => v !== value);
         
         // Remove active state from filter chip button
         const filterChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
         if (filterChip) filterChip.classList.remove('active');
         
         // Sync with mobile checkboxes if they exist
         const mobileCheckbox = root.querySelector(`.ep-songlib__mobile-filter-option input[data-filter-type="${filterType}"][value="${value}"]`);
         if (mobileCheckbox) mobileCheckbox.checked = false;
         
         // Apply the updated filters immediately on both desktop and mobile.
         filterChangeTriggered = true;
         updateFilterChips();
         applyFilters();
         updateDesktopActionButtons();
         filterChangeTriggered = false;
       });
       
       chipsContainer.appendChild(chip);
     });
   });
   
   if (hasChips) {
     chipsContainer.classList.add('has-chips');
   } else {
     chipsContainer.classList.remove('has-chips');
   }
 }

 // Sort products based on sort type
 function sortProducts(products, sortType) {
   if (!sortType) {
     return products; // Return as-is if no sort type
   }
   
   // Create a copy of the array to avoid mutating the original
   const sortedProducts = [...products];
   
   switch(sortType) {
     case 'newest':
     case 'latest':
       // Sort by created_at timestamp (newest/latest first = descending order)
       sortedProducts.sort((a, b) => {
         const dateA = parseInt(a.dataset.createdAt || '0', 10);
         const dateB = parseInt(b.dataset.createdAt || '0', 10);
         // Descending order: newest/latest first (larger timestamp first)
         return dateB - dateA;
      });
      break;
     
     // Trending - commented out
     // case 'trending':
     //   // Sort by view count (most viewed first = descending order)
     //   sortedProducts.sort((a, b) => {
     //     const viewsA = parseInt(a.dataset.viewCount || '0', 10);
     //     const viewsB = parseInt(b.dataset.viewCount || '0', 10);
     //     // Descending order: most viewed first
     //     return viewsB - viewsA;
     //   });
     //   break;
       
    // Top Downloads - commented out
    // case 'downloads':
    //   // Sort by order count (most ordered first = descending order)
    //   sortedProducts.sort((a, b) => {
    //     const ordersA = parseInt(a.dataset.orderCount || '0', 10);
    //     const ordersB = parseInt(b.dataset.orderCount || '0', 10);
    //     // Descending order: most ordered first
    //     return ordersB - ordersA;
    //   });
    //   break;
     
    case 'alphabetical':
      // Sort by product title alphabetically (A-Z)
      sortedProducts.sort((a, b) => {
        const titleA = (a.querySelector('.tli__title')?.textContent || '').trim().toLowerCase();
        const titleB = (b.querySelector('.tli__title')?.textContent || '').trim().toLowerCase();
        // Ascending order: A-Z
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });
      break;
     
    default:
      // No sorting for unknown types
      return products;
  }
   
   return sortedProducts;
 }

 // Apply filters to products
 function applyFilters() {
   const allProducts = Array.from(root.querySelectorAll('.track-list-item'));
   const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
   
   // Track if any filters are active
   const hasActiveFilters = Object.values(activeFilters).some(arr => arr.length > 0) || searchTerm !== '';
   
   allProducts.forEach(item => {
     let matches = true;
     
     // Check search term
    // if (searchTerm) {
    //   const title = item.querySelector('.tli__title')?.textContent.toLowerCase() || '';
    //   const tags = Array.from(item.querySelectorAll('.tli__chip')).map(chip => chip.textContent.toLowerCase()).join(' ');
    //   const searchableText = `${title} ${tags}`;
    //     if (!searchableText.includes(searchTerm)) {
    //       matches = false;
    //     }
    //  }


    // Check search term
    if (searchTerm) {
      const title = item.querySelector('.tli__title')?.textContent.toLowerCase() || '';

      const chips = Array.from(item.querySelectorAll('.tli__chip'))
        .map(chip => chip.textContent.toLowerCase().trim())
        .join(' ');

      const genres = (item.dataset.genres || '').replaceAll('||', ' ').toLowerCase();
      const bpm = (item.dataset.bpm || '').toLowerCase();
      const mood = (item.dataset.mood || '').replaceAll('||', ' ').toLowerCase();

      const key = (item.dataset.key || '').replaceAll('||', ' ').toLowerCase();
      const theme = (item.dataset.theme || '').replaceAll('||', ' ').toLowerCase();
      const vocal = (item.dataset.vocal || '').replaceAll('||', ' ').toLowerCase();
      const section = (item.dataset.section || item.dataset.tags || '').replaceAll('||', ' ').toLowerCase();

      const searchableText = `${title} ${chips} ${genres} ${bpm} ${mood} ${key} ${theme} ${vocal} ${section}`;

      if (!searchableText.includes(searchTerm)) {
        matches = false;
      }
    }

     // Check genre filter
     if (matches && activeFilters.genre.length > 0) {
       const itemGenres = (item.dataset.genres || '').split('||').filter(g => g);
       const hasGenre = activeFilters.genre.some(genre => itemGenres.includes(genre));
       if (!hasGenre) matches = false;
     }
     
     // Check BPM filter
     if (matches && activeFilters.bpm.length > 0) {
       const itemBpm = item.dataset.bpm || '';
       if (!activeFilters.bpm.includes(itemBpm)) matches = false;
     }
     
     // Check mood filter. Multiple selected moods use OR matching, and
     // each song's mood metafield is treated as separate || values.
     if (matches && activeFilters.mood.length > 0) {
       const itemMoods = (item.dataset.mood || '')
         .split('||')
         .map(normalizeValue)
         .filter(Boolean);

       const hasMood = activeFilters.mood.some(mood =>
         itemMoods.includes(normalizeValue(mood))
       );

       if (!hasMood) matches = false;
     }
     
    // Check key filter-------------
    // if (matches && activeFilters.key.length > 0) {
    //   const itemKeys = (item.dataset.key || '').split('||').filter(k => k);
    //   const hasKey = activeFilters.key.some(key => itemKeys.includes(key));
    //   if (!hasKey) matches = false;
    // }

    // Check key filter
    if (matches && activeFilters.key.length > 0) {
      const itemKeys = (item.dataset.key || '')
        .split('||')
        .map(k => k.trim().toLowerCase())
        .filter(Boolean);

      const hasKey = activeFilters.key.some(key =>
        itemKeys.includes(key.trim().toLowerCase())
      );

      if (!hasKey) matches = false;
    }

    // Check theme filter
    if (matches && activeFilters.theme.length > 0) {
      const itemThemes = (item.dataset.theme || '')
        .split('||')
        .map(t => t.trim().toLowerCase())
        .filter(Boolean);

      const hasTheme = activeFilters.theme.some(theme =>
        itemThemes.includes(theme.trim().toLowerCase())
      );

      if (!hasTheme) matches = false;
    }


    // Check vocal filter
    if (matches && activeFilters.vocal.length > 0) {
      const itemVocals = (item.dataset.vocal || '').split('||').filter(v => v);
      const hasVocal = activeFilters.vocal.some(vocal => itemVocals.includes(vocal));
      if (!hasVocal) matches = false;
    }
     
     // Check Section filter. data-section is preferred; data-tags remains
     // as a fallback so existing Liquid markup continues to work.
     if (matches && activeFilters.section.length > 0) {
       const itemSections = (item.dataset.section || item.dataset.tags || '')
         .split('||')
         .map(normalizeValue)
         .filter(Boolean);

       const hasSection = activeFilters.section.some(section =>
         itemSections.includes(normalizeValue(section))
       );

       if (!hasSection) matches = false;
     }
     
     // Check price filter
     if (matches && activeFilters.price.length > 0) {
       const itemPriceRange = item.dataset.priceRange || '';
       if (!activeFilters.price.includes(itemPriceRange)) matches = false;
     }
     
     // Check length filter
     if (matches && activeFilters.length.length > 0) {
       const itemLength = item.dataset.trackLength || item.getAttribute('data-track-length') || '';
       if (!activeFilters.length.includes(itemLength)) {
         matches = false;
       }
     }
     
     // Set filtered attribute - pagination will check this
     item.dataset.filtered = matches ? 'true' : 'false';
   });
   
   // Apply sorting based on feature filter
   const currentSort = activeFilters.feature && activeFilters.feature.length > 0
     ? activeFilters.feature[0]
     : 'newest'; // Default to newest
   
   // Get the product list container
   const productListContainer = root.querySelector('.ep-songlib__list');
   if (productListContainer && currentSort) {
     // Get all products (both filtered and unfiltered) to maintain DOM order
     const allProductsArray = Array.from(productListContainer.querySelectorAll('.track-list-item'));
     
     // Sort all products based on current sort type
     const sortedProducts = sortProducts(allProductsArray, currentSort);
     
     // Reorder DOM elements based on sorted order
     sortedProducts.forEach((product) => {
       productListContainer.appendChild(product);
     });
   }
   
  // Reset to page 1 when filters change (not on search), if pagination exists
  if (filterChangeTriggered && typeof currentPage !== 'undefined' && currentPage !== undefined) {
    currentPage = 1;
  }
 
  // Update item visibility
  if (updateDisplay && typeof updateDisplay === 'function') {
    // Update items visibility based on current page and filters
    updateDisplay();
} else {
    // If no pagination, just show/hide based on filters
    // Products are already sorted in DOM, so just show/hide them
    allProducts.forEach(item => {
      item.style.display = item.dataset.filtered === 'true' ? 'grid' : 'none';
    });
  }
}

 // Mobile filters modal
 const mobileFiltersBtn = root.querySelector('.ep-songlib__mobile-filters-btn');
 const mobileFiltersModal = root.querySelector('#mobile-filters-modal');
 const mobileFiltersClose = root.querySelector('.ep-songlib__mobile-filters-close');
 const mobileFiltersApply = root.querySelector('.ep-songlib__mobile-filters-apply');
 
// Mobile filter group collapsible functionality
const mobileFilterGroupHeaders = root.querySelectorAll('.ep-songlib__mobile-filter-group-header');
mobileFilterGroupHeaders.forEach(header => {
  header.addEventListener('click', () => {
    const group = header.closest('.ep-songlib__mobile-filter-group');
    if (group) {
      group.classList.toggle('expanded');
    }
  });
});

// Mobile filter chip click handlers
const mobileFilterChips = root.querySelectorAll('.ep-songlib__mobile-filter-chip');
mobileFilterChips.forEach(chip => {
  chip.addEventListener('click', (e) => {
    e.stopPropagation();
    const originalFilterType = chip.dataset.filterType;
    const filterType = normalizeFilterType(originalFilterType);
    const value = chip.dataset.filterValue;
   
    if (!filterType || !value) return;
   
    const isActive = chip.classList.contains('active');
   
    // Feature filter is single-selection (only one option active at a time)
    if (filterType === 'feature') {
      if (!isActive) {
        // Remove active state from all mobile feature chips
        const allMobileFeatureChips = root.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="feature"]`);
        allMobileFeatureChips.forEach(c => c.classList.remove('active'));
       
        // Set the clicked chip as active
        chip.classList.add('active');
        activeFilters[filterType] = [value];
       
        // Update URL with sort parameter
        updateURLWithSort(value);
       
        // Sync with desktop sort dropdowns
        const sortDropdowns = root.querySelectorAll('.ep-songlib__sort');
        sortDropdowns.forEach(sd => {
          const sdOptions = sd.querySelectorAll('.ep-songlib__sort-option');
          sdOptions.forEach(o => o.classList.remove('active'));
          const matchingOption = sd.querySelector(`.ep-songlib__sort-option[data-filter-value="${value}"]`);
          if (matchingOption) {
            matchingOption.classList.add('active');
          }
        });
       
        // Update all sort labels (including mobile heading)
        updateAllSortLabels();
       
        // Apply filters immediately
        filterChangeTriggered = true;
        applyFilters();
        filterChangeTriggered = false;
      }
      // If clicking the same feature option, don't deselect it (always keep one selected)
    } else {
      // Multi-selection for other filters
      if (isActive) {
        chip.classList.remove('active');
        activeFilters[filterType] = activeFilters[filterType].filter(v => v !== value);
      } else {
        chip.classList.add('active');
        if (!activeFilters[filterType].includes(value)) {
          activeFilters[filterType].push(value);
        }
      }
     
      // Sync with desktop chips
      const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${originalFilterType}"][data-filter-value="${value}"], .ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
      if (desktopChip) {
        if (chip.classList.contains('active')) {
          desktopChip.classList.add('active');
        } else {
          desktopChip.classList.remove('active');
        }
      }
    }
   
    updateMobileFilterTitle();
    filterChangeTriggered = true;
    updateFilterChips();
    applyFilters();
    filterChangeTriggered = false;
  });
});

if (mobileFiltersBtn && mobileFiltersModal) {
  mobileFiltersBtn.addEventListener('click', () => {
    // Sync mobile chips with desktop chip buttons before opening
    const mobileChips = mobileFiltersModal.querySelectorAll('.ep-songlib__mobile-filter-chip');
    mobileChips.forEach(mobileChip => {
      const filterType = mobileChip.dataset.filterType;
      const value = mobileChip.dataset.filterValue;
      const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
      if (desktopChip) {
        if (desktopChip.classList.contains('active')) {
          mobileChip.classList.add('active');
        } else {
          mobileChip.classList.remove('active');
        }
      }
    });
   
    updateMobileFilterTitle();
    mobileFiltersModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
}

if (mobileFiltersClose) {
  mobileFiltersClose.addEventListener('click', () => {
    mobileFiltersModal.classList.remove('active');
    document.body.style.overflow = '';
  });
}

if (mobileFiltersModal) {
  mobileFiltersModal.addEventListener('click', (e) => {
    if (e.target === mobileFiltersModal) {
      mobileFiltersModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
}

// Clear All button
const mobileFiltersClear = root.querySelector('.ep-songlib__mobile-filters-clear');
if (mobileFiltersClear) {
  mobileFiltersClear.addEventListener('click', () => {
    // Clear all active filters
    Object.keys(activeFilters).forEach(filterType => {
      activeFilters[filterType] = [];
    });
   
    // Clear search input
    if (searchInput) {
      searchInput.value = '';
    }
   
    // Remove active class from all mobile chips
    const mobileChips = mobileFiltersModal.querySelectorAll('.ep-songlib__mobile-filter-chip');
    mobileChips.forEach(chip => {
      chip.classList.remove('active');
    });
   
    // Remove active class from all desktop chips
    const desktopChips = root.querySelectorAll('.ep-songlib__filter-chip');
    desktopChips.forEach(chip => {
      chip.classList.remove('active');
    });
   
    updateMobileFilterTitle();
    updateFilterChips();
    applyFilters();
  });
}

if (mobileFiltersApply) {
  mobileFiltersApply.addEventListener('click', () => {
    // Update filters from mobile chips
    Object.keys(activeFilters).forEach(filterType => {
      activeFilters[filterType] = [];
      const activeChips = mobileFiltersModal.querySelectorAll(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"].active`);
      activeChips.forEach(chip => {
        activeFilters[filterType].push(chip.dataset.filterValue);
      });
    });
   
    // Sync with desktop chips
    const mobileChips = mobileFiltersModal.querySelectorAll('.ep-songlib__mobile-filter-chip.active');
    mobileChips.forEach(mobileChip => {
      const filterType = mobileChip.dataset.filterType;
      const value = mobileChip.dataset.filterValue;
      const desktopChip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
      if (desktopChip) {
        desktopChip.classList.add('active');
      }
    });
   
    // Remove active from desktop chips that aren't active in mobile
    const desktopChips = root.querySelectorAll('.ep-songlib__filter-chip.active');
    desktopChips.forEach(desktopChip => {
      const filterType = desktopChip.dataset.filterType;
      const value = desktopChip.dataset.filterValue;
      const mobileChip = mobileFiltersModal.querySelector(`.ep-songlib__mobile-filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"]`);
      if (!mobileChip || !mobileChip.classList.contains('active')) {
        desktopChip.classList.remove('active');
      }
    });
   
    filterChangeTriggered = true; // Mark that filters changed
    updateFilterChips();
    applyFilters();
    filterChangeTriggered = false; // Reset flag
    mobileFiltersModal.classList.remove('active');
    document.body.style.overflow = '';
  });
}

// Desktop Clear All button
const desktopClearBtn = root.querySelector('.ep-songlib__desktop-clear-btn');
if (desktopClearBtn) {
  desktopClearBtn.addEventListener('click', () => {
    // Clear all active filters
    Object.keys(activeFilters).forEach(filterType => {
      activeFilters[filterType] = [];
    });
   
    // Clear search input
    if (searchInput) {
      searchInput.value = '';
    }
   
    // Remove active class from all mobile chips
    const mobileChips = root.querySelectorAll('.ep-songlib__mobile-filter-chip');
    mobileChips.forEach(chip => {
      chip.classList.remove('active');
    });
   
    // Remove active class from all desktop chips
    const desktopChips = root.querySelectorAll('.ep-songlib__filter-chip');
    desktopChips.forEach(chip => {
      chip.classList.remove('active');
    });
   
    updateMobileFilterTitle();
    updateFilterChips();
    updateDesktopActionButtons(); // Hide buttons after clearing
    applyFilters();
  });
}

// Desktop Show Results button
const desktopShowResultsBtn = root.querySelector('.ep-songlib__desktop-show-results-btn');
if (desktopShowResultsBtn) {
  desktopShowResultsBtn.style.display = 'none';
  desktopShowResultsBtn.addEventListener('click', () => {
    // Apply filters when Show Results is clicked on desktop
    // Note: Search works independently and is already applied, this only applies other filters
    filterChangeTriggered = true;
    updateFilterChips();
    applyFilters();
    filterChangeTriggered = false;
  });
}
 
 if (searchInput) {
   //console.log('🔍 Search input found, setting up search functionality');
   searchInput.addEventListener('input', (e) => {
     //console.log('🔍 Searching for:', e.target.value);
     // Reset to page 1 when searching so results always start from first page
     // This ensures that if user is on page 2+ and searches, they see results from page 1
     if (typeof currentPage !== 'undefined' && currentPage !== undefined) {
       currentPage = 1;
     }
     // Apply search immediately on both desktop and mobile - search works independently
     applyFilters(); // Use unified filter function (this will call updateDisplay() which updates pagination)
     // Update button visibility on desktop (for other filters)
     if (isDesktop()) {
       updateDesktopActionButtons();
     }
   });
 }

// Initialize all products as filtered initially
const allProducts = Array.from(root.querySelectorAll('.track-list-item'));

// Initialize all products as visible on page load
if (allProducts.length > 0) {
  // Mark all as visible initially
  allProducts.forEach(item => {
    item.dataset.filtered = 'true';
  });
}

// Function to calculate track length category from duration in seconds
function getTrackLengthCategory(totalSeconds) {
  if (!totalSeconds || totalSeconds <= 0) return '';
  if (totalSeconds < 90) return 'short';
  if (totalSeconds <= 150) return 'medium';
  return 'long';
}

// Function to extract duration from audio and update track length
// This function loads ONLY metadata, not the full audio file - it does NOT play audio
function extractAndUpdateTrackLength(productElement, audioElement) {
  if (!audioElement || !productElement) return;
 
  // Prevent any accidental playback
  if (!audioElement.paused) {
    audioElement.pause();
  }
 
  // Check if duration is already available
  if (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) {
    const durationInSeconds = audioElement.duration;
    const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
   
    if (trackLengthCategory) {
      productElement.dataset.trackLength = trackLengthCategory;
      // console.log('✅ Updated track length:', {
      //   product: productElement.querySelector('.tli__title')?.textContent,
      //   duration: durationInSeconds,
      //   category: trackLengthCategory
      // });
    }
    return;
  }
 
  // Listen for when metadata is loaded (this event fires when duration becomes available)
  // Only add listener if not already added to avoid duplicates
  if (!audioElement.dataset.metadataListenerAdded) {
    audioElement.dataset.metadataListenerAdded = 'true';
   
    const handleMetadataLoaded = () => {
      // Ensure audio is paused (should already be paused, but double-check)
      if (!audioElement.paused) {
        audioElement.pause();
      }
     
      if (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) {
        const durationInSeconds = audioElement.duration;
        const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
       
        if (trackLengthCategory) {
          productElement.dataset.trackLength = trackLengthCategory;
          // console.log('✅ Extracted track length from audio:', {
          //   product: productElement.querySelector('.tli__title')?.textContent,
          //   duration: durationInSeconds,
          //   category: trackLengthCategory
          // });
         
          // Re-apply filters if any are active
          if (activeFilters.length.length > 0) {
            applyFilters();
          }
        }
      }
    };
   
    // Add listener with { once: true } so it automatically removes after firing
    audioElement.addEventListener('loadedmetadata', handleMetadataLoaded, { once: true });
   
    // Load ONLY metadata (not the full audio file) - this is safe and won't play audio
    // Set preload to metadata to only load metadata
    if (audioElement.preload !== 'metadata') {
      audioElement.preload = 'metadata';
    }
   
    // Load metadata if not already loading/loaded
    if (audioElement.readyState === 0 && audioElement.src) {
      // Use load() to load metadata - this does NOT play the audio
      audioElement.load();
    }
  }
}

// Extract duration from all products by loading metadata only
// Since Osaria player creates audio elements dynamically, we'll check for them
// This function loads ONLY metadata (not full audio), so it's safe and won't play audio
function extractDurationsFromAllProducts() {
  allProducts.forEach((productElement, index) => {
    // Try to find audio element directly in the product
    let audioElement = productElement.querySelector('audio');
   
    // If not found, try to find it through Osaria player
    if (!audioElement) {
      const osariaPlayer = productElement.querySelector('.osaria-player-custom-product-view');
      if (osariaPlayer) {
        // Try to get audio source from Osaria data
        const osariaData = productElement.dataset.productOsariaAudioData;
       
        // Create a temporary audio element to load metadata only
        if (osariaData) {
          try {
            const osariaDataObj = JSON.parse(osariaData);
            const audioUrl = osariaDataObj?.url || osariaDataObj?.src || osariaDataObj?.audio_url;
           
            if (audioUrl) {
              // Create a temporary audio element just for metadata extraction
              const tempAudio = new Audio();
              tempAudio.preload = 'metadata'; // Only load metadata, not full file
             
              tempAudio.addEventListener('loadedmetadata', () => {
                if (tempAudio.duration && isFinite(tempAudio.duration) && tempAudio.duration > 0) {
                  const durationInSeconds = tempAudio.duration;
                  const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
                  if (trackLengthCategory) {
                    productElement.dataset.trackLength = trackLengthCategory;
                    // console.log('✅ Extracted track length from Osaria data:', {
                    //   product: productElement.querySelector('.tli__title')?.textContent,
                    //   duration: durationInSeconds,
                    //   category: trackLengthCategory
                    // });
                   
                    // Re-apply filters if any are active
                    if (activeFilters.length.length > 0) {
                      applyFilters();
                    }
                  }
                }
                // Clean up
                tempAudio.src = '';
              });
             
              tempAudio.addEventListener('error', () => {
                console.warn('⚠️ Could not load metadata for:', productElement.querySelector('.tli__title')?.textContent);
                tempAudio.src = '';
              });
             
              // Load metadata (this does NOT play audio)
              tempAudio.src = audioUrl;
            }
          } catch (e) {
            console.warn('⚠️ Could not parse Osaria data for:', productElement.querySelector('.tli__title')?.textContent);
          }
        }
       
        // Also use MutationObserver to watch for audio elements being added by Osaria
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeName === 'AUDIO' || (node.querySelector && node.querySelector('audio'))) {
                const audio = node.nodeName === 'AUDIO' ? node : node.querySelector('audio');
                if (audio) {
                  extractAndUpdateTrackLength(productElement, audio);
                }
              }
            });
          });
        });
       
        observer.observe(osariaPlayer, { childList: true, subtree: true });
       
        // Also check after delays in case audio elements are created asynchronously
        setTimeout(() => {
          audioElement = productElement.querySelector('audio');
          if (audioElement) {
            extractAndUpdateTrackLength(productElement, audioElement);
          }
        }, 500);
       
        setTimeout(() => {
          audioElement = productElement.querySelector('audio');
          if (audioElement) {
            extractAndUpdateTrackLength(productElement, audioElement);
          }
        }, 2000);
      }
    } else {
      // Audio element found directly - extract duration by loading metadata
      extractAndUpdateTrackLength(productElement, audioElement);
    }
  });
}

// Run extraction on page load, but only for already-loaded audio
// This prevents auto-playing all tracks
extractDurationsFromAllProducts();

// Also set up listeners for when audio loads naturally (via user interaction)
// Don't force load on page initialization

// Debug: Log all track lengths to see what values products have
//console.log('🎵 Track Length Debug - All products:');
allProducts.forEach((item, index) => {
  const trackLength = item.dataset.trackLength || '(empty)';
  const productTitle = item.querySelector('.tli__title')?.textContent || 'Unknown';
  console.log(`  Product ${index + 1}: "${productTitle}" - Track Length: "${trackLength}"`);
});

 // Initialize filter chips to sync with activeFilters (if any are set)
 // This ensures chips show as active when filters are applied
 function syncChipStates() {
   Object.keys(activeFilters).forEach(filterType => {
     activeFilters[filterType].forEach(value => {
       const selectorType = filterType === 'section' ? 'tags' : filterType;
       const chip = root.querySelector(`.ep-songlib__filter-chip[data-filter-type="${filterType}"][data-filter-value="${value}"], .ep-songlib__filter-chip[data-filter-type="${selectorType}"][data-filter-value="${value}"]`);
       if (chip) {
         chip.classList.add('active');
       }
     });
   });
 }
 
 // Call sync after page load
 syncChipStates();
 updateMobileFilterTitle(); // Initialize mobile filter title

  // Advanced Pagination System - declare variables in outer scope
  let currentPage = 1;
  let updateDisplay = null;
  const paginationData = root.querySelector('#pagination-data');
 
  if (paginationData) {
    const itemsPerPage = parseInt(paginationData.dataset.itemsPerPage);
    const totalProducts = parseInt(paginationData.dataset.totalProducts);
    const totalPages = parseInt(paginationData.dataset.totalPages);
   
    //console.log('📊 Pagination Data:', { itemsPerPage, totalProducts, totalPages });
   
    // Function to show/hide products based on current page
    updateDisplay = () => {
      // Get all filtered products from DOM (in their sorted order, not from static allProducts array)
      // Query the container to get products in their current DOM order (after sorting)
      const container = root.querySelector('.ep-songlib__list');
      const filteredProducts = container
        ? Array.from(container.querySelectorAll('.track-list-item')).filter(item => item.dataset.filtered === 'true')
        : allProducts.filter(item => item.dataset.filtered === 'true');
      const filteredCount = filteredProducts.length;
     
      // Calculate total pages based on filtered products
      const filteredTotalPages = Math.max(1, Math.ceil(filteredCount / itemsPerPage));
     
      // Calculate page range for current page
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
     
      // Hide all products first
      allProducts.forEach(item => {
        item.style.display = 'none';
      });
     
      // Show only products in current page range from filtered results
      filteredProducts.forEach((item, index) => {
        if (index >= startIndex && index < endIndex) {
          item.style.display = 'grid';
        }
      });
     
      // Update pagination controls with filtered count
      updatePaginationControls(filteredCount, filteredTotalPages);
    };
   
    // Update pagination button states
    const updatePaginationControls = (filteredCount = null, filteredTotalPages = null) => {
      // Use filtered counts if provided, otherwise use original counts
      const actualTotalPages = filteredTotalPages !== null ? filteredTotalPages : totalPages;
     
      const prevBtn = root.querySelector('#prev-btn');
      const nextBtn = root.querySelector('#next-btn');
      const pageNumbers = root.querySelector('#page-numbers');
     
      if (prevBtn) {
        prevBtn.disabled = currentPage === 1;
      }
     
      if (nextBtn) {
        nextBtn.disabled = currentPage >= actualTotalPages;
      }
     
      // Show/hide and enable/disable "Show More" button - only show if there are at least itemsPerPage (12) more products
      // Works in parallel with filters and pagination
      const showMoreBtn = root.querySelector('.show-more-btn');
      if (showMoreBtn) {
        // Calculate remaining items beyond what's currently shown
        const actualFilteredCount = filteredCount !== null ? filteredCount : totalProducts;
        const itemsShown = currentPage * itemsPerPage;
        const remainingItems = actualFilteredCount - itemsShown;
        
        // Show More button should only appear if there are at least itemsPerPage (12) more products available
        // This ensures the button text "Show 12 more" is accurate
        const hasEnoughMoreItems = remainingItems >= itemsPerPage;
        const hasMorePages = currentPage < actualTotalPages;
        
        // Show More should only work if:
        // 1. There are at least itemsPerPage (12) more filtered items to show, AND
        // 2. There are more pages to show (pagination has more pages)
        // Works in parallel with both filters and pagination
        const shouldEnable = hasEnoughMoreItems && hasMorePages && actualTotalPages > 1;
        
        // Debug logging
        // console.log('🔍 Show More Button Check:', {
        //   currentPage,
        //   actualTotalPages,
        //   actualFilteredCount,
        //   itemsShown,
        //   remainingItems,
        //   itemsPerPage,
        //   hasEnoughMoreItems,
        //   hasMorePages,
        //   shouldEnable
        // });
        
        // Hide and disable button if not enough items (less than itemsPerPage remaining)
        if (!shouldEnable) {
          showMoreBtn.style.display = 'none';
          showMoreBtn.disabled = true;
          //console.log('✅ Hiding and disabling Show More button - not enough items (need at least ' + itemsPerPage + ' more)');
        } else {
          showMoreBtn.style.display = 'flex';
          showMoreBtn.disabled = false;
          //console.log('✅ Showing and enabling Show More button - ' + remainingItems + ' items remaining');
        }
      }
     
      // Only update page numbers if container exists
      if (pageNumbers) {
        // Check if page numbers need to be regenerated (when total pages change)
        const existingPages = pageNumbers.querySelectorAll('.page-number');
        const existingPageCount = existingPages.length;
        const isMobile = window.innerWidth <= 768;
        const hasEllipsis = pageNumbers.querySelector('.ellipsis') !== null;
       
        // Check if current page is visible in pagination (for mobile with ellipsis)
        const visiblePageNumbers = Array.from(existingPages)
          .filter(el => !el.classList.contains('ellipsis')) // Skip ellipsis elements
          .map(el => parseInt(el.dataset.page) || parseInt(el.textContent))
          .filter(num => !isNaN(num));
        const isCurrentPageVisible = visiblePageNumbers.includes(currentPage);
        
        // Calculate expected page count for mobile with ellipsis
        // If current page is 1, 2, or last: expect 4 items (1, 2, ..., last)
        // If current page is in middle: expect 5 items (1, 2, ..., currentPage, ..., last)
        const expectedMobilePageCount = (isMobile && actualTotalPages > 4) 
          ? ((currentPage > 2 && currentPage < actualTotalPages) ? 5 : 4)
          : actualTotalPages;
        
        // Regenerate if:
        // 1. Total pages changed
        // 2. Pages don't exist
        // 3. On mobile and structure should be different (has ellipsis when shouldn't, or vice versa)
        // 4. On mobile and page count doesn't match expected count
        // 5. Current page is not visible in pagination (important for mobile with ellipsis)
        const shouldRegenerate = (!isMobile && existingPageCount !== actualTotalPages) ||
                                  existingPageCount === 0 ||
                                  (isMobile && actualTotalPages <= 4 && hasEllipsis) ||
                                  (!isMobile && hasEllipsis) ||
                                  (isMobile && actualTotalPages > 4 && existingPageCount !== expectedMobilePageCount) ||
                                  (isMobile && actualTotalPages > 4 && !isCurrentPageVisible);
       
        if (shouldRegenerate) {
          // Check if mobile view (width <= 768px)
          const isMobile = window.innerWidth <= 768;
          
          // Regenerate page numbers with new total
          let pageHtml = '';
          
          if (isMobile && actualTotalPages > 4) {
            // Mobile view: Show 1, 2, ..., last number
            // Always show first page
            if (1 === currentPage) {
              pageHtml += `<span class="page-number active">1</span>`;
            } else {
              pageHtml += `<button class="page-number" data-page="1">1</button>`;
            }
            
            // Always show second page
            if (2 === currentPage) {
              pageHtml += `<span class="page-number active">2</span>`;
            } else {
              pageHtml += `<button class="page-number" data-page="2">2</button>`;
            }
            
            // Show current page if it's not 1, 2, or last
            if (currentPage > 2 && currentPage < actualTotalPages) {
              // Show ellipsis before current page if there's a gap
              if (currentPage > 3) {
                pageHtml += `<span class="page-number ellipsis">...</span>`;
              }
              
              // Show current page
              pageHtml += `<span class="page-number active">${currentPage}</span>`;
              
              // Show ellipsis after current page if there's a gap
              if (currentPage < actualTotalPages - 1) {
                pageHtml += `<span class="page-number ellipsis">...</span>`;
              }
            } else {
              // Show ellipsis if current page is 1, 2, or last (only when more than 4 pages)
              if (actualTotalPages > 4) {
                pageHtml += `<span class="page-number ellipsis">...</span>`;
              }
            }
            
            // Always show last page
            if (actualTotalPages === currentPage) {
              pageHtml += `<span class="page-number active">${actualTotalPages}</span>`;
            } else {
              pageHtml += `<button class="page-number" data-page="${actualTotalPages}">${actualTotalPages}</button>`;
            }
          } else {
            // Desktop view or mobile with 4 or fewer pages: Show all numbers
            for (let i = 1; i <= actualTotalPages; i++) {
              if (i === currentPage) {
                pageHtml += `<span class="page-number active">${i}</span>`;
              } else {
                pageHtml += `<button class="page-number" data-page="${i}">${i}</button>`;
              }
            }
          }
        pageNumbers.innerHTML = pageHtml;
       
        // Add click handlers to page numbers (skip ellipsis)
        pageNumbers.querySelectorAll('.page-number').forEach(btn => {
          if (btn.dataset.page && !btn.classList.contains('ellipsis')) {
              btn.setAttribute('data-listener', 'true');
            btn.addEventListener('click', () => {
              currentPage = parseInt(btn.dataset.page);
              updateDisplay();
            });
          }
        });
        } else {
          // Just update active state without regenerating HTML
          existingPages.forEach(pageEl => {
            // Skip ellipsis elements - they don't have page numbers
            if (pageEl.classList.contains('ellipsis')) {
              return;
            }
            
            const pageNum = parseInt(pageEl.dataset.page) || parseInt(pageEl.textContent);
            // Skip if pageNum is NaN (shouldn't happen, but safety check)
            if (isNaN(pageNum)) {
              return;
            }
            
            if (pageNum === currentPage) {
              pageEl.classList.add('active');
              // If it's a button, convert to span to match original design
              if (pageEl.tagName === 'BUTTON') {
                const span = document.createElement('span');
                span.className = 'page-number active';
                span.textContent = pageNum;
                pageEl.parentNode.replaceChild(span, pageEl);
              }
            } else {
              pageEl.classList.remove('active');
              // If it's a span (was active), convert back to button
              if (pageEl.tagName === 'SPAN') {
                const btn = document.createElement('button');
                btn.className = 'page-number';
                btn.dataset.page = pageNum;
                btn.textContent = pageNum;
                if (!btn.hasAttribute('data-listener')) {
                  btn.setAttribute('data-listener', 'true');
                  btn.addEventListener('click', () => {
                    currentPage = parseInt(btn.dataset.page);
                    updateDisplay();
                  });
                }
                pageEl.parentNode.replaceChild(btn, pageEl);
              } else if (pageEl.tagName === 'BUTTON' && !pageEl.hasAttribute('data-listener')) {
                // Add click handler if not already added
                pageEl.setAttribute('data-listener', 'true');
                pageEl.addEventListener('click', () => {
                  currentPage = parseInt(pageEl.dataset.page);
                  updateDisplay();
                });
              }
            }
          });
        }
      }
    };
   
    // Add resize listener to update pagination when switching between mobile/desktop
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Force regeneration of pagination on resize
        const pageNumbers = root.querySelector('#page-numbers');
        if (pageNumbers) {
          // Clear existing pages to force regeneration
          pageNumbers.innerHTML = '';
          updatePaginationControls();
        }
      }, 150);
    });
   
    // Previous button
    const prevBtn = root.querySelector('#prev-btn');
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentPage > 1) {
          currentPage--;
          updateDisplay();
        }
      });
    }
   
    // Next button
    const nextBtn = root.querySelector('#next-btn');
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        // Calculate filtered pages dynamically
        const filteredProducts = allProducts.filter(item => item.dataset.filtered === 'true');
        const filteredTotalPages = Math.max(1, Math.ceil(filteredProducts.length / itemsPerPage));
       
        if (currentPage < filteredTotalPages) {
          currentPage++;
          updateDisplay();
        }
      });
    }
   
    // Show More button - only works if there are at least itemsPerPage (12) more products available
    const showMoreBtn = root.querySelector('.show-more-btn');
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', () => {
        // Don't proceed if button is disabled
        if (showMoreBtn.disabled) {
          //console.log('🚫 Show More button is disabled, ignoring click');
          return;
        }
        
        // Check if there are at least itemsPerPage (12) more filtered items available
        // Use the same logic as updateDisplay to get filtered products
        const container = root.querySelector('.ep-songlib__list');
        const filteredProducts = container
          ? Array.from(container.querySelectorAll('.track-list-item')).filter(item => item.dataset.filtered === 'true')
          : allProducts.filter(item => item.dataset.filtered === 'true');
        const filteredTotalPages = Math.max(1, Math.ceil(filteredProducts.length / itemsPerPage));
        const totalItems = filteredProducts.length;
        const itemsShown = currentPage * itemsPerPage;
        const remainingItems = totalItems - itemsShown;
        const hasEnoughMoreItems = remainingItems >= itemsPerPage;
        const hasMorePages = currentPage < filteredTotalPages;
        
        // Only proceed if there are at least itemsPerPage (12) more items AND more pages
        // Works in parallel with both filters and pagination
        if (hasEnoughMoreItems && hasMorePages && filteredTotalPages > 1) {
          currentPage++;
          updateDisplay();
        } else {
          //console.log('🚫 Not enough items to show (need at least ' + itemsPerPage + ' more, but only ' + remainingItems + ' remaining)');
          // Disable button if not enough items
          showMoreBtn.disabled = true;
          showMoreBtn.style.display = 'none';
        }
      });
    }
   
    // Initialize display
    updateDisplay();
   
    // Initialize filters - apply on page load
    if (typeof applyFilters === 'function') {
      applyFilters();
    }
  }
 
// --- Osaria Player Integration ---
let activeRow = null;
let activePlayer = null;
let selectedMediaSyncListener = null; // Store reference to selected media sync listener

  function pauseAllCartAudio() {
    try {
      const pauseCartAudio = (container) => { if (container) container.querySelectorAll('audio').forEach(audio => { if (!audio.paused) { audio.pause(); const cartItem = audio.closest('.cart-item-card, .cart__item, [class*="cart-item"]'); if (cartItem) { const playBtn = cartItem.querySelector('.cart-item-card__playbtn, [class*="playbtn"], button[aria-label*="Play"]'); if (playBtn) { playBtn.classList.remove('playing', 'active'); const playIcon = playBtn.querySelector('.play-icon, [class*="play"]'), pauseIcon = playBtn.querySelector('.pause-icon, [class*="pause"]'); if (playIcon) playIcon.style.display = ''; if (pauseIcon) pauseIcon.style.display = 'none'; } } } }); };
      pauseCartAudio(document.querySelector('cart-drawer-component') || document.querySelector('[id*="cart-drawer"]') || document.querySelector('cart-drawer') || document.querySelector('[class*="cart-drawer"]'));
      pauseCartAudio(document.querySelector('.cart-items__wrapper'));
    } catch (error) { console.warn('⚠️ Error pausing cart audio:', error); }
  }

  function pauseAllMusicStoreAudio() {
    try {
      root.querySelectorAll('audio').forEach(audio => { if (!audio.paused) { audio.pause(); const trackItem = audio.closest('.track-list-item'); if (trackItem) { setPlayIcon(trackItem, false); trackItem.classList.remove('playing'); } } });
      if (window.StickyAudioPlayer?.getCurrentTrack) { const currentTrack = window.StickyAudioPlayer.getCurrentTrack(); if (currentTrack?.element?.closest('.track-list-item')) { const stickyAudio = window.StickyAudioPlayer.getAudioElement?.(); if (stickyAudio && !stickyAudio.paused) { stickyAudio.pause(); window.StickyAudioPlayer.updatePlayPause?.(false); } } }
    } catch (error) { console.warn('⚠️ Error pausing music store audio:', error); }
  }

  function setupCartAudioObserver() {
    const targetElement = document.querySelector('cart-drawer-component') || document.querySelector('[id*="cart-drawer"]') || document.querySelector('cart-drawer') || document.querySelector('[class*="cart-drawer"]') || document.querySelector('.cart-items__wrapper');
    if (targetElement) {
      const setupCartAudioListeners = () => { targetElement.querySelectorAll('audio').forEach(audio => { if (!audio.dataset.cartPlayListenerAdded) { audio.dataset.cartPlayListenerAdded = 'true'; audio.addEventListener('play', () => { pauseAllMusicStoreAudio(); document.dispatchEvent(new CustomEvent('cart:audio:play', { bubbles: true })); }); } }); };
      setupCartAudioListeners();
      new MutationObserver(setupCartAudioListeners).observe(targetElement, { childList: true, subtree: true });
      return true;
    }
    return false;
  }
  if (!setupCartAudioObserver()) { setTimeout(() => { if (!setupCartAudioObserver()) { document.addEventListener('cart:drawer:open', () => { setTimeout(() => setupCartAudioObserver(), 500); }, { once: true }); } }, 1000); }
  document.addEventListener('cart:content:refreshed', () => { setTimeout(() => setupCartAudioObserver(), 500); });
  document.addEventListener('cart:audio:play', () => { pauseAllMusicStoreAudio(); });
  
  // Listen for sticky player pause/play events - immediate UI update
  document.addEventListener('stickyPlayerPause', (e) => {
    const { variantId, productId, source } = e.detail;
    if (source === 'musicLibrary') return; // Ignore our own events
    
    //console.log('🎵 Music Store - Received stickyPlayerPause event', { variantId, productId, source });
    
    // Immediately update all playing tracks in this section
    root.querySelectorAll('.track-list-item.playing').forEach(track => {
      const trackVariantId = track.dataset.variantId;
      const trackProductId = track.dataset.productId;
      
      // If variantId matches or no variantId specified (pause all), pause this track
      if (!variantId || (trackVariantId && Number(trackVariantId) === Number(variantId)) || 
          (productId && trackProductId && Number(trackProductId) === Number(productId))) {
        track.classList.remove('playing');
        setPlayIcon(track, false);
        
        // Also pause the audio element if it exists
        const audio = track.querySelector('audio');
        if (audio && !audio.paused) {
          audio.pause();
        }
      }
    });
    
    // Clear activeRow if it matches
    if (activeRow) {
      const activeVariantId = activeRow.dataset.variantId;
      const activeProductId = activeRow.dataset.productId;
      if (!variantId || (activeVariantId && Number(activeVariantId) === Number(variantId)) ||
          (productId && activeProductId && Number(activeProductId) === Number(productId))) {
        activeRow = null;
        activePlayer = null;
      }
    }
  });
  
  document.addEventListener('stickyPlayerPlay', (e) => {
    const { variantId, productId, source } = e.detail;
    if (source === 'musicLibrary') return; // Ignore our own events
    
    //console.log('🎵 Music Store - Received stickyPlayerPlay event', { variantId, productId, source });
    
    // Find and update the track that should be playing
    if (variantId || productId) {
      const track = root.querySelector(
        variantId ? `.track-list-item[data-variant-id="${variantId}"]` :
        `.track-list-item[data-product-id="${productId}"]`
      );
      
      if (track) {
        track.classList.add('playing');
        setPlayIcon(track, true);
        activeRow = track;
      }
    }
  });

  // format seconds → m:ss
  const fmt = (sec) => {
    if (!isFinite(sec) || sec < 0) return '0:00';
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60).toString().padStart(2,'0');
    return `${m}:${s}`;
  };

  // Initialize all time displays to show total duration on page load
  const initializeTimeDisplays = () => {
    const allRows = root.querySelectorAll('.track-list-item');
    allRows.forEach(row => {
      const current = row.querySelector('.tli__current');
      const currentMobile = row.querySelector('.tli__current-mobile');
      const totalElement = row.querySelector('.tli__total');
     
      // Only set if not already playing or loading, and total element exists
      if (totalElement && !row.classList.contains('playing')) {
        const totalDuration = totalElement.textContent.trim();
       
        // Set desktop time display if it exists and is not in loading state
        if (current && !current.classList.contains('loading')) {
          current.textContent = totalDuration;
        }
       
        // Set mobile time display if it exists and is not in loading state
        if (currentMobile && !currentMobile.classList.contains('loading')) {
          currentMobile.textContent = totalDuration;
        }
      }
    });
  };
 
  // Initialize time displays on page load and after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTimeDisplays);
  } else {
    initializeTimeDisplays();
  }

  // Toggle icons
  const setPlayIcon = (row, playing, loading = false) => {
    const play = row.querySelector('.icon-play');
    const pause = row.querySelector('.icon-pause');
    if (!play || !pause) return;
   
    if (loading) {
      play.style.display = 'none';
      pause.style.display = 'none';
      row.classList.remove('showing-pause');
    } else {
      play.style.display = playing ? 'none' : 'block';
      pause.style.display = playing ? 'block' : 'none';
      // Add/remove showing-pause class for overlay
      if (playing) {
        row.classList.add('showing-pause');
      } else {
        row.classList.remove('showing-pause');
      }
    }
  };

 // Reset all play icons except the active one
 const resetAllPlayIcons = (exceptRow = null) => {
 root.querySelectorAll('.track-list-item').forEach(trackRow => {
 if (trackRow !== exceptRow) {
 setPlayIcon(trackRow, false);
 }
 });
 };

  // Reset previously active row UI
  const resetActive = () => {
    if (!activeRow) return;
    setPlayIcon(activeRow, false);
    const seek = activeRow.querySelector('.tli__seek');
    const current = activeRow.querySelector('.tli__current');
    const currentMobile = activeRow.querySelector('.tli__current-mobile');
    if (seek) seek.value = 0;
   
    // Reset to total duration instead of '0:00'
    const totalElement = activeRow.querySelector('.tli__total');
    const audioElement = activeRow.querySelector('audio');
   
    if (current) {
      // Try to get duration from audio element first
      if (audioElement && audioElement.duration && isFinite(audioElement.duration)) {
        current.textContent = fmt(audioElement.duration);
      } else if (totalElement) {
        current.textContent = totalElement.textContent.trim();
      } else {
        current.textContent = '0:00';
      }
      current.classList.remove('loading', 'error');
    }
    if (currentMobile) {
      // Try to get duration from audio element first
      if (audioElement && audioElement.duration && isFinite(audioElement.duration)) {
        currentMobile.textContent = fmt(audioElement.duration);
      } else if (totalElement) {
        currentMobile.textContent = totalElement.textContent.trim();
      } else {
        currentMobile.textContent = '0:00';
      }
    }
    activeRow = null;
  };

  // Show loading state
  const showLoading = (row) => {
 //console.log('🔄 Showing loading state for:', row.querySelector('.tli__title').textContent);
    setPlayIcon(row, false, true);
    const current = row.querySelector('.tli__current');
    const currentMobile = row.querySelector('.tli__current-mobile');
    if (current) {
      current.textContent = 'Loading...';
      current.classList.add('loading');
 //console.log('✅ Loading text set to:', current.textContent);
 } else {
 console.warn('❌ No .tli__current element found for loading state');
    }
    if (currentMobile) {
      currentMobile.textContent = 'Loading...';
    }
  };

  // Handle audio errors
  const handleAudioError = (row) => {
    setPlayIcon(row, false);
    const current = row.querySelector('.tli__current');
    const currentMobile = row.querySelector('.tli__current-mobile');
    if (current) {
 current.textContent = 'Loading...';
 current.classList.remove('error');
 current.classList.add('loading');
 }
 if (currentMobile) {
 currentMobile.textContent = 'Loading...';
 }
 console.warn('Audio failed to load for track:', row.querySelector('.tli__title').textContent);
 };

 // Initialize Osaria Player for a track
 const initOsariaPlayer = (row) => {
 const osariaData = row.dataset.productOsariaAudioData;
 if (!osariaData) {
 console.warn('❌ No Osaria data found for track:', row.querySelector('.tli__title').textContent);
 return null;
 }

 // Create Osaria player element
 const playerDiv = row.querySelector('.osaria-player-custom-product-view');
 if (!playerDiv) {
 console.warn('❌ No Osaria player div found for track:', row.querySelector('.tli__title').textContent);
 return null;
 }

 // Initialize Osaria player (this will be handled by Osaria's JavaScript)
 //console.log('🎵 Initializing Osaria player for:', row.querySelector('.tli__title').textContent);
 return playerDiv;
  };

  // Bind clicks
  root.querySelectorAll('.track-list-item').forEach((row, index) => {
 console.log(`🎵 Setting up track ${index + 1}:`, row.querySelector('.tli__title')?.textContent);
    const btn = row.querySelector('.tli__playbtn');
    const seek = row.querySelector('.tli__seek');
    const addBtn = row.querySelector('.tli__add');
 //console.log('🎵 Play button found:', !!btn);
 //console.log('🎵 Seek bar found:', !!seek);
 //console.log('🎵 Add button found:', !!addBtn);
 if (!btn) {
 console.warn('❌ No play button found for track:', row.querySelector('.tli__title')?.textContent);
 return;
 }

    // Make entire track clickable (except play button and add to cart button)
    row.style.cursor = 'pointer';
    row.setAttribute('tabindex', '0');
    row.setAttribute('role', 'button');
    row.setAttribute('aria-label', `Play track: ${row.querySelector('.tli__title').textContent}`);
   
    // Helper function to check if click/touch should be ignored
    const shouldIgnoreInteraction = (target) => {
      return target.closest('.tli__playbtn') ||
             target.closest('.tli__add') ||
             target.closest('.tli__seek') ||
             target.closest('.tli__seek-container');
    };
   
    // Handle click events
    row.addEventListener('click', (e) => {
      // Don't trigger if clicking on play button, add button, or seek bar
      if (shouldIgnoreInteraction(e.target)) {
        return;
      }
     
      //console.log('🎵 Track clicked:', row.querySelector('.tli__title').textContent);
      // Trigger the play button click
      btn.click();
    });
   
    // Handle touch events for mobile compatibility
    let rowTouchStartTime = 0;
    let rowTouchStartTarget = null;
   
    row.addEventListener('touchstart', (e) => {
      // Check if touch started on a button that should be ignored
      if (shouldIgnoreInteraction(e.target)) {
        // Don't track this touch - let the button handle it
        rowTouchStartTime = 0;
        rowTouchStartTarget = null;
        return;
      }
      rowTouchStartTime = Date.now();
      rowTouchStartTarget = e.target;
    }, { passive: true });
   
    row.addEventListener('touchend', (e) => {
      // Don't trigger if touching on play button, add button, or seek bar
      const endTarget = e.target;
      const startTarget = rowTouchStartTarget;
     
      // Check if touch was on any button that should be ignored
      if (shouldIgnoreInteraction(endTarget) || shouldIgnoreInteraction(startTarget)) {
        // Reset tracking and don't trigger
        rowTouchStartTime = 0;
        rowTouchStartTarget = null;
        return;
      }
     
      // Only trigger if we have valid tracking data
      if (!rowTouchStartTime || !rowTouchStartTarget) {
        return;
      }
     
      // Only trigger if it was a quick tap (not a swipe)
      const touchDuration = Date.now() - rowTouchStartTime;
      if (touchDuration < 300 && touchDuration > 0) {
        e.preventDefault();
        e.stopPropagation();
        //console.log('🎵 Track touched:', row.querySelector('.tli__title').textContent);
        // Trigger the play button click
        btn.click();
      }
     
      // Reset tracking
      rowTouchStartTime = 0;
      rowTouchStartTarget = null;
    }, { passive: false });

    // play/pause
    btn.addEventListener('click', () => {
 //console.log('🎵 Clicked play button for:', row.querySelector('.tli__title').textContent);
 //console.log('🎵 Osaria data:', row.dataset.productOsariaAudioData);
 
 // Check if Osaria data exists
 const osariaData = row.dataset.productOsariaAudioData;
 if (!osariaData || osariaData === 'null' || osariaData === '') {
 console.warn('❌ No Osaria data found for track:', row.querySelector('.tli__title').textContent);
 alert('No audio source found for this track. Please check Osaria metafields.');
        return;
      }

     // If same track is already playing, pause it
     if (row === activeRow && activePlayer) {
       //console.log('🎵 Pausing current track');
       // Remove playing class
       row.classList.remove('playing');
       // Try to pause the Osaria player
       const audioElement = row.querySelector('audio');
       if (audioElement) {
         audioElement.pause();
       }
        setPlayIcon(row, false);
       // Reset progress bar and time
       const seek = row.querySelector('.tli__seek');
       const current = row.querySelector('.tli__current');
       const currentMobile = row.querySelector('.tli__current-mobile');
       if (seek) {
         seek.value = 0;
         seek.style.setProperty('--value', '0%');
       }
       const seekFill = row.querySelector('.tli__seek-fill');
       if (seekFill) seekFill.style.width = '0%';
         if (current) {
             current.textContent = '0:00';
           current.classList.remove('loading');
         }
         if (currentMobile) {
             currentMobile.textContent = '0:00';
         }
       
       // Notify sticky player about pause
       notifyPlayPause(false);
       
       activeRow = null;
       activePlayer = null;
        return;
      }

   // Stop any currently playing track
 if (activeRow && activeRow !== row) {
 //console.log('🎵 Stopping previous track');
 const prevAudio = activeRow.querySelector('audio');
 if (prevAudio) {
 prevAudio.pause();
 }
 setPlayIcon(activeRow, false);
 }
 
 // Reset all play icons to ensure only one shows pause
 resetAllPlayIcons();

 // Set new active row
 activeRow = row;
        showLoading(row);

 // Initialize Osaria player
 const player = initOsariaPlayer(row);
 if (player) {
 activePlayer = player;
 
 // Wait for Osaria player to initialize and find audio element
 const checkForAudio = () => {
 const audioElement = row.querySelector('audio');
 if (audioElement) {
 //console.log('🎵 Audio element found, setting up events');
 
// Set up audio events
audioElement.addEventListener('loadstart', () => {
 //console.log('🎵 Audio loadstart');
 // Don't extract here to avoid triggering unwanted loads
 });
 
audioElement.addEventListener('canplay', () => {
//console.log('🎵 Audio canplay');
setPlayIcon(row, true);
const current = row.querySelector('.tli__current');
const currentMobile = row.querySelector('.tli__current-mobile');
// Show total duration when audio is ready
if (audioElement.duration && isFinite(audioElement.duration)) {
  const totalDuration = fmt(audioElement.duration);
  if (current) {
    current.textContent = totalDuration;
    current.classList.remove('loading');
  }
  if (currentMobile) {
    currentMobile.textContent = totalDuration;
  }
} else {
  // Fallback: try to get from tli__total element
  const totalElement = row.querySelector('.tli__total');
  if (current) {
    if (totalElement) {
      current.textContent = totalElement.textContent.trim();
    } else {
      current.textContent = '0:00';
    }
    current.classList.remove('loading');
  }
  if (currentMobile) {
    if (totalElement) {
      currentMobile.textContent = totalElement.textContent.trim();
    } else {
      currentMobile.textContent = '0:00';
     }
   }
 }
 
 // Extract and update track length from audio duration
 if (audioElement.duration && isFinite(audioElement.duration) && audioElement.duration > 0) {
   const durationInSeconds = audioElement.duration;
   const trackLengthCategory = getTrackLengthCategory(durationInSeconds);
   if (trackLengthCategory) {
     row.dataset.trackLength = trackLengthCategory;
     //console.log('✅ Updated track length from canplay event:', {
    //    product: row.querySelector('.tli__title')?.textContent,
    //    duration: durationInSeconds,
    //    category: trackLengthCategory
    //  });
     
     // Re-apply filters if any are active
     if (activeFilters.length.length > 0) {
       applyFilters();
     }
   }
 }
 });
 
     audioElement.addEventListener('play', () => {
       //console.log('🎵 Audio playing');
       
       // Pause any playing audio in cart drawer
       pauseAllCartAudio();
       
       // Remove playing class from all tracks
       root.querySelectorAll('.track-list-item').forEach(track => {
         track.classList.remove('playing');
       });
       // Add playing class to current track
       row.classList.add('playing');
       // Reset all other tracks to show play button
       resetAllPlayIcons(row);
       // Show pause button for this track
          setPlayIcon(row, true);
         // Set this as active row
         activeRow = row;
       
       // Prepare track data for sticky player
       const titleElement = row.querySelector('.tli__title');
       const titleText = titleElement?.textContent?.trim();
       const albumArtElement = row.querySelector('.tli__cover img');
       const albumArtSrc = albumArtElement?.src;
       
       //console.log('🎵 Music store - title element:', titleElement);
       //console.log('🎵 Music store - title text:', titleText);
       //console.log('🎵 Music store - album art element:', albumArtElement);
       //console.log('🎵 Music store - album art src:', albumArtSrc);
       
       // Create comprehensive track data
       const trackData = {
         title: titleText || 'Unknown Track',
         artist: 'Unknown Artist', // You can enhance this with metafields
         albumArt: albumArtSrc || '',
         duration: audioElement.duration || 0,
         element: row // Add the track element for cart functionality
       };
       
       //console.log('🎵 Music store - sending track data to global API:', trackData);
       
       // Send track list to sticky player first
       sendTrackListToStickyPlayer();
       
       // Use global sticky player API
       if (window.StickyAudioPlayer) {
         window.StickyAudioPlayer.show(trackData);
         window.StickyAudioPlayer.connect(audioElement);
         window.StickyAudioPlayer.updatePlayPause(true);
       } else {
         console.warn('🎵 Global StickyAudioPlayer not available, using fallback');
         notifyStickyPlayer(trackData, audioElement);
         notifyPlayPause(true);
       }
     });
 
     audioElement.addEventListener('pause', () => {
       //console.log('🎵 Audio paused');
         row.classList.remove('playing');
         setPlayIcon(row, false);
         
         // Clear activeRow and activePlayer if this is the active track
         // This ensures that clicking play again will resume instead of requiring two clicks
         if (activeRow === row) {
           activeRow = null;
           activePlayer = null;
         }
         
         // Notify sticky player about pause using global API
         if (window.StickyAudioPlayer) {
           window.StickyAudioPlayer.updatePlayPause(false);
         } else {
           notifyPlayPause(false);
       }
     });
 
audioElement.addEventListener('timeupdate', () => {
if (activeRow === row) {
const current = row.querySelector('.tli__current');
const currentMobile = row.querySelector('.tli__current-mobile');
const seek = row.querySelector('.tli__seek');
if (current && audioElement.duration && isFinite(audioElement.duration)) {
// Show remaining time (countdown)
const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
current.textContent = fmt(remaining);
}
if (currentMobile && audioElement.duration && isFinite(audioElement.duration)) {
// Show remaining time (countdown)
const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
currentMobile.textContent = fmt(remaining);
}
if (seek && audioElement.duration && isFinite(audioElement.duration)) {
const progress = (audioElement.currentTime / audioElement.duration) * 1000;
seek.value = Math.round(progress);
// Update CSS custom property for gradient fill
const fillWidth = (audioElement.currentTime / audioElement.duration) * 100;
seek.style.setProperty('--value', `${fillWidth}%`);
const seekFill = row.querySelector('.tli__seek-fill');
if (seekFill) seekFill.style.width = `${fillWidth}%`;
//console.log('🎵 Progress update:', audioElement.currentTime, '/', audioElement.duration, '=', progress);
}
}
});
 
 audioElement.addEventListener('ended', () => {
 //console.log('🎵 Audio ended');
 if (activeRow === row) {
 row.classList.remove('playing');
 setPlayIcon(row, false);
 const seek = row.querySelector('.tli__seek');
 const current = row.querySelector('.tli__current');
 const currentMobile = row.querySelector('.tli__current-mobile');
 if (seek) {
 seek.value = 0;
 seek.style.setProperty('--value', '0%');
 }
 const seekFill = row.querySelector('.tli__seek-fill');
 if (seekFill) seekFill.style.width = '0%';
 // Reset to total duration (countdown starts at full duration)
 if (audioElement.duration && isFinite(audioElement.duration)) {
   const totalDuration = fmt(audioElement.duration);
   if (current) current.textContent = totalDuration;
   if (currentMobile) currentMobile.textContent = totalDuration;
 } else {
   // Fallback: try to get from tli__total element
   const totalElement = row.querySelector('.tli__total');
   if (totalElement && current) {
     current.textContent = totalElement.textContent.trim();
   }
   if (totalElement && currentMobile) {
     currentMobile.textContent = totalElement.textContent.trim();
   }
 }
 activeRow = null;
 activePlayer = null;
 }
 });
 
 audioElement.addEventListener('error', (e) => {
 console.error('🎵 Audio error:', e);
 // Show loading instead of error
 const current = row.querySelector('.tli__current');
 const currentMobile = row.querySelector('.tli__current-mobile');
 if (current) {
 current.textContent = 'Loading...';
 current.classList.remove('error');
 current.classList.add('loading');
 }
 if (currentMobile) {
 currentMobile.textContent = 'Loading...';
 }
 });
 
 // Try to play
 const playPromise = audioElement.play();
 if (playPromise) {
   playPromise.then(() => {
     // Enable seek bar when audio starts playing
     const seek = row.querySelector('.tli__seek');
     if (seek) {
       seek.disabled = false;
       //console.log('🎵 Seek bar enabled for:', row.querySelector('.tli__title').textContent);
     }
   }).catch((error) => {
     console.error('🎵 Playback failed:', error);
     // Show loading instead of error
     const current = row.querySelector('.tli__current');
     const currentMobile = row.querySelector('.tli__current-mobile');
     if (current) {
       current.textContent = 'Loading...';
       current.classList.remove('error');
       current.classList.add('loading');
     }
     if (currentMobile) {
       currentMobile.textContent = 'Loading...';
     }
   });
 }
 } else {
 // Keep checking for audio element
 setTimeout(checkForAudio, 100);
 }
 };
 
 checkForAudio();
 } else {
 // Show loading instead of error
 const current = row.querySelector('.tli__current');
 const currentMobile = row.querySelector('.tli__current-mobile');
 if (current) {
 current.textContent = 'Loading...';
 current.classList.remove('error');
 current.classList.add('loading');
 }
 if (currentMobile) {
 currentMobile.textContent = 'Loading...';
 }
      }
    });

    // Simple and reliable seek interactions
    if (seek) {
      //console.log('🎵 Setting up seek bar for:', row.querySelector('.tli__title').textContent);
      //console.log('🎵 Seek bar disabled?', seek.disabled);
     
      // Make sure seek bar is enabled
      seek.disabled = false;
     
      // Simple input event for real-time updates
      seek.addEventListener('input', function(e) {
        //console.log('🎵 INPUT EVENT:', e.target.value);
       
        // Always update the visual progress
        const fillWidth = (Number(e.target.value) / 1000) * 100;
        seek.style.setProperty('--value', `${fillWidth}%`);
        const seekFill = row.querySelector('.tli__seek-fill');
        if (seekFill) seekFill.style.width = `${fillWidth}%`;
       
        // Update time display (show remaining time)
        const current = row.querySelector('.tli__current');
        const currentMobile = row.querySelector('.tli__current-mobile');
        if ((current || currentMobile) && activeRow === row) {
          // Check if selected media is playing this track
          const variantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
          const selectedMediaTrack = variantId ? document.querySelector(`.sm-track-item[data-variant-id="${variantId}"]`) : null;
          const selectedAudio = selectedMediaTrack ? selectedMediaTrack.querySelector('audio') : null;
         
          // Use selected media audio if available, otherwise use local audio
          const audioElement = selectedAudio || row.querySelector('audio');
         
          if (audioElement && audioElement.duration && isFinite(audioElement.duration)) {
            const pct = Number(e.target.value) / 1000;
            const t = audioElement.duration * pct;
            const remaining = Math.max(0, audioElement.duration - t);
            const timeStr = fmt(remaining);
            if (current) current.textContent = timeStr;
            if (currentMobile) currentMobile.textContent = timeStr;
          }
        }
      });
     
      // Change event for final seek
      seek.addEventListener('change', function(e) {
        //console.log('🎵 CHANGE EVENT:', e.target.value);
       
        if (activeRow === row) {
          // Check if selected media is playing this track
          const variantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
          const selectedMediaTrack = variantId ? document.querySelector(`.sm-track-item[data-variant-id="${variantId}"]`) : null;
          const selectedAudio = selectedMediaTrack ? selectedMediaTrack.querySelector('audio') : null;
         
          // Use selected media audio if available, otherwise use local audio
          const audioElement = selectedAudio || row.querySelector('audio');
         
          if (audioElement && audioElement.duration) {
            const pct = Number(e.target.value) / 1000;
            const newTime = audioElement.duration * pct;
            audioElement.currentTime = newTime;
            //console.log('🎵 Seeked to:', fmt(newTime), selectedAudio ? '(selected media)' : '(music library)');
          }
        }
      });
     
      // Test all possible events
      seek.addEventListener('mousedown', () => console.log('🎵 MOUSEDOWN'));
      seek.addEventListener('mouseup', () => console.log('🎵 MOUSEUP'));
      seek.addEventListener('mousemove', () => console.log('🎵 MOUSEMOVE'));
      seek.addEventListener('click', () => console.log('🎵 CLICK'));
      seek.addEventListener('touchstart', () => console.log('🎵 TOUCHSTART'));
      seek.addEventListener('touchend', () => console.log('🎵 TOUCHEND'));
    }
  });

 // Osaria player initialization
 //console.log('🎵 Osaria player integration ready');

 // Function to update cart count in header
//  function updateCartCount() {
//    fetch('/cart.js')
//      .then(response => response.json())
//      .then(cart => {
//        // Update cart count in header
//        const cartCountElement = document.getElementById('CartCount');
//        if (cartCountElement) {
//          cartCountElement.querySelector('span').textContent = cart.item_count;
//        }
       
//        // Update cart count in any other cart elements
//        const cartCountElements = document.querySelectorAll('.cart-count, .cart-item-count');
//        cartCountElements.forEach(element => {
//          element.textContent = cart.item_count;
//        });
       
//        //console.log('🛒 Cart count updated:', cart.item_count);
//      })
//      .catch(error => {
//        console.error('❌ Failed to update cart count:', error);
//      });
//   }
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      let displayCount = 0;

      cart.items.forEach((item) => {

        const hasCustomProperty =
          item.properties &&
          Object.keys(item.properties).some(
            key => key.includes('Your Name')
          );

        if (hasCustomProperty) {

          // Custom Vocal Order
          displayCount += 1;

        } else {

          // Normal products
          displayCount += item.quantity;

        }

      });

      // Header count
      const cartCountElement = document.getElementById('CartCount');

      if (cartCountElement) {
        const span = cartCountElement.querySelector('span');

        if (span) {
          span.textContent = displayCount;
        }
      }

      // Other cart count elements
      const cartCountElements = document.querySelectorAll(
        '.cart-count, .cart-item-count'
      );

      cartCountElements.forEach((element) => {
        element.textContent = displayCount;
      });

      console.log('🛒 Display Count:', displayCount);
    })
    .catch(error => {
      console.error('❌ Failed to update cart count:', error);
    });
}

  // Function to check if a variant is in the cart
  // Cache cart state to avoid redundant fetches
  let cartCache = null;
  let cartCacheTime = 0;
  const CART_CACHE_DURATION = 100; // Cache for 100ms to batch rapid calls
  
  async function isVariantInCart(variantId) {
    try {
      const now = Date.now();
      // Use cache if available and recent
      if (cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
        return cartCache.items.some(item => item.variant_id === variantId);
      }
      // Fetch fresh cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();
      cartCache = cart;
      cartCacheTime = now;
      return cart.items.some(item => item.variant_id === variantId);
    } catch (error) {
      console.error('❌ Failed to check cart:', error);
      return false;
    }
  }
  
  // Function to invalidate cart cache
  function invalidateCartCache() {
    cartCache = null;
    cartCacheTime = 0;
  }

  // Track last cart state for comparison
  let lastCartState = null;
  
  // Function to get current cart state as a string for comparison
  async function getCartStateString() {
    try {
      const now = Date.now();
      // Use cache if available and recent
      if (cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
        return cartCache.items.map(item => item.variant_id).sort().join(',');
      }
      // Fetch fresh cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();
      cartCache = cart;
      cartCacheTime = now;
      // Create a string representation of cart items (variant IDs)
      return cart.items.map(item => item.variant_id).sort().join(',');
    } catch (error) {
      console.warn('Failed to get cart state:', error);
      return null;
    }
  }

  // Function to check if cart has changed and update buttons (optimized)
  async function checkCartChanges() {
    try {
      // Fetch fresh cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cache
      cartCache = cart;
      cartCacheTime = Date.now();
      
      // Check if state changed
      const currentCartState = cart.items.map(item => item.variant_id).sort().join(',');
      if (currentCartState !== lastCartState && currentCartState !== null) {
        //console.log('🛒 Cart state changed, updating button states');
        lastCartState = currentCartState;
        
        // Update buttons using cached cart data (no additional fetch)
        const buttons = root.querySelectorAll('.tli__add');
        if (buttons.length > 0) {
          const cartVariantIds = new Set(cart.items.map(item => item.variant_id));
          buttons.forEach(btn => {
            const variantId = Number(btn.dataset.vid);
            if (!variantId) return;
            
            if (!btn.dataset.originalContent) {
              btn.dataset.originalContent = btn.innerHTML;
            }
            
            const isInCart = cartVariantIds.has(variantId);
            const originalContent = btn.dataset.originalContent;
            
            // if (isInCart) {
            //   btn.innerHTML = `
            //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            //       <path d="M5 13l4 4L19 7"/>
            //     </svg>
            //   `;
            //   btn.classList.add('success');
            //   btn.dataset.inCart = 'true';
            // } else {
            //   btn.innerHTML = originalContent;
            //   btn.classList.remove('success');
            //   btn.dataset.inCart = 'false';
            // }
          });
        }
        
        updateCartCount();
      }
    } catch (error) {
      console.warn('Failed to check cart changes:', error);
    }
  }

  // Function to check if variant is in Selected Media
  function isVariantInSelectedMedia(variantId) {
    try {
      const stored = localStorage.getItem('sm_selected_tracks');
      if (stored) {
        const tracks = JSON.parse(stored);
        return tracks.some(track => Number(track.variantId) === Number(variantId));
      }
    } catch (e) {
      console.warn('Failed to check Selected Media:', e);
    }
    return false;
  }

  // Function to update button state based on cart (NOT Selected Media - Selected Media tick is temporary)
  async function updateButtonState(button, variantId) {
    const isInCart = await isVariantInCart(variantId);
    const originalContent = button.dataset.originalContent || button.innerHTML;
   
    // Store original content if not already stored
    if (!button.dataset.originalContent) {
      button.dataset.originalContent = originalContent;
    }
   
    // Show red tick SVG ONLY if in cart (Selected Media items show temporary tick, not persistent)
    // if (isInCart) {
    //   // Show red tick SVG
    //   button.innerHTML = `
    //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
    //       <path d="M5 13l4 4L19 7"/>
    //     </svg>
    //   `;
    //   button.classList.add('success');
    //   button.dataset.inCart = 'true';
    //   // Make button non-clickable when showing tick (product in cart)
    //   button.style.pointerEvents = 'none';
    //   button.style.cursor = 'default';
    // } else {
    //   // Show plus
    //   button.innerHTML = originalContent;
    //   button.classList.remove('success');
    //   button.dataset.inCart = 'false';
    //   // Re-enable button clicks when not in cart
    //   button.style.pointerEvents = '';
    //   button.style.cursor = '';
    // }
  }

  // Function to update all add to cart buttons based on cart state (optimized - single fetch)
  async function updateAllButtonStates() {
    const buttons = root.querySelectorAll('.tli__add');
    if (buttons.length === 0) return;
    
    // Fetch cart once for all buttons
    const now = Date.now();
    let cart;
    if (cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
      cart = cartCache;
    } else {
      try {
        const response = await fetch('/cart.js');
        cart = await response.json();
        cartCache = cart;
        cartCacheTime = now;
      } catch (error) {
        console.error('Failed to fetch cart for button updates:', error);
        return;
      }
    }
    
    const cartVariantIds = new Set(cart.items.map(item => item.variant_id));
    const originalContent = buttons[0].dataset.originalContent || buttons[0].innerHTML;
    
    // Update all buttons in parallel using cached cart data
    buttons.forEach(btn => {
      const variantId = Number(btn.dataset.vid);
      if (!variantId) return;
      
      // Store original content if not already stored
      if (!btn.dataset.originalContent) {
        btn.dataset.originalContent = btn.innerHTML;
      }
      
      const isInCart = cartVariantIds.has(variantId);
      
      // if (isInCart) {
      //   // Show red tick SVG
      //   btn.innerHTML = `
      //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      //       <path d="M5 13l4 4L19 7"/>
      //     </svg>
      //   `;
      //   btn.classList.add('success');
      //   btn.dataset.inCart = 'true';
      //   // Make button non-clickable when showing tick (product in cart)
      //   btn.style.pointerEvents = 'none';
      //   btn.style.cursor = 'default';
      // } else {
      //   // Show plus
      //   const origContent = btn.dataset.originalContent || originalContent;
      //   btn.innerHTML = origContent;
      //   btn.classList.remove('success');
      //   btn.dataset.inCart = 'false';
      //   // Re-enable button clicks when not in cart
      //   btn.style.pointerEvents = '';
      //   btn.style.cursor = '';
      // }
    });
    
    // Also update sticky player cart button if there's a current track (using cached cart data)
    if (window.StickyAudioPlayer && window.StickyAudioPlayer.getCurrentTrack) {
      const currentTrack = window.StickyAudioPlayer.getCurrentTrack();
      if (currentTrack && currentTrack.element) {
        const addBtn = currentTrack.element.querySelector('.tli__add');
        if (addBtn) {
          const variantId = Number(addBtn.dataset.vid);
          if (variantId) {
            // Use cached cart data instead of fetching
            const isInCart = cartVariantIds.has(variantId);
            
            // Update add button if not already updated
            if (!addBtn.dataset.originalContent) {
              addBtn.dataset.originalContent = addBtn.innerHTML;
            }
            
            // if (isInCart) {
            //   addBtn.innerHTML = `
            //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            //       <path d="M5 13l4 4L19 7"/>
            //     </svg>
            //   `;
            //   addBtn.classList.add('success');
            //   addBtn.dataset.inCart = 'true';
            // } else {
            //   addBtn.innerHTML = addBtn.dataset.originalContent;
            //   addBtn.classList.remove('success');
            //   addBtn.dataset.inCart = 'false';
            // }
            
            // Update sticky player button to match (using cached data)
            const stickyCartBtn = document.getElementById('sap-cart');
            if (stickyCartBtn) {
              // if (isInCart) {
              //   stickyCartBtn.innerHTML = `
              //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              //       <path d="M5 13l4 4L19 7"/>
              //     </svg>
              //   `;
              //   stickyCartBtn.classList.add('success');
              // } else {
              //   stickyCartBtn.innerHTML = `
              //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              //       <path d="M12 5v14M5 12h14"/>
              //     </svg>
              //   `;
              //   stickyCartBtn.classList.remove('success');
              // }
            }
          }
        }
      }
    }
  }

  // AJAX Add to Cart with enhanced feedback
  root.querySelectorAll('.tli__add').forEach(btn => {
    // Store original content
    if (!btn.dataset.originalContent) {
      btn.dataset.originalContent = btn.innerHTML;
    }
   
    // Shared handler function for both click and touch events
    let isHandling = false; // Flag to prevent double-triggering
    
    const handleAddButton = async (e) => {
      //console.log('🎵 handleAddButton called', { isHandling, disabled: btn.disabled });
     
      // Prevent double-triggering
      if (isHandling) {
        //console.log('🎵 Already handling, skipping');
        return;
      }
      isHandling = true;
     
      // Prevent music playback when clicking/tapping add button
      if (e && e.stopPropagation) e.stopPropagation();
      if (e && e.preventDefault) e.preventDefault();
     
      if (btn.disabled) {
        //console.log('🎵 Button disabled, skipping');
        isHandling = false;
        return;
      }
     
      const variantId = Number(btn.dataset.vid);
      const isCurrentlyInCart = btn.dataset.inCart === 'true';
      const trackItem = btn.closest('.track-list-item');
     
      // If product is already in cart, prevent removing it from music-store-section
      // The tick should only disappear when product is removed from cart drawer or elsewhere
      if (isCurrentlyInCart) {
        //console.log('🎵 Product already in cart - button is ticked and cannot be unticked from music-store-section');
        isHandling = false;
        return;
      }
     
      // Check if Selected Media section exists on the page
      const selectedMediaSection = document.querySelector('.sm-wrap');
     
      if (selectedMediaSection && !isCurrentlyInCart) {
        // Send track to Selected Media section instead of adding directly to cart
        const titleEl = trackItem.querySelector('.tli__title');
        const title = titleEl ? titleEl.textContent.trim() : 'Unknown Track';
       
        const thumbnailEl = trackItem.querySelector('.tli__cover img');
        const thumbnail = thumbnailEl ? thumbnailEl.src : '';
       
        // Try to get duration from .tli__total (total duration) only
        // Don't use .tli__current-mobile as it shows current time (0:00) not total duration
        const durationEl = trackItem.querySelector('.tli__total');
        let duration = durationEl ? durationEl.textContent.trim() : '';
       
        // If duration is still empty or "0:00", try to get from audio element
        if (!duration || duration === '0:00') {
          const audioEl = trackItem.querySelector('audio');
          if (audioEl && audioEl.duration && isFinite(audioEl.duration) && audioEl.duration > 0) {
            const m = Math.floor(audioEl.duration / 60);
            const s = Math.floor(audioEl.duration % 60).toString().padStart(2, '0');
            duration = `${m}:${s}`;
          }
        }
       
        const priceEl = trackItem.querySelector('.tli__price-current');
        const price = priceEl ? priceEl.textContent.trim() : '';
       
        // Extract chips/tags
        const chipEls = trackItem.querySelectorAll('.tli__chip');
        const chips = Array.from(chipEls).map(chip => chip.textContent.trim()).filter(Boolean);
       
        // Get product ID from data attribute
        const productId = trackItem.dataset.productId ? Number(trackItem.dataset.productId) : null;
        const product_type = trackItem.getAttribute("data-product-type");
        const productType = product_type || null;

        console.log("productType",productType)

        // Get product handle from product link (for proper cart identification)
        let productHandle = null;
        const productLink = trackItem.querySelector('a[href*="/products/"]');
        if (productLink && productLink.href) {
          const urlMatch = productLink.href.match(/\/products\/([^\/\?#]+)/);
          if (urlMatch && urlMatch[1]) {
            productHandle = urlMatch[1];
            //console.log('🎵 Music Store - Extracted product handle:', productHandle);
          }
        }
       
        if (!productHandle) {
          console.warn('🎵 Music Store - Could not extract product handle from track item');
        }



        // Get Osaria audio data from data attribute (CRITICAL for playback)
        // Try multiple ways to get the data attribute
        let osariaAudioData = trackItem.dataset.productOsariaAudioData ||
                              trackItem.getAttribute('data-product-osaria-audio-data') ||
                              '';
       
        // If still empty, try to get from the Osaria player div
        if (!osariaAudioData || osariaAudioData === '') {
          const osariaPlayerDiv = trackItem.querySelector('.osaria-player-custom-product-view');
          if (osariaPlayerDiv) {
            osariaAudioData = osariaPlayerDiv.dataset.productOsariaAudioData ||
                             osariaPlayerDiv.getAttribute('data-product-osaria-audio-data') ||
                             '';
          }
        }
       
        //console.log('🎵 Music Library - Preparing track for Selected Media:', {
        //   variantId: variantId,
        //   title: title,
        //   hasOsariaData: !!osariaAudioData,
        //   osariaDataLength: osariaAudioData ? osariaAudioData.length : 0,
        //   osariaDataPreview: osariaAudioData ? osariaAudioData.substring(0, 50) + '...' : 'missing',
        //   trackItemHasAttribute: trackItem.hasAttribute('data-product-osaria-audio-data'),
        //   datasetValue: trackItem.dataset.productOsariaAudioData
        // });
       
        // Create track data object
        const trackData = {
          variantId: variantId,
          productId: productId,
          productHandle: productHandle,
          title: title,
          thumbnail: thumbnail,
          duration: duration,
          price: price,
          chips: chips,
          osariaAudioData: osariaAudioData,
          productType:productType,
        };
       
        //console.log('🎵 Music Library - Sending track to Selected Media:', {
        //   ...trackData,
        //   osariaAudioData: osariaAudioData ? `present (${osariaAudioData.length} chars)` : 'MISSING'
        // });
       
        // Dispatch event to Selected Media section
        const event = new CustomEvent('addTrackToSelected', {
          detail: trackData
        });
       
        //console.log('🎵 Music Library - Dispatching addTrackToSelected event:', {
        //   variantId: trackData.variantId,
        //   productId: trackData.productId,
        //   title: trackData.title
        // });
       
        // Dispatch event synchronously to ensure validation message can show immediately
        document.dispatchEvent(event);
       
        //console.log('🎵 Music Library - Event dispatched');
       
        // Immediate optimistic update - show tick right away
        const originalHTML = btn.innerHTML;
        btn.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M5 13l4 4L19 7"/>
          </svg>
        `;
        btn.classList.add('success');
        
        // Check for validation message in next frame (immediate check)
        requestAnimationFrame(() => {
          const validationMsg = document.querySelector('#smValidationMessage');
          const isValidationShowing = validationMsg &&
            (validationMsg.style.display === 'flex' ||
             validationMsg.style.visibility === 'visible' ||
             validationMsg.classList.contains('show') ||
             window.getComputedStyle(validationMsg).display === 'flex');
         
          if (isValidationShowing) {
            // Validation message showing - revert immediately
            btn.innerHTML = originalHTML;
            btn.classList.remove('success');
            isHandling = false;
            return;
          }
         
          // Show tick temporarily, then restore to "+" (not persistent for Selected Media)
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.classList.remove('success');
            // Check if item is in cart - if so, show tick via updateButtonState
            updateButtonState(btn, variantId);
            isHandling = false; // Reset flag to allow future clicks
          }, 1500); // Show tick for 1.5 seconds then restore
        });
       
        return; // Exit early, don't add to cart directly
      }
     
      // Original cart functionality if Selected Media section doesn't exist
      // Note: This code should never run if isCurrentlyInCart is true due to early return above
      const originalContent = btn.dataset.originalContent || btn.innerHTML;
      
      // Optimistic UI update - show immediate visual feedback (only for adding, not removing)
      // Optimistically show red tick immediately when adding
      btn.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M5 13l4 4L19 7"/>
        </svg>
      `;
      btn.classList.add('success');
      btn.dataset.inCart = 'true';
      // Make button non-clickable when showing tick
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'default';
      
      btn.disabled = true;
     
      // try {
      //   // Only handle adding to cart (removal is prevented by early return above)
      //   // Add to cart
      //   const res = await fetch('/cart/add.js', {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'Accept': 'application/json',
      //       'X-Requested-With': 'XMLHttpRequest'
      //     },
      //     body: JSON.stringify({ id: variantId, quantity: 1 })
      //   });
       
      //   if (!res.ok) {
      //     const errorData = await res.json().catch(() => ({}));
      //     throw new Error(errorData.message || 'Failed to add to cart');
      //   }
        
      //   // Use response cart data instead of fetching again
      //   const updatedCart = await res.json();
       
      //   // Update cache and state from response (no additional fetch needed)
      //   cartCache = updatedCart;
      //   cartCacheTime = Date.now();
      //   const newCartState = updatedCart.items.map(item => item.variant_id).sort().join(',');
      //   lastCartState = newCartState;
       
      //   // Update cart count in header
      //   updateCartCount();
       
      //   // Update this button's state to reflect actual cart state
      //   await updateButtonState(btn, variantId);
       
      //   // Dispatch cart:updated event to notify other listeners
      //   document.dispatchEvent(new CustomEvent('cart:updated', {
      //     bubbles: true,
      //     detail: { source: 'music-store-button' }
      //   }));
       
      //   // Update sticky player button if this is the current track
      //   if (trackItem && window.StickyAudioPlayer && window.StickyAudioPlayer.updateCartButton) {
      //     const currentTrack = window.StickyAudioPlayer.getCurrentTrack();
      //     if (currentTrack && currentTrack.element === trackItem) {
      //       // Use sticky player's update method
      //       window.StickyAudioPlayer.updateCartButton();
      //     }
      //   }
       
      //   btn.disabled = false;
      //   isHandling = false; // Reset flag immediately
       
      // } catch (e) {
      //   console.error('Add to cart error:', e);
      //   // Revert optimistic update on error
      //   await updateButtonState(btn, variantId);
      //   btn.classList.remove('error');
      //   btn.disabled = false;
      //   isHandling = false; // Reset flag immediately
      // }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        console.log("reseeeeeeeeeeeeeeeeeeeeeeeee",res)

        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.message || 'Failed to add to cart');
        }

        // /cart/add.js returns added item, not full cart
        const addedItem = await res.json();
        console.log('Added item:', addedItem);

        // latest full cart fetch
        const updatedCart = await fetch('/cart.js', {
          cache: 'no-store'
        }).then(res => res.json());

        console.log('Updated cart:', updatedCart);

        cartCache = updatedCart;
        cartCacheTime = Date.now();

        const newCartState = Array.isArray(updatedCart.items)
          ? updatedCart.items.map(item => item.variant_id).sort().join(',')
          : '';

        lastCartState = newCartState;

        // Update cart count in header
        if (typeof updateCartCount === 'function') {
          updateCartCount(updatedCart);
        }

        // Update this button's state
        await updateButtonState(btn, variantId);

        // Notify cart drawer
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              source: 'music-store-button',
              cart: updatedCart
            }
          })
        );

        // Also notify content refresh listeners
        document.dispatchEvent(
          new CustomEvent('cart:content:refreshed', {
            bubbles: true,
            detail: {
              cart: updatedCart
            }
          })
        );

        if (
          trackItem &&
          window.StickyAudioPlayer &&
          window.StickyAudioPlayer.updateCartButton
        ) {
          const currentTrack = window.StickyAudioPlayer.getCurrentTrack();

          if (currentTrack && currentTrack.element === trackItem) {
            window.StickyAudioPlayer.updateCartButton();
          }
        }

        btn.disabled = false;
        isHandling = false;
      } catch (e) {
        console.error('Add to cart error:', e);

        await updateButtonState(btn, variantId);

        btn.classList.remove('error');
        btn.disabled = false;
        isHandling = false;
      }
    };
   
    // Simple approach: Use both click and touch for maximum compatibility
    // On mobile, touch events fire first, then click fires ~300ms later
    // We'll handle both but prevent double-triggering
   
    let lastTriggerTime = 0;
    const TRIGGER_COOLDOWN = 500; // ms
   
    const triggerHandler = (e) => {
      const now = Date.now();
      // Prevent rapid double-triggers
      if (now - lastTriggerTime < TRIGGER_COOLDOWN) {
        return;
      }
      lastTriggerTime = now;
     
      // Stop propagation to prevent row handler
      if (e && e.stopPropagation) e.stopPropagation();
      if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
     
      // Call the handler
      handleAddButton(e);
    };
   
    // Handle click events (works on both desktop and mobile)
    btn.addEventListener('click', (e) => {
      // On mobile, click fires after touch, so we check if touch already handled it
      const timeSinceLastTrigger = Date.now() - lastTriggerTime;
      if (timeSinceLastTrigger < 300) {
        // Touch likely already handled it, skip click
        return;
      }
      triggerHandler(e);
    });
   
    // Handle touch events for mobile (fires before click)
    btn.addEventListener('touchend', (e) => {
      // Stop propagation immediately
      if (e && e.stopPropagation) e.stopPropagation();
      if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
     
      // Prevent default to stop click from also firing
      if (e && e.preventDefault) e.preventDefault();
     
      // Trigger handler immediately
      triggerHandler(e);
    }, { passive: false, capture: true });
  });
 
  // Initialize button states on page load
  updateAllButtonStates();

  // Initialize cart state tracking
  getCartStateString().then(state => {
    lastCartState = state;
  });

  // Listen for cart updates
  document.addEventListener('cart:updated', () => {
    //console.log('🛒 Cart updated event received, refreshing button states');
    updateAllButtonStates();
    updateCartCount();
    // Update tracked state
    getCartStateString().then(state => {
      lastCartState = state;
    });
  });

  // Also listen for custom cart events
  window.addEventListener('cartUpdated', () => {
    //console.log('🛒 Cart updated (custom event), refreshing button states');
    updateAllButtonStates();
    updateCartCount();
    // Update tracked state
    getCartStateString().then(state => {
      lastCartState = state;
    });
  });

  // Listen for cart:change event (Shopify cart drawer)
  document.addEventListener('cart:change', () => {
    //console.log('🛒 Cart change event received, refreshing button states');
    // Immediate update
    updateAllButtonStates();
    updateCartCount();
    getCartStateString().then(state => {
      lastCartState = state;
    });
  });

  // Listen for cart drawer content refresh (when items are added/removed)
  document.addEventListener('cart:content:refreshed', () => {
    //console.log('🛒 Cart content refreshed, updating button states');
    // Clear cart cache to force fresh fetch
    cartCache = null;
    cartCacheTime = 0;
    // Update all button states
    updateAllButtonStates();
    updateCartCount();
    getCartStateString().then(state => {
      lastCartState = state;
    });
  });

  // Listen for cart drawer open/close events
  document.addEventListener('cart:drawer:open', () => {
    //console.log('🛒 Cart drawer opened, will check for changes');
  });

  document.addEventListener('cart:drawer:close', () => {
    //console.log('🛒 Cart drawer closed, checking for changes');
    checkCartChanges(); // Immediate check
  });

  // Poll for cart changes every 5 seconds (as backup - reduced frequency)
  setInterval(() => {
    checkCartChanges();
  }, 5000);

  // Also check when window regains focus (user might have removed items in another tab)
  window.addEventListener('focus', () => {
    //console.log('🛒 Window focused, checking cart changes');
    checkCartChanges();
    // Also update button states to sync with Selected Media changes
    updateAllButtonStates();
  });

  // Track Selected Media localStorage for changes
  let lastSelectedMediaState = null;
  
  function getSelectedMediaState() {
    try {
      const stored = localStorage.getItem('sm_selected_tracks');
      return stored || '';
    } catch (e) {
      return '';
    }
  }
  
  function checkSelectedMediaChanges() {
    const currentState = getSelectedMediaState();
    if (currentState !== lastSelectedMediaState) {
      //console.log('🎵 Selected Media changed, updating button states');
      lastSelectedMediaState = currentState;
      updateAllButtonStates();
    }
  }
  
  // Initialize Selected Media state
  lastSelectedMediaState = getSelectedMediaState();
  
  // Listen for storage events (fires when localStorage changes in other tabs/windows)
  window.addEventListener('storage', (e) => {
    if (e.key === 'sm_selected_tracks') {
      //console.log('🎵 Selected Media storage event detected, updating button states');
      lastSelectedMediaState = e.newValue || '';
      updateAllButtonStates();
    }
  });
  
  // Poll for Selected Media changes (for same-window changes) - reduced frequency
  setInterval(() => {
    checkSelectedMediaChanges();
  }, 2000);

  // Watch for cart drawer changes using MutationObserver
  const cartDrawer = document.querySelector('cart-drawer-component') || document.querySelector('[id*="cart-drawer"]');
  if (cartDrawer) {
    const cartObserver = new MutationObserver(() => {
      // When cart drawer content changes, check for cart updates immediately
      checkCartChanges();
    });
    
    // Observe cart drawer for changes
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: false
    });
    
    //console.log('🛒 Cart drawer observer set up');
  }

  // Listen for cart item removal events (common Shopify pattern)
  document.addEventListener('cart:item:removed', () => {
    //console.log('🛒 Cart item removed event received');
    checkCartChanges(); // Immediate update
  });

  // Listen for any cart-related mutations in the document
  const documentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check if cart-related elements changed
      if (mutation.target && (
        mutation.target.classList?.contains('cart-item') ||
        mutation.target.closest?.('.cart-item') ||
        mutation.target.closest?.('cart-drawer-component') ||
        mutation.target.closest?.('cart-items-component')
      )) {
        checkCartChanges(); // Immediate update
      }
    });
  });

  // Observe document body for cart-related changes
  documentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Keyboard navigation support
  root.addEventListener('keydown', (e) => {
    if (e.target.classList.contains('tli__playbtn') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      e.target.click();
    }
   
    // Support keyboard navigation for entire track items
    if (e.target.classList.contains('track-list-item') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      const playBtn = e.target.querySelector('.tli__playbtn');
      if (playBtn) {
        playBtn.click();
      }
    }
  });

// Function to notify sticky player about track changes
// Function to build track list from all visible tracks
const buildTrackList = () => {
  const trackItems = document.querySelectorAll('.track-list-item');
  const trackList = [];
 
  trackItems.forEach((item, index) => {
    const title = item.querySelector('.tli__title')?.textContent?.trim() || 'Unknown Track';
    const albumArt = item.querySelector('.tli__cover img')?.src || '';
    const artist = 'Unknown Artist'; // You can add artist metafield if available
   
    trackList.push({
      title,
      artist,
      albumArt,
      element: item,
      index: index
    });
  });
 
  return trackList;
};

// Function to send track list to sticky player
const sendTrackListToStickyPlayer = () => {
  const trackList = buildTrackList();
  //console.log('🎵 Sending track list to sticky player:', trackList);
 
  if (window.StickyAudioPlayer && window.StickyAudioPlayer.setTrackList) {
    window.StickyAudioPlayer.setTrackList(trackList);
  }
};

const notifyStickyPlayer = (trackData, audioElement) => {
  //console.log('🎵 Notifying sticky player:', trackData);
  //console.log('🎵 StickyAudioPlayer available:', !!window.StickyAudioPlayer);
 
  // Send track list to sticky player
  sendTrackListToStickyPlayer();
 
  // Try direct API call first
  if (window.StickyAudioPlayer && window.StickyAudioPlayer.show) {
    //console.log('🎵 Using direct API call');
    //console.log('🎵 Calling StickyAudioPlayer.show with:', trackData);
    window.StickyAudioPlayer.show(trackData);
    if (audioElement) {
      window.StickyAudioPlayer.connect(audioElement);
    }
  } else {
    //console.log('🎵 StickyAudioPlayer not available, using event');
  }
 
  // Also dispatch custom event for sticky player
  const event = new CustomEvent('trackChanged', {
    detail: { trackData, audioElement }
  });
  document.dispatchEvent(event);
  //console.log('🎵 Custom event dispatched');
};

// Function to notify sticky player about play/pause
const notifyPlayPause = (isPlaying) => {
  //console.log('🎵 Notifying play/pause:', isPlaying);
 
  // Try direct API call first
  if (window.StickyAudioPlayer) {
    window.StickyAudioPlayer.updatePlayPause(isPlaying);
  }
 
  // Also dispatch custom event
  const event = new CustomEvent('trackPlayPause', {
    detail: { isPlaying }
  });
  document.dispatchEvent(event);
};

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
  if (activeRow) {
    const audioElement = activeRow.querySelector('audio');
    if (audioElement) {
      audioElement.pause();
    }
    }
  });

  // Sticky Audio Player JavaScript
  (() => {
    const stickyPlayer = document.getElementById('sticky-player');
    const albumArt = document.getElementById('sap-album-art');
    const title = document.getElementById('sap-title');
    const currentTime = document.getElementById('sap-current-time');
    const totalTime = document.getElementById('sap-total-time');
    const progressFill = document.getElementById('sap-progress-fill');
    const progressThumb = document.getElementById('sap-progress-thumb');
    const playPauseBtn = document.getElementById('sap-play-pause');
    const prevBtn = document.getElementById('sap-prev');
    const nextBtn = document.getElementById('sap-next');
    const cartBtn = document.getElementById('sap-cart');
    const closeBtn = document.getElementById('sap-close');
    const progressBar = document.querySelector('.sap__progress-bar');

    let currentTrack = null;
    let audioElement = null;
    let isPlaying = false;
    let trackList = [];
    let currentTrackIndex = -1;

    // Move sticky player to body to avoid transform context issues
    if (stickyPlayer && stickyPlayer.parentNode !== document.body) {
      document.body.appendChild(stickyPlayer);
      //console.log('🎵 Moved sticky player to body from music store');
    }

    // Initialize player as hidden
    stickyPlayer.classList.add('idle');
    document.body.classList.remove('player-active');
   
    // Force positioning to viewport bottom
    const forceBottomPosition = () => {
      stickyPlayer.style.position = 'fixed';
      stickyPlayer.style.bottom = '0';
      stickyPlayer.style.left = '0';
      stickyPlayer.style.right = '0';
      stickyPlayer.style.width = '100%';
      stickyPlayer.style.zIndex = '99999';
      stickyPlayer.style.margin = '0';
     
      // Don't override transform - let CSS classes handle it
    };
   
    // Apply positioning immediately
    forceBottomPosition();
   
    // Reapply on window events
    window.addEventListener('load', forceBottomPosition);
    window.addEventListener('resize', forceBottomPosition);
    window.addEventListener('scroll', forceBottomPosition);

    // Format time helper - returns mm:ss format
    const formatTime = (seconds) => {
      if (!isFinite(seconds) || seconds < 0) return '00:00';
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60).toString().padStart(2, '0');
      const mm = m.toString().padStart(2, '0');
      return `${mm}:${s}`;
    };

    // Update progress bar
    const updateProgress = () => {
      if (!audioElement || !isFinite(audioElement.duration)) return;
     
      const progress = (audioElement.currentTime / audioElement.duration) * 100;
      progressFill.style.width = `${progress}%`;
      progressThumb.style.left = `${progress}%`;
      currentTime.textContent = formatTime(audioElement.currentTime);
     
      // Also update the track list item's progress bar if it exists
      if (currentTrack && currentTrack.element) {
        const trackElement = currentTrack.element;
        const seek = trackElement.querySelector('.tli__seek');
        const seekFill = trackElement.querySelector('.tli__seek-fill');
        const current = trackElement.querySelector('.tli__current');
        const currentMobile = trackElement.querySelector('.tli__current-mobile');
       
        if (seek && audioElement.duration && isFinite(audioElement.duration)) {
          const progressValue = (audioElement.currentTime / audioElement.duration) * 1000;
          seek.value = Math.round(progressValue);
          const fillWidth = (audioElement.currentTime / audioElement.duration) * 100;
          seek.style.setProperty('--value', `${fillWidth}%`);
          if (seekFill) {
            seekFill.style.width = `${fillWidth}%`;
          }
        }
       
        // Update time display (remaining time countdown)
        if (current && audioElement.duration && isFinite(audioElement.duration)) {
          const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
          const m = Math.floor(remaining / 60);
          const s = Math.floor(remaining % 60).toString().padStart(2, '0');
          current.textContent = `${m}:${s}`;
        }
        if (currentMobile && audioElement.duration && isFinite(audioElement.duration)) {
          const remaining = Math.max(0, audioElement.duration - audioElement.currentTime);
          const m = Math.floor(remaining / 60);
          const s = Math.floor(remaining % 60).toString().padStart(2, '0');
          currentMobile.textContent = `${m}:${s}`;
        }
      }
    };

    // Update play/pause button
    const updatePlayPause = (playing) => {
      isPlaying = playing;
     
      // Update main play/pause button using class toggle
      if (playing) {
        playPauseBtn.classList.add('playing');
        // Ensure player stays in playing state
        stickyPlayer.classList.remove('idle');
        stickyPlayer.classList.add('playing');
      } else {
        playPauseBtn.classList.remove('playing');
        // If no track is loaded, return to idle state
        if (!currentTrack) {
          stickyPlayer.classList.remove('playing');
          stickyPlayer.classList.add('idle');
        }
      }
     
      // Also update the track list item's icon if it exists
      if (currentTrack && currentTrack.element) {
        const trackElement = currentTrack.element;
        if (playing) {
          trackElement.classList.add('playing');
          // Use setPlayIcon if available in scope, otherwise update manually
          const playIcon = trackElement.querySelector('.icon-play');
          const pauseIcon = trackElement.querySelector('.icon-pause');
          if (playIcon) playIcon.style.display = 'none';
          if (pauseIcon) pauseIcon.style.display = 'block';
          trackElement.classList.add('showing-pause');
        } else {
          trackElement.classList.remove('playing');
          trackElement.classList.remove('showing-pause');
          const playIcon = trackElement.querySelector('.icon-play');
          const pauseIcon = trackElement.querySelector('.icon-pause');
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
        }
      }
    };

    // Show player with track data
    const showPlayer = (trackData) => {
      //console.log('🎵 Showing player for track:', trackData);
      //console.log('🎵 Track data type:', typeof trackData);
      //console.log('🎵 Track data keys:', trackData ? Object.keys(trackData) : 'null');
     
      if (!trackData) {
        console.error('🎵 No track data provided to showPlayer');
        return;
      }
     
      currentTrack = trackData;
     
      // Update track info with proper fallbacks
      if (trackData.albumArt) {
        albumArt.src = trackData.albumArt;
        albumArt.alt = trackData.title;
      }
     
      // Ensure we have proper track information with multiple fallbacks
      let displayTitle = 'No track selected';
     
      if (trackData.title && trackData.title.trim()) {
        displayTitle = trackData.title.trim();
      } else if (currentTrack && currentTrack.title && currentTrack.title.trim()) {
        displayTitle = currentTrack.title.trim();
      }
     
      title.textContent = displayTitle;
     
      //console.log('🎵 Final display values:', {
      //   title: displayTitle,
      //   albumArt: trackData.albumArt,
      //   originalTitle: trackData.title
      // });
     
      // Update current track index if we have a track list
      if (trackList.length > 0) {
        const trackIndex = trackList.findIndex(track => track.title === trackData.title);
        if (trackIndex !== -1) {
          currentTrackIndex = trackIndex;
          //console.log('🎵 Updated current track index to:', currentTrackIndex);
        }
      }
     
      // Update total time from trackData if available
      if (trackData.duration && trackData.duration > 0) {
        totalTime.textContent = formatTime(trackData.duration);
      }
     
      // Show the player and add body class for spacing
      stickyPlayer.classList.remove('idle');
      stickyPlayer.classList.add('playing');
      document.body.classList.add('player-active');
    };

    // Hide player
    const hidePlayer = () => {
      stickyPlayer.classList.remove('playing');
      stickyPlayer.classList.add('idle');
      document.body.classList.remove('player-active');
      currentTrack = null;
      audioElement = null;
      isPlaying = false;
    };

    // Function to update total time display
    const updateTotalTime = (audio) => {
      if (audio && audio.duration && isFinite(audio.duration) && audio.duration > 0) {
        totalTime.textContent = formatTime(audio.duration);
        return true; // Duration updated
      }
      return false; // Duration not available yet
    };
   
    // Connect to audio element
    // Note: This connects sticky player to the audio element without interfering
    // with existing event listeners in music store or selected media sections.
    // The audio events (play/pause) will automatically trigger handlers in both sections.
    const connectToAudio = (audio) => {
      //console.log('🎵 Connecting to audio element:', audio);
     
      // Disconnect from previous audio element if any
      if (audioElement && audioElement !== audio) {
        // Remove our listeners from previous audio (if needed)
        // Note: We don't remove other listeners as they're needed by their sections
      }
     
      audioElement = audio;
     
      // Set up audio event listeners for sticky player
      // These are in addition to existing listeners, not replacing them
      audio.addEventListener('timeupdate', updateProgress);
      audio.addEventListener('play', () => {
        updatePlayPause(true);
        // Audio play event will also trigger handlers in music store/selected media
        // The handlers in those sections will update their UI automatically
        //console.log('🎵 Sticky player - Audio play event fired, sections should update automatically');
      });
      audio.addEventListener('pause', () => {
        updatePlayPause(false);
        // Audio pause event will also trigger handlers in music store/selected media
        // The handlers in those sections will update their UI automatically
        //console.log('🎵 Sticky player - Audio pause event fired, sections should update automatically');
      });
      audio.addEventListener('ended', () => {
        updatePlayPause(false);
        hidePlayer();
      });
     
      // Listen for loadedmetadata event to get duration when available
      audio.addEventListener('loadedmetadata', () => {
        //console.log('🎵 Sticky player - loadedmetadata, duration:', audio.duration);
        updateTotalTime(audio);
      });
     
      // Listen for durationchange event
      audio.addEventListener('durationchange', () => {
        //console.log('🎵 Sticky player - durationchange, duration:', audio.duration);
        updateTotalTime(audio);
      });
     
      // Try to update total time immediately if available
      if (!updateTotalTime(audio)) {
        // If duration not available, check periodically (up to 5 seconds)
        let durationCheckAttempts = 0;
        const maxDurationChecks = 50; // 5 seconds (50 * 100ms)
        const checkDuration = () => {
          if (updateTotalTime(audio) || durationCheckAttempts >= maxDurationChecks) {
            return; // Stop checking
          }
          durationCheckAttempts++;
          setTimeout(checkDuration, 100);
        };
        setTimeout(checkDuration, 100);
      }
    };

    // Set track list from music library
    const setTrackList = (tracks) => {
      //console.log('🎵 Setting track list:', tracks);
      trackList = tracks;
     
      // Find current track index
      if (currentTrack) {
        currentTrackIndex = trackList.findIndex(track =>
          track.title === currentTrack.title
        );
        if (currentTrackIndex === -1) {
          currentTrackIndex = 0;
        }
      } else {
        currentTrackIndex = 0;
      }
     
      //console.log('🎵 Current track index set to:', currentTrackIndex);
    };

    // Play next track
      const playNextTrack = () => {
        // Check if current track is from cart drawer
        const isFromCartDrawer = currentTrack && currentTrack.element && 
                                 (currentTrack.element.classList.contains('cart-item-card') ||
                                  currentTrack.element.closest('.cart-item-card') ||
                                  currentTrack.element.closest('cart-drawer-component'));
        
        if (isFromCartDrawer) {
          // Navigate through cart items
          const cartWrapper = document.querySelector('.cart-items__wrapper');
          if (!cartWrapper) return;
          
          const cartItems = Array.from(cartWrapper.querySelectorAll('.cart-item-card[data-product-osaria-audio-data]'));
          if (cartItems.length === 0) return;
          
          // Find current cart item index
          const currentCartItem = currentTrack.element.classList.contains('cart-item-card') 
            ? currentTrack.element 
            : currentTrack.element.closest('.cart-item-card');
          
          if (!currentCartItem) return;
          
          const currentCartIndex = cartItems.indexOf(currentCartItem);
          if (currentCartIndex === -1) return;
          
          // Stop current track
          if (audioElement && !audioElement.paused) {
            audioElement.pause();
          }
          if (currentCartItem) {
            currentCartItem.classList.remove('playing');
            const playIcon = currentCartItem.querySelector('.icon-play');
            const pauseIcon = currentCartItem.querySelector('.icon-pause');
            if (playIcon) playIcon.style.display = 'block';
            if (pauseIcon) pauseIcon.style.display = 'none';
          }
          
          // Get next cart item (wrap around)
          const nextCartIndex = (currentCartIndex + 1) % cartItems.length;
          const nextCartItem = cartItems[nextCartIndex];
          
          // Click the play button on the next cart item
          // Wait a bit to ensure current track is fully stopped and audio is ready
          setTimeout(() => {
            const nextPlayButton = nextCartItem.querySelector('.cart-item-card__playbtn');
            if (nextPlayButton && !nextPlayButton.disabled) {
              // Ensure Osaria player is initialized if needed
              const osariaPlayer = nextCartItem.querySelector('.osaria-player-custom-product-view');
              if (osariaPlayer) {
                // Trigger Osaria initialization if not already done
                osariaPlayer.dispatchEvent(new CustomEvent('osaria:init', { 
                  bubbles: true,
                  detail: { element: osariaPlayer, productId: nextCartItem.dataset.productId } 
                }));
              }
              nextPlayButton.click();
            } else if (nextPlayButton && nextPlayButton.disabled) {
              // If disabled, wait a bit more and try again
              setTimeout(() => {
                if (nextPlayButton && !nextPlayButton.disabled) {
                  nextPlayButton.click();
                }
              }, 300);
            }
          }, 150);
          return;
        }
        
        // Normal behavior: navigate through trackList
        if (trackList.length === 0) return;
       
        // Stop current track and update its UI
        if (currentTrack && currentTrack.element) {
          const currentTrackElement = currentTrack.element;
          const currentAudio = currentTrackElement.querySelector('audio');
         
          // Stop the audio
          if (currentAudio && !currentAudio.paused) {
            currentAudio.pause();
          }
         
          // Clear progress bar
          const seek = currentTrackElement.querySelector('.tli__seek');
          const seekFill = currentTrackElement.querySelector('.tli__seek-fill');
          if (seek) {
            seek.value = 0;
            seek.style.setProperty('--value', '0%');
          }
          if (seekFill) {
            seekFill.style.width = '0%';
          }
         
          // Update UI to show it's paused
          currentTrackElement.classList.remove('playing');
          currentTrackElement.classList.remove('showing-pause');
          const playIcon = currentTrackElement.querySelector('.icon-play');
          const pauseIcon = currentTrackElement.querySelector('.icon-pause');
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
        }
       
        // Also stop the sticky player's audio element if it exists
        if (audioElement && !audioElement.paused) {
          audioElement.pause();
        }
       
        currentTrackIndex = (currentTrackIndex + 1) % trackList.length;
        const nextTrack = trackList[currentTrackIndex];
       
        //console.log('🎵 Playing next track:', nextTrack);
       
        // Find the corresponding track element and trigger play
        const trackElement = nextTrack.element;
        if (trackElement) {
          const playButton = trackElement.querySelector('.tli__playbtn');
          if (playButton) {
            playButton.click();
          }
        }
      };

      // Play previous track
      const playPreviousTrack = () => {
        // Check if current track is from cart drawer
        const isFromCartDrawer = currentTrack && currentTrack.element && 
                                 (currentTrack.element.classList.contains('cart-item-card') ||
                                  currentTrack.element.closest('.cart-item-card') ||
                                  currentTrack.element.closest('cart-drawer-component'));
        
        if (isFromCartDrawer) {
          // Navigate through cart items
          const cartWrapper = document.querySelector('.cart-items__wrapper');
          if (!cartWrapper) return;
          
          const cartItems = Array.from(cartWrapper.querySelectorAll('.cart-item-card[data-product-osaria-audio-data]'));
          if (cartItems.length === 0) return;
          
          // Find current cart item index
          const currentCartItem = currentTrack.element.classList.contains('cart-item-card') 
            ? currentTrack.element 
            : currentTrack.element.closest('.cart-item-card');
          
          if (!currentCartItem) return;
          
          const currentCartIndex = cartItems.indexOf(currentCartItem);
          if (currentCartIndex === -1) return;
          
          // Stop current track
          if (audioElement && !audioElement.paused) {
            audioElement.pause();
          }
          if (currentCartItem) {
            currentCartItem.classList.remove('playing');
            const playIcon = currentCartItem.querySelector('.icon-play');
            const pauseIcon = currentCartItem.querySelector('.icon-pause');
            if (playIcon) playIcon.style.display = 'block';
            if (pauseIcon) pauseIcon.style.display = 'none';
          }
          
          // Get previous cart item (wrap around - last item if at first)
          const prevCartIndex = currentCartIndex === 0 ? cartItems.length - 1 : currentCartIndex - 1;
          const prevCartItem = cartItems[prevCartIndex];
          
          // Click the play button on the previous cart item
          // Wait a bit to ensure current track is fully stopped and audio is ready
          setTimeout(() => {
            const prevPlayButton = prevCartItem.querySelector('.cart-item-card__playbtn');
            if (prevPlayButton && !prevPlayButton.disabled) {
              // Ensure Osaria player is initialized if needed
              const osariaPlayer = prevCartItem.querySelector('.osaria-player-custom-product-view');
              if (osariaPlayer) {
                // Trigger Osaria initialization if not already done
                osariaPlayer.dispatchEvent(new CustomEvent('osaria:init', { 
                  bubbles: true,
                  detail: { element: osariaPlayer, productId: prevCartItem.dataset.productId } 
                }));
              }
              prevPlayButton.click();
            } else if (prevPlayButton && prevPlayButton.disabled) {
              // If disabled, wait a bit more and try again
              setTimeout(() => {
                if (prevPlayButton && !prevPlayButton.disabled) {
                  prevPlayButton.click();
                }
              }, 300);
            }
          }, 150);
          return;
        }
        
        // Normal behavior: navigate through trackList
        if (trackList.length === 0) return;
       
        // Stop current track and update its UI
        if (currentTrack && currentTrack.element) {
          const currentTrackElement = currentTrack.element;
          const currentAudio = currentTrackElement.querySelector('audio');
         
          // Stop the audio
          if (currentAudio && !currentAudio.paused) {
            currentAudio.pause();
          }
         
          // Clear progress bar
          const seek = currentTrackElement.querySelector('.tli__seek');
          const seekFill = currentTrackElement.querySelector('.tli__seek-fill');
          if (seek) {
            seek.value = 0;
            seek.style.setProperty('--value', '0%');
          }
          if (seekFill) {
            seekFill.style.width = '0%';
          }
         
          // Update UI to show it's paused
          currentTrackElement.classList.remove('playing');
          currentTrackElement.classList.remove('showing-pause');
          const playIcon = currentTrackElement.querySelector('.icon-play');
          const pauseIcon = currentTrackElement.querySelector('.icon-pause');
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
        }
       
        // Also stop the sticky player's audio element if it exists
        if (audioElement && !audioElement.paused) {
          audioElement.pause();
        }
       
        currentTrackIndex = currentTrackIndex === 0 ? trackList.length - 1 : currentTrackIndex - 1;
        const prevTrack = trackList[currentTrackIndex];
       
        //console.log('🎵 Playing previous track:', prevTrack);
       
        // Find the corresponding track element and trigger play
        const trackElement = prevTrack.element;
        if (trackElement) {
          const playButton = trackElement.querySelector('.tli__playbtn');
          if (playButton) {
            playButton.click();
          }
        }
      };

    // Event listeners
    playPauseBtn.addEventListener('click', () => {
      if (audioElement) {
        if (isPlaying) {
          audioElement.pause();
          // Dispatch immediate pause event to all sections
          const currentTrack = window.StickyAudioPlayer?.getCurrentTrack?.();
          const variantId = currentTrack?.element?.dataset?.variantId || currentTrack?.variantId;
          const productId = currentTrack?.element?.dataset?.productId || currentTrack?.productId;
          
          document.dispatchEvent(new CustomEvent('stickyPlayerPause', {
            bubbles: true,
            detail: { variantId, productId, source: 'stickyPlayer' }
          }));
        } else {
            audioElement.play();
            // Dispatch immediate play event to all sections
            const currentTrack = window.StickyAudioPlayer?.getCurrentTrack?.();
            const variantId = currentTrack?.element?.dataset?.variantId || currentTrack?.variantId;
            const productId = currentTrack?.element?.dataset?.productId || currentTrack?.productId;
            
            document.dispatchEvent(new CustomEvent('stickyPlayerPlay', {
              bubbles: true,
              detail: { variantId, productId, source: 'stickyPlayer' }
            }));
          }
      }
    });

    prevBtn.addEventListener('click', () => {
      playPreviousTrack();
    });

    nextBtn.addEventListener('click', () => {
      playNextTrack();
    });

    // Cart button - add/remove current track to/from cart
    cartBtn.addEventListener('click', async () => {
      if (!currentTrack || !currentTrack.element) {
        console.warn('🎵 No current track to add to cart');
        return;
      }

      // Find the add to cart button in the track element
      const trackElement = currentTrack.element;
      // Try music store add button first
      let addBtn = trackElement.querySelector('.tli__add');
     
      // Selected media tracks don't have individual add buttons (they're added via form)
      // So only handle music store tracks
      if (!addBtn) {
        console.warn('🎵 No add button found in current track (selected media tracks are added via form)');
        return;
      }

      // Check if button is disabled
      if (addBtn.disabled) {
        return;
      }

      // Store original cart button content if not already stored
      if (!cartBtn.dataset.originalContent) {
        cartBtn.dataset.originalContent = cartBtn.innerHTML;
      }

      cartBtn.disabled = true;

      // Simulate click on the add button from the track
      addBtn.click();

      // Wait a bit for the cart operation to complete, then update sticky button
      setTimeout(async () => {
        await updateStickyCartButton();
        cartBtn.disabled = false;
      }, 500);
    });

    // Close button - hide the sticky player
    closeBtn.addEventListener('click', () => {
      if (audioElement) {
        audioElement.pause();
      }
      hidePlayer();
    });

    // Progress bar click
    progressBar.addEventListener('click', (e) => {
      if (!audioElement || !audioElement.duration) return;
     
      const rect = progressBar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const percentage = clickX / rect.width;
      const newTime = percentage * audioElement.duration;
     
      audioElement.currentTime = newTime;
    });

    // Function to check if a variant is in the cart (for sticky player)
    const isVariantInCartSticky = async (variantId) => {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        return cart.items.some(item => item.variant_id === variantId);
      } catch (error) {
        console.error('❌ Failed to check cart:', error);
        return false;
      }
    };

    // Function to update sticky player cart button based on current track
    const updateStickyCartButton = async () => {
      if (!currentTrack || !currentTrack.element) return;
     
      // Store original cart button content if not already stored
      if (!cartBtn.dataset.originalContent) {
        cartBtn.dataset.originalContent = cartBtn.innerHTML;
      }
     
      // Check if track is from cart drawer
      // The element should be the cart-item-card itself when playing from cart drawer
      const isCartItemCard = currentTrack.element.classList && 
                             currentTrack.element.classList.contains('cart-item-card');
      const cartItemCard = isCartItemCard 
        ? currentTrack.element 
        : (currentTrack.element.closest && currentTrack.element.closest('.cart-item-card'));
      const isFromCartDrawer = isCartItemCard || cartItemCard || 
                                (currentTrack.element.closest && 
                                 currentTrack.element.closest('.cart-items__wrapper'));
     
      if (isFromCartDrawer && cartItemCard) {
        // Track is from cart drawer - show tick and check if still in cart
        // Check if item is still in cart by checking if the cart item card still exists in DOM
        const cartWrapper = document.querySelector('.cart-items__wrapper');
        const isStillInCart = cartWrapper && cartWrapper.contains(cartItemCard);
        
        if (isStillInCart) {
          // Show tick icon - item is in cart
          cartBtn.innerHTML = `
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <path d="M5 13l4 4L19 7"/>
            </svg>
          `;
          cartBtn.classList.add('success');
        } else {
          // Item was removed from cart - show plus icon
          cartBtn.innerHTML = cartBtn.dataset.originalContent;
          cartBtn.classList.remove('success');
        }
        return;
      }
     
      // Track is from music store - use existing logic
      const addBtn = currentTrack.element.querySelector('.tli__add');
      if (!addBtn) return;
     
      const variantId = Number(addBtn.dataset.vid);
      if (!variantId) return;
     
      const isInCart = await isVariantInCartSticky(variantId);
      // if (isInCart) {
      //   cartBtn.innerHTML = `
      //     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      //       <path d="M5 13l4 4L19 7"/>
      //     </svg>
      //   `;
      //   cartBtn.classList.add('success');
      // } else {
      //   cartBtn.innerHTML = cartBtn.dataset.originalContent;
      //   cartBtn.classList.remove('success');
      // }
    };

    // Expose functions globally for communication with music library
    window.StickyAudioPlayer = {
      show: (trackData) => {
        //console.log('🎵 Sticky player - direct API show called with:', trackData);
        //console.log('🎵 Sticky player - trackData.title:', trackData?.title);
        showPlayer(trackData);
        // Update cart button when track is shown
        setTimeout(updateStickyCartButton, 100);
      },
      hide: hidePlayer,
      connect: connectToAudio,
      updateProgress: updateProgress,
      updatePlayPause: updatePlayPause,
      setTrackList: setTrackList,
      playNext: playNextTrack,
      playPrevious: playPreviousTrack,
      getCurrentTrack: () => currentTrack,
      updateCartButton: updateStickyCartButton
    };

    // Listen for track changes from music library sections
    document.addEventListener('trackChanged', (e) => {
      //console.log('🎵 Sticky player received trackChanged event:', e.detail);
      const { trackData, audioElement: audio } = e.detail;
      //console.log('🎵 Sticky player - received trackData:', trackData);
      //console.log('🎵 Sticky player - trackData.title:', trackData?.title);
      showPlayer(trackData);
      if (audio) {
        connectToAudio(audio);
      }
      // Update cart button when track changes
      setTimeout(updateStickyCartButton, 100);
    });

    // Listen for play/pause events
    document.addEventListener('trackPlayPause', (e) => {
      //console.log('🎵 Sticky player received trackPlayPause event:', e.detail);
      const { isPlaying: playing } = e.detail;
      updatePlayPause(playing);
    });
   
    // Listen for unified play events from both music store and selected media
    document.addEventListener('unifiedTrackPlay', (e) => {
      const { trackData, source } = e.detail;
      //console.log('🎵 Sticky player received unifiedTrackPlay event from:', source, trackData);
     
      // Only update sticky player if trackData is provided
      if (trackData) {
        showPlayer(trackData);
       
        // Update total time from trackData if available (before connecting to audio)
        if (trackData.duration && trackData.duration > 0) {
          totalTime.textContent = formatTime(trackData.duration);
        }
       
        // Try to find and connect to the audio element
        const findAndConnectAudio = (trackElement) => {
          if (!trackElement) return;
         
          let audio = trackElement.querySelector('audio');
          if (audio) {
            connectToAudio(audio);
            // Check if audio is already playing
            if (!audio.paused) {
              updatePlayPause(true);
            }
          } else {
            // If not found immediately, wait a bit for Osaria to create it
            let attempts = 0;
            const maxAttempts = 20; // 2 seconds (20 * 100ms)
            const checkForAudio = () => {
              audio = trackElement.querySelector('audio');
              if (audio) {
                connectToAudio(audio);
                // Check if audio is playing
                if (!audio.paused) {
                  updatePlayPause(true);
                }
              } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkForAudio, 100);
              }
            };
            setTimeout(checkForAudio, 100);
          }
        };
       
        if (source === 'musicLibrary' || source === 'selectedMedia') {
          // Find audio in the track element
          const trackElement = trackData.element;
          findAndConnectAudio(trackElement);
        }
       
        // Update cart button when track changes
        setTimeout(updateStickyCartButton, 100);
      }
    });
   
    // Listen for unified pause events from both sections
    document.addEventListener('unifiedTrackPause', (e) => {
      const { source } = e.detail;
      //console.log('🎵 Sticky player received unifiedTrackPause event from:', source);
      updatePlayPause(false);
    });

    // Listen for cart updates to refresh sticky player button
    document.addEventListener('cart:updated', () => {
      //console.log('🛒 Sticky player - cart updated, refreshing cart button');
      updateStickyCartButton();
    });
   
    window.addEventListener('cartUpdated', () => {
      //console.log('🛒 Sticky player - cart updated (custom event), refreshing cart button');
      updateStickyCartButton();
    });
    
    // Listen for cart drawer content refresh (when items are added/removed)
    document.addEventListener('cart:content:refreshed', () => {
      //console.log('🛒 Sticky player - cart content refreshed, checking cart button state');
      updateStickyCartButton();
    });
    
    // Listen for cart change events
    document.addEventListener('cart:change', () => {
      //console.log('🛒 Sticky player - cart changed, refreshing cart button');
      updateStickyCartButton();
    });

    //console.log('🎵 Sticky Audio Player initialized');
  })();
 
  // Listen for unified play events from selected media
  document.addEventListener('unifiedTrackPlay', (e) => {
    const { variantId, productId, source } = e.detail;
    //console.log('🎵 Music Library - Received unifiedTrackPlay event', {
    //   variantId: variantId,
    //   productId: productId,
    //   source: source
    // });
   
    if (source === 'musicLibrary') return; // Ignore our own events
   
    // If selected media is playing, pause any playing track in music store
    if (source === 'selectedMedia') {
      // Clean up any existing selected media sync listener
      if (selectedMediaSyncListener) {
        const selectedMediaTrack = document.querySelector('.sm-track-item.playing');
        if (selectedMediaTrack) {
          const selectedAudio = selectedMediaTrack.querySelector('audio');
          if (selectedAudio) {
            selectedAudio.removeEventListener('timeupdate', selectedMediaSyncListener);
          }
        }
        selectedMediaSyncListener = null;
      }
     
      // Pause any currently playing track in music store
      if (activeRow) {
        const prevAudio = activeRow.querySelector('audio');
        if (prevAudio) {
          prevAudio.pause();
          prevAudio.currentTime = 0;
        }
        setPlayIcon(activeRow, false);
        activeRow.classList.remove('playing');
       
        // Reset progress bar and time
        const seek = activeRow.querySelector('.tli__seek');
        const current = activeRow.querySelector('.tli__current');
        const currentMobile = activeRow.querySelector('.tli__current-mobile');
        if (seek) {
          seek.value = 0;
          seek.style.setProperty('--value', '0%');
        }
        const seekFill = activeRow.querySelector('.tli__seek-fill');
        if (seekFill) seekFill.style.width = '0%';
       
        // Reset to total duration
        if (prevAudio && prevAudio.duration && isFinite(prevAudio.duration)) {
          const totalDuration = fmt(prevAudio.duration);
          if (current) {
            current.textContent = totalDuration;
            current.classList.remove('loading');
          }
          if (currentMobile) {
            currentMobile.textContent = totalDuration;
          }
        } else {
          const totalElement = activeRow.querySelector('.tli__total');
          if (current) {
            if (totalElement) {
              current.textContent = totalElement.textContent.trim();
            } else {
              current.textContent = '0:00';
            }
            current.classList.remove('loading');
          }
          if (currentMobile) {
            if (totalElement) {
              currentMobile.textContent = totalElement.textContent.trim();
            } else {
              currentMobile.textContent = '0:00';
            }
          }
        }
       
        activeRow = null;
        activePlayer = null;
      }
     
      // Update UI to show matching track is playing (if it exists in music store)
      if (variantId) {
        root.querySelectorAll('.track-list-item').forEach(row => {
          const rowVariantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
          if (rowVariantId === variantId) {
            // Update UI to show this track is playing (Selected Media is playing it)
            resetAllPlayIcons(row);
            setPlayIcon(row, true);
            row.classList.add('playing');
           
            // Set as active row so seek bar updates
            activeRow = row;
           
            // Find the audio element in selected media and sync seek bar updates
            // Audio element might not be ready yet, so we need to wait for it
            // Try to find by variant ID first, then by playing class as fallback
            let selectedMediaTrack = document.querySelector(`.sm-track-item[data-variant-id="${variantId}"]`);
            if (!selectedMediaTrack) {
              // Fallback: find by playing class
              selectedMediaTrack = document.querySelector('.sm-track-item.playing');
            }
            if (selectedMediaTrack) {
              //console.log('🎵 Found selected media track for sync:', selectedMediaTrack);
              // Clean up any existing listener first
              if (selectedMediaSyncListener) {
                const prevSelectedMediaTrack = document.querySelector('.sm-track-item.playing');
                if (prevSelectedMediaTrack) {
                  const prevSelectedAudio = prevSelectedMediaTrack.querySelector('audio');
                  if (prevSelectedAudio) {
                    prevSelectedAudio.removeEventListener('timeupdate', selectedMediaSyncListener);
                  }
                }
                selectedMediaSyncListener = null;
              }
             
              // Function to set up seek bar sync
              const setupSeekBarSync = () => {
                const selectedAudio = selectedMediaTrack.querySelector('audio');
                //console.log('🎵 Checking for selected audio:', {
                //   hasSelectedMediaTrack: !!selectedMediaTrack,
                //   hasSelectedAudio: !!selectedAudio,
                //   activeRow: activeRow === row,
                //   audioDuration: selectedAudio ? selectedAudio.duration : 'N/A'
                // });
               
                if (selectedAudio && activeRow === row) {
                  //console.log('🎵 Setting up seek bar sync for selected media playback');
                 
                  // Listen to selected media audio timeupdate and update music library seek bar
                  selectedMediaSyncListener = () => {
                    // Always update if this is the active row (don't check paused state)
                    if (activeRow === row && selectedAudio) {
                      const current = row.querySelector('.tli__current');
                      const currentMobile = row.querySelector('.tli__current-mobile');
                      const seek = row.querySelector('.tli__seek');
                     
                      // Check if elements exist
                      if (!current && !currentMobile && !seek) {
                        console.warn('⚠️ No UI elements found for seek bar sync');
                        return;
                      }
                     
                      if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
                        // Update time displays (show remaining time)
                        const remaining = Math.max(0, selectedAudio.duration - selectedAudio.currentTime);
                        if (current) {
                          current.textContent = fmt(remaining);
                          current.classList.remove('loading');
                        }
                        if (currentMobile) {
                          currentMobile.textContent = fmt(remaining);
                        }
                       
                        // Update seek bar
                        if (seek) {
                          // Enable seek bar
                          seek.disabled = false;
                         
                          const progress = (selectedAudio.currentTime / selectedAudio.duration) * 1000;
                          seek.value = Math.round(progress);
                          const fillWidth = (selectedAudio.currentTime / selectedAudio.duration) * 100;
                          seek.style.setProperty('--value', `${fillWidth}%`);
                         
                          const seekFill = row.querySelector('.tli__seek-fill');
                          if (seekFill) {
                            seekFill.style.width = `${fillWidth}%`;
                          }
                        }
                      } else {
                        // If duration not available yet, wait for it
                        if (current) {
                          current.textContent = 'Loading...';
                          current.classList.add('loading');
                        }
                        if (currentMobile) {
                          currentMobile.textContent = 'Loading...';
                        }
                      }
                    } else {
                      // Debug: log why listener isn't updating
                      if (activeRow !== row) {
                        //console.log('⚠️ Active row mismatch:', {
                        //   activeRow: activeRow ? activeRow.querySelector('.tli__title')?.textContent : 'null',
                        //   expectedRow: row.querySelector('.tli__title')?.textContent
                        // });
                      }
                      if (!selectedAudio) {
                        console.warn('⚠️ Selected audio element not found');
                      }
                    }
                  };
                 
                  // Add new listener
                  selectedAudio.addEventListener('timeupdate', selectedMediaSyncListener);
                 
                  // Also listen to loadedmetadata to get initial duration
                  const handleMetadata = () => {
                    if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
                      //console.log('✅ Selected audio metadata loaded, duration:', selectedAudio.duration);
                      // Update immediately with initial state
                      selectedMediaSyncListener();
                    }
                  };
                  selectedAudio.addEventListener('loadedmetadata', handleMetadata, { once: true });
                 
                  // Also update immediately if duration is already available
                  if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
                    selectedMediaSyncListener();
                  } else {
                    // Wait a bit for metadata to load
                    setTimeout(() => {
                      if (selectedAudio.duration && isFinite(selectedAudio.duration)) {
                        selectedMediaSyncListener();
                      }
                    }, 100);
                  }
                 
                  //console.log('✅ Seek bar sync listener attached');
                  return true; // Successfully set up
                }
                return false; // Audio not ready yet
              };
             
              // Try to set up immediately
              if (!setupSeekBarSync()) {
                //console.log('⏳ Selected audio not ready, starting polling...');
                // If audio not ready, wait for it (check periodically)
                let attempts = 0;
                const maxAttempts = 100; // Try for up to 10 seconds (100 * 100ms)
                const checkInterval = setInterval(() => {
                  attempts++;
                  if (setupSeekBarSync()) {
                    //console.log('✅ Seek bar sync set up after', attempts, 'attempts');
                    clearInterval(checkInterval);
                  } else if (attempts >= maxAttempts) {
                    console.warn('⚠️ Failed to set up seek bar sync after', maxAttempts, 'attempts');
                    clearInterval(checkInterval);
                  } else if (attempts % 10 === 0) {
                    // Log every 10 attempts
                    //console.log('⏳ Still waiting for selected audio element...', attempts, '/', maxAttempts);
                  }
                }, 100);
              } else {
                //console.log('✅ Seek bar sync set up immediately');
              }
            }
          } else {
            // Make sure other tracks show play icon
            setPlayIcon(row, false);
            row.classList.remove('playing');
          }
        });
      }
     
      return; // Don't process further
    }
   
    if (!variantId) {
      console.warn('🎵 Music Library - No variantId in event');
      return;
    }
   
    // Find matching track in music library by comparing variantId as number
    let matchingRow = null;
    root.querySelectorAll('.track-list-item').forEach(row => {
      const rowVariantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
      if (rowVariantId === variantId) {
        matchingRow = row;
        //console.log('🎵 Music Library - Found matching track', {
        //   variantId: rowVariantId,
        //   title: row.querySelector('.tli__title')?.textContent
        // });
      }
    });
   
    if (!matchingRow) {
      console.warn('🎵 Music Library - No matching track found for variantId:', variantId);
      return;
    }
   
    if (matchingRow) {
      //console.log('🎵 Music Library - Received play event from Selected Media, updating UI');
     
      // Stop current track if playing (only if different track)
      if (activeRow && activeRow !== matchingRow) {
        const prevAudio = activeRow.querySelector('audio');
        if (prevAudio) {
          prevAudio.pause();
        }
        setPlayIcon(activeRow, false);
        activeRow.classList.remove('playing');
      }
     
      // Update UI to show this track is playing (Selected Media is playing it)
      if (!matchingRow.classList.contains('playing')) {
        resetAllPlayIcons(matchingRow);
        setPlayIcon(matchingRow, true);
        matchingRow.classList.add('playing');
        activeRow = matchingRow;
        //console.log('🎵 Music Library - UI updated to show playing state');
      } else {
        //console.log('🎵 Music Library - Track already showing as playing');
      }
    } else {
      //console.log('🎵 Music Library - Track not found in music library');
    }
  });
 
  // Listen for unified pause events from selected media
  document.addEventListener('unifiedTrackPause', (e) => {
    const { variantId, productId, source } = e.detail;
    if (source === 'musicLibrary') return; // Ignore our own events
   
    // Clean up selected media sync listener when paused
    if (source === 'selectedMedia' && selectedMediaSyncListener) {
      const selectedMediaTrack = document.querySelector('.sm-track-item.playing');
      if (selectedMediaTrack) {
        const selectedAudio = selectedMediaTrack.querySelector('audio');
        if (selectedAudio) {
          selectedAudio.removeEventListener('timeupdate', selectedMediaSyncListener);
        }
      }
      selectedMediaSyncListener = null;
    }
   
    // If no variantId specified, pause ALL playing tracks in music store
    if (!variantId) {
      if (activeRow) {
        const audio = activeRow.querySelector('audio');
        if (audio && !audio.paused) {
          audio.pause();
          audio.currentTime = 0;
        }
        setPlayIcon(activeRow, false);
        activeRow.classList.remove('playing');
       
        // Reset progress bar and time
        const seek = activeRow.querySelector('.tli__seek');
        const current = activeRow.querySelector('.tli__current');
        const currentMobile = activeRow.querySelector('.tli__current-mobile');
        if (seek) {
          seek.value = 0;
          seek.style.setProperty('--value', '0%');
        }
        const seekFill = activeRow.querySelector('.tli__seek-fill');
        if (seekFill) seekFill.style.width = '0%';
       
        // Reset to total duration
        if (audio && audio.duration && isFinite(audio.duration)) {
          const totalDuration = fmt(audio.duration);
          if (current) {
            current.textContent = totalDuration;
            current.classList.remove('loading');
          }
          if (currentMobile) {
            currentMobile.textContent = totalDuration;
          }
        } else {
          const totalElement = activeRow.querySelector('.tli__total');
          if (current) {
            if (totalElement) {
              current.textContent = totalElement.textContent.trim();
            } else {
              current.textContent = '0:00';
            }
            current.classList.remove('loading');
          }
          if (currentMobile) {
            if (totalElement) {
              currentMobile.textContent = totalElement.textContent.trim();
            } else {
              currentMobile.textContent = '0:00';
            }
          }
        }
       
        activeRow = null;
        activePlayer = null;
      }
      return;
    }
   
    // Find matching track in music library by comparing variantId as number
    let matchingRow = null;
    root.querySelectorAll('.track-list-item').forEach(row => {
      const rowVariantId = row.dataset.variantId ? Number(row.dataset.variantId) : null;
      if (rowVariantId === variantId) {
        matchingRow = row;
      }
    });
   
    if (matchingRow) {
      //console.log('🎵 Music Library - Received pause event from Selected Media, updating UI');
      if (matchingRow.classList.contains('playing')) {
        const audio = matchingRow.querySelector('audio');
        if (audio) {
          audio.pause();
        }
        matchingRow.classList.remove('playing');
        setPlayIcon(matchingRow, false);
        if (matchingRow === activeRow) {
          activeRow = null;
          activePlayer = null;
        }
      }
    }
  });
})();
document.addEventListener("click", function(e) {
  const btn = e.target.closest(".tli__add");
  if (!btn) return;

  const scrollY = window.scrollY;

  // lock scroll
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";

  setTimeout(function () {
    // unlock scroll
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, scrollY);
  }, 600);
});